import React from 'react';

export const DubizzleLogo = (props) => (
  <svg fill="none" viewBox="0 0 80 26" width={props.width || '80px'} height={props.height || '26px'} {...props}>
    <path
      fill="#212223"
      d="M52.709 15.16a7.864 7.864 0 0 0-1.088 1.31c-.434.564-.918 1.189-1.416 1.877a74.259 74.259 0 0 0-1.506 2.18c-.498.695-.955 1.42-1.369 2.168h5.508v2.193h-8.515v-1.666c.387-.593.696-1.236 1.139-1.933.442-.696.915-1.39 1.386-2.098.472-.707.946-1.396 1.41-2.033.464-.636.885-1.172 1.249-1.688h-4.925v-2.194h8.127v1.884zm10.062 0c-.26.311-.609.748-1.043 1.31a68.866 68.866 0 0 0-1.392 1.877c-.494.688-.994 1.433-1.496 2.18-.493.696-.945 1.42-1.354 2.168H62.9v2.193h-8.385v-1.666c.387-.593.683-1.236 1.125-1.933.441-.696.907-1.39 1.375-2.098.47-.707.94-1.396 1.401-2.033.462-.636.879-1.172 1.24-1.688h-4.883v-2.194h8v1.884h-.002zm4.773-7.305h-.024a6.456 6.456 0 0 0-2.674.75s-.011 0-.011.006v16.277h2.71V7.855zm1.51 11.277a7.297 7.297 0 0 1 .456-2.687 5.64 5.64 0 0 1 1.21-1.92 5.005 5.005 0 0 1 1.733-1.156 5.365 5.365 0 0 1 2-.388 4.782 4.782 0 0 1 3.739 1.488 6.435 6.435 0 0 1 1.343 4.441c0 .149 0 .286-.01.472a6.083 6.083 0 0 1-.035.47h-7.66a2.949 2.949 0 0 0 .987 2.194c.724.562 1.629.84 2.544.782.6.007 1.2-.051 1.787-.173a7.396 7.396 0 0 0 1.277-.374l.356 2.2c-.197.094-.4.172-.61.234-.291.09-.588.165-.888.223a13.37 13.37 0 0 1-1.076.167c-.391.045-.784.067-1.178.067a7.13 7.13 0 0 1-2.665-.455 4.957 4.957 0 0 1-1.865-1.266 5.181 5.181 0 0 1-1.089-1.913 7.784 7.784 0 0 1-.355-2.41m7.795-1.217a3.412 3.412 0 0 0-.155-1.043 2.53 2.53 0 0 0-.456-.862c-.2-.243-.45-.44-.733-.576a2.338 2.338 0 0 0-1.033-.21 2.407 2.407 0 0 0-1.089.234 2.485 2.485 0 0 0-.788.608 2.754 2.754 0 0 0-.5.86 4.015 4.015 0 0 0-.244.992h4.997l.001-.003zm-56.265-4.635v6.081c.08.92-.1 1.843-.517 2.665a2.1 2.1 0 0 1-1.879.8 2.072 2.072 0 0 1-1.862-.8 4.944 4.944 0 0 1-.516-2.665v-6.08h-2.708v6.503a9.03 9.03 0 0 0 .234 2.165c.142.618.417 1.198.805 1.7.401.49.92.87 1.508 1.105a7.21 7.21 0 0 0 2.554.396 7.225 7.225 0 0 0 2.557-.396 3.755 3.755 0 0 0 1.51-1.108 4.34 4.34 0 0 0 .795-1.698c.163-.71.24-1.436.229-2.164v-6.503h-2.71zM.46 19.091a7.288 7.288 0 0 0 .411 2.522 5.43 5.43 0 0 0 1.177 1.92c.52.538 1.154.954 1.854 1.218a6.779 6.779 0 0 0 2.466.422c.85.003 1.698-.064 2.537-.2.678-.102 1.348-.25 2.005-.444V7.858h-.017a6.47 6.47 0 0 0-2.677.75s-.015 0-.015.005v5.058a4.94 4.94 0 0 0-1.13-.444 5.221 5.221 0 0 0-1.491-.2 5.271 5.271 0 0 0-2.184.434 4.28 4.28 0 0 0-1.608 1.233 5.685 5.685 0 0 0-.985 1.92A8.41 8.41 0 0 0 .46 19.09zm2.754-.044c-.05-.95.186-1.895.677-2.71a2.404 2.404 0 0 1 2.144-1c.42-.003.84.065 1.238.2.326.11.638.259.928.445v6.685c-.24.06-.483.1-.728.122-.363.04-.727.06-1.092.056a2.869 2.869 0 0 1-2.327-1.01c-.602-.8-.9-1.788-.84-2.787v-.001zm32.39-2.435a5.684 5.684 0 0 0-.992-1.918 4.286 4.286 0 0 0-1.61-1.233 5.288 5.288 0 0 0-2.188-.435 5.21 5.21 0 0 0-1.49.2c-.393.101-.773.25-1.13.442v-5.81h-.035a6.435 6.435 0 0 0-2.668.75s-.006 0-.006.006v15.918c.659.193 1.33.342 2.01.444a15.6 15.6 0 0 0 2.543.2 6.78 6.78 0 0 0 2.465-.421c.7-.264 1.334-.68 1.855-1.218a5.44 5.44 0 0 0 1.177-1.92 7.29 7.29 0 0 0 .41-2.522 8.411 8.411 0 0 0-.347-2.477l.006-.006zm-3.254 5.217a2.869 2.869 0 0 1-2.331 1.01 9.08 9.08 0 0 1-1.089-.055 4.916 4.916 0 0 1-.733-.122v-6.68c.292-.186.605-.336.933-.445a3.84 3.84 0 0 1 1.25-.2 2.399 2.399 0 0 1 2.14 1c.491.815.727 1.759.676 2.709.058 1-.241 1.988-.845 2.787v-.004zm7.61-8.556a4.77 4.77 0 0 0-1.61.223 1.325 1.325 0 0 0-.684 1.136c0 .46.147 4.122.207 4.48.06.357.435.12.59 1.032.154.912.538 4.808.633 4.903a1.697 1.697 0 0 0 1.773 0c.094-.095.474-3.99.633-4.903.16-.912.53-.675.59-1.033.06-.357.204-4.02.203-4.479a1.332 1.332 0 0 0-.69-1.136 4.634 4.634 0 0 0-1.604-.223h-.065m1.651-2.05a1.545 1.545 0 1 1-3.09.004 1.545 1.545 0 0 1 3.09-.004z"
    />
    <path
      fill="#BB2025"
      fillRule="evenodd"
      d="M39.156 5.498c.811-.675 2.066-1.924 2.066-2.877a2.823 2.823 0 0 0-.776-2.113s.338 1.145-2.305 3.578c-2.276 2.094-1.955 4-1.947 4.126a4.192 4.192 0 0 0 1.412 3.102 3.42 3.42 0 0 1-.554-1.781c0-.194-.174-2.134 2.104-4.034m4.313 4.207c-.045-1.156-.415-1.25-.844-2.276-.609-1.652.43-3.06-.722-4.812-.353 2.233-2.017 2.882-3.23 4.313a3.515 3.515 0 0 0-.744 3.572 2.212 2.212 0 1 1 3.94 1.937 2.792 2.792 0 0 0 1.6-2.735"
      clipRule="evenodd"
    />
  </svg>
);

export const IconInfoOutline = (props) => (
  <svg viewBox="0 0 14 14" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <g fill={props.color || 'currentColor'}>
      <path d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0Zm0 12.813A5.813 5.813 0 0 1 7 1.187a5.813 5.813 0 0 1 0 11.626Z" />
      <path d="M6.25 4.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM7.375 6h-.75a.125.125 0 0 0-.125.125v4.25c0 .069.056.125.125.125h.75a.125.125 0 0 0 .125-.125v-4.25A.125.125 0 0 0 7.375 6Z" />
    </g>
  </svg>
);

export const IconGraphFilled = (props) => (
  <svg viewBox="0 0 14 15" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M3.938 8.375H1.312a.438.438 0 0 0-.437.438v4.374c0 .242.196.438.438.438h2.625a.438.438 0 0 0 .437-.438V8.814a.438.438 0 0 0-.438-.438ZM12.688 4.875h-2.626a.438.438 0 0 0-.437.438v7.875c0 .241.196.437.438.437h2.624a.438.438 0 0 0 .438-.438V5.314a.438.438 0 0 0-.438-.438ZM8.313 1.375H5.687a.438.438 0 0 0-.437.438v11.374c0 .242.196.438.438.438h2.625a.438.438 0 0 0 .437-.438V1.813a.438.438 0 0 0-.438-.438Z"
    />
  </svg>
);

export const IconEyeFilled = (props) => (
  <svg viewBox="0 0 20 14" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M10.001.477A10.285 10.285 0 0 0 .435 6.999a10.276 10.276 0 0 0 19.132 0A10.285 10.285 0 0 0 10.001.477zm0 10.87a4.348 4.348 0 1 1 0-8.696 4.348 4.348 0 0 1 0 8.696zm0-6.957a2.609 2.609 0 1 0 0 5.218 2.609 2.609 0 0 0 0-5.218z"
    />
  </svg>
);

export const IconRefund = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} {...props} viewBox="0 0 16 14">
    <path
      d="M3.5 0.25H12.5C14.15 0.25 15.5 1.6 15.5 3.25C15.5 4.525 14.75 5.575 13.625 6.025V3.25C13.625 2.95 13.475 2.65 13.325 2.425C13.175 2.2 12.8 2.125 12.5 2.125H3.5C3.2 2.125 2.9 2.275 2.675 2.425C2.45 2.575 2.375 2.95 2.375 3.25V6.025C1.25 5.575 0.5 4.525 0.5 3.25C0.5 1.6 1.85 0.25 3.5 0.25Z"
      fill="#E00000"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 3.25V12.25C12.5 13.075 11.825 13.75 11 13.75H5C4.175 13.75 3.5 13.075 3.5 12.25V3.25H12.5ZM6.875 8.875L7.4 9.4V6.25C7.4 5.95 7.625 5.65 8 5.65C8.375 5.65 8.6 5.875 8.6 6.25V9.4L9.125 8.875C9.35 8.65 9.725 8.65 9.95 8.875C10.175 9.1 10.175 9.475 9.95 9.7L8.975 10.675C8.45 11.2 7.625 11.2 7.1 10.675L6.125 9.7C5.9 9.475 5.9 9.1 6.125 8.875C6.35 8.65 6.65 8.65 6.875 8.875Z"
      fill="#E00000"
    />
  </svg>
);

export const IconPaidAmont = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} {...props} viewBox="0 0 16 16">
    <path
      d="M4.6665 14.6654C4.29984 14.6654 3.98595 14.5348 3.72484 14.2737C3.46373 14.0126 3.33317 13.6987 3.33317 13.332C3.33317 12.9654 3.46373 12.6515 3.72484 12.3904C3.98595 12.1293 4.29984 11.9987 4.6665 11.9987C5.03317 11.9987 5.34706 12.1293 5.60817 12.3904C5.86928 12.6515 5.99984 12.9654 5.99984 13.332C5.99984 13.6987 5.86928 14.0126 5.60817 14.2737C5.34706 14.5348 5.03317 14.6654 4.6665 14.6654ZM11.3332 14.6654C10.9665 14.6654 10.6526 14.5348 10.3915 14.2737C10.1304 14.0126 9.99984 13.6987 9.99984 13.332C9.99984 12.9654 10.1304 12.6515 10.3915 12.3904C10.6526 12.1293 10.9665 11.9987 11.3332 11.9987C11.6998 11.9987 12.0137 12.1293 12.2748 12.3904C12.5359 12.6515 12.6665 12.9654 12.6665 13.332C12.6665 13.6987 12.5359 14.0126 12.2748 14.2737C12.0137 14.5348 11.6998 14.6654 11.3332 14.6654ZM3.4665 2.66536H13.2998C13.5554 2.66536 13.7498 2.77925 13.8832 3.00703C14.0165 3.23481 14.0221 3.46536 13.8998 3.6987L11.5332 7.96536C11.4109 8.18759 11.2471 8.35981 11.0415 8.48203C10.8359 8.60425 10.6109 8.66536 10.3665 8.66536H5.39984L4.6665 9.9987H12.6665V11.332H4.6665C4.1665 11.332 3.78873 11.1126 3.53317 10.6737C3.27762 10.2348 3.2665 9.7987 3.49984 9.36536L4.39984 7.73203L1.99984 2.66536H0.666504V1.33203H2.83317L3.4665 2.66536Z"
      fill="#919395"
    />
  </svg>
);

export const IconAcceptOrder = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 12 12"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.415 3.484h1.226v.665a.21.21 0 0 0 .42 0v-.665h2.2v.665a.21.21 0 0 0 .42 0v-.665h1.227c.136 0 .249.103.261.238l.198 2.15a2.718 2.718 0 0 0-2.796 3.746H2.175a.498.498 0 0 1-.38-.167.498.498 0 0 1-.132-.394l.49-5.335a.262.262 0 0 1 .262-.238Zm1.226-.035V2.7c0-.418.171-.798.447-1.074a1.516 1.516 0 0 1 2.147 0c.276.276.447.656.447 1.074v.75h-.42V2.7c0-.302-.124-.577-.324-.777a1.097 1.097 0 0 0-1.553 0c-.2.2-.324.475-.324.777v.75h-.42Zm4.442 2.88a2.246 2.246 0 1 0 0 4.494 2.246 2.246 0 0 0 0-4.493ZM6.985 8.71l.672.617c.094.087.24.082.328-.009l1.2-1.148a.235.235 0 0 0-.327-.34L7.813 8.83l-.51-.467a.236.236 0 0 0-.318.346Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconAcceptReturn = (props) => (
  <svg viewBox="0 0 18 18" fill={props.color || 'currentColor'} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 2.885L6.9425 11.45L3.7625 8.27L4.82 7.2125L6.9425 9.335L14.4425 1.835L15.5 2.885ZM13.8425 6.665C13.94 7.0925 14 7.5425 14 8C14 11.315 11.315 14 8 14C4.685 14 2 11.315 2 8C2 4.685 4.685 2 8 2C9.185 2 10.28 2.345 11.21 2.9375L12.29 1.8575C11.075 1.0025 9.5975 0.5 8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 7.1075 15.335 6.2525 15.05 5.4575L13.8425 6.665Z"
      fill="#E00000"
    />
  </svg>
);

export const IconOrdersFilled = (props) => (
  <svg viewBox="0 0 14 15" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      d="M2.023 4h1.704v.926a.292.292 0 0 0 .585 0V4H7.37v.926a.292.292 0 0 0 .584 0V4H9.66c.19 0 .346.143.363.332l.275 2.99a3.78 3.78 0 0 0-3.887 5.208H1.69a.692.692 0 0 1-.528-.233.692.692 0 0 1-.184-.548l.682-7.417A.364.364 0 0 1 2.023 4Zm1.704-.048V2.911c0-.582.238-1.11.621-1.493a2.108 2.108 0 0 1 2.986 0c.383.383.621.911.621 1.493v1.041h-.584V2.911c0-.42-.172-.803-.45-1.08a1.525 1.525 0 0 0-2.16 0c-.277.277-.45.66-.45 1.08v1.041h-.584Zm6.176 4.005a3.123 3.123 0 1 0 0 6.247 3.123 3.123 0 0 0 0-6.247Zm-1.527 3.309.934.858c.131.12.334.114.457-.013l1.668-1.597a.327.327 0 1 0-.454-.471l-1.453 1.391-.709-.65a.327.327 0 1 0-.443.482Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconRestock = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} viewBox="0 0 64 64" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M52.64 9.8a7.869 7.869 0 0 0-5.14-1.9h-31c-1.88 0-3.71.67-5.14 1.9L5.6 14.74h52.8zM62 21.45c0-1.25-.31-2.5-.89-3.63a2.005 2.005 0 0 0-1.78-1.08H4.67c-.75 0-1.43.42-1.77 1.08-.59 1.12-.9 2.38-.9 3.63v26.76c0 4.35 3.54 7.89 7.89 7.89H54.1c2.11 0 4.09-.82 5.58-2.31A7.804 7.804 0 0 0 62 48.21zM31.96 44.41c-.01.04-.03.09-.04.13-.02.09-.05.17-.08.25-.02.05-.05.09-.08.14-.04.07-.07.14-.11.2-.03.05-.07.09-.11.13-.05.06-.09.12-.14.17-.01 0-.01.01-.01.02l-3.97 3.97c-.4.38-.91.58-1.42.58s-1.02-.19-1.41-.58c-.78-.78-.78-2.05 0-2.83l.59-.59H24c-5.51 0-10-4.49-10-10 0-2.66 1.04-5.17 2.92-7.07C18.83 27.04 21.34 26 24 26h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4c-1.6 0-3.11.62-4.25 1.76A5.96 5.96 0 0 0 18 36c0 3.31 2.69 6 6 6h1.17l-.59-.59c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0l3.97 3.97c.01 0 .01.01.01.02.05.05.1.11.14.17.04.04.08.08.11.13.04.06.08.13.11.2.02.05.05.09.08.14.03.08.06.17.08.25.01.04.03.09.04.13.04.13.05.27.05.41s-.01.28-.04.41zm15.12-1.34C45.17 44.96 42.66 46 40 46h-5.16c-1.1 0-2-.9-2-2s.9-2 2-2H40c1.6 0 3.11-.62 4.25-1.76A5.96 5.96 0 0 0 46 36c0-3.31-2.69-6-6-6h-2.34l.59.59c.78.78.78 2.05 0 2.83-.39.39-.9.58-1.41.58s-1.02-.2-1.42-.59l-3.97-3.97-.03-.03-.01-.01a2.005 2.005 0 0 1 0-2.82l.01-.01.03-.03c.28-.27 3.97-3.97 3.97-3.97.78-.78 2.05-.78 2.83 0s.78 2.05 0 2.83l-.59.59H40c5.51 0 10 4.49 10 10 0 2.67-1.04 5.18-2.92 7.08z"
    />
  </svg>
);

export const IconPencil = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    {...props}
  >
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

export const IconShare = (props) => (
  <svg viewBox="0 0 12 12" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M6.964 4.231V2.303l3.375 3.375-3.375 3.375V7.076c-2.41 0-4.098.771-5.303 2.459.482-2.41 1.928-4.822 5.303-5.304Z"
    />
  </svg>
);

export const IconDelete = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 10 11"
    {...props}
  >
    <path d="m1.352 3.501.5 6.04a.852.852 0 0 0 .844.778h4.61a.852.852 0 0 0 .845-.777l.5-6.041h-7.3Zm2.237 5.688a.282.282 0 0 1-.282-.265l-.283-4.558a.282.282 0 0 1 .265-.3.278.278 0 0 1 .3.265l.282 4.558c.01.161-.118.3-.282.3Zm1.695-.283a.282.282 0 1 1-.565 0V4.348a.282.282 0 1 1 .565 0v4.558Zm1.694-4.54-.282 4.558a.282.282 0 1 1-.564-.035l.283-4.558a.287.287 0 0 1 .3-.264c.155.01.273.143.263.3Z" />
    <path d="M8.672 1.809H6.977v-.283A.848.848 0 0 0 6.129.68H3.87a.848.848 0 0 0-.847.847v.283H1.327a.565.565 0 1 0 0 1.13h7.345a.565.565 0 0 0 0-1.13Zm-2.26 0H3.587v-.283c0-.156.126-.282.282-.282h2.26c.156 0 .283.126.283.282v.283Z" />
  </svg>
);

export const IconNotes = (props) => (
  <svg viewBox="0 0 19 18" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill="#FF5636"
      d="M15.5.938h-12A2.064 2.064 0 0 0 1.437 3v9A2.064 2.064 0 0 0 3.5 14.063h.931a.757.757 0 0 1 .756.755v.466a1.661 1.661 0 0 0 1.042 1.56 1.665 1.665 0 0 0 1.839-.366l2.194-2.194a.758.758 0 0 1 .534-.225H15.5A2.064 2.064 0 0 0 17.563 12V3A2.064 2.064 0 0 0 15.5.937Z"
    />
    <path
      fill="#fff"
      d="M13.25 6.563h-7.5a.563.563 0 1 1 0-1.125h7.5a.562.562 0 1 1 0 1.125ZM10.25 9.563h-4.5a.563.563 0 1 1 0-1.126h4.5a.562.562 0 1 1 0 1.126Z"
    />
  </svg>
);

export const IconBuyer = (props) => (
  <svg viewBox="0 0 25 24" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill="#FEA832"
      d="M17.266 10.448a.388.388 0 1 1-.774 0c0-.721.293-1.374.766-1.847a2.603 2.603 0 0 1 1.847-.765c.72 0 1.375.292 1.848.765.473.473.765 1.126.765 1.847a.387.387 0 1 1-.775 0 1.83 1.83 0 0 0-.538-1.3 1.833 1.833 0 0 0-1.3-.537c-.508 0-.968.205-1.3.538-.334.332-.54.792-.54 1.3Z"
    />
    <path
      fill="#0593FC"
      fillRule="evenodd"
      d="M1.356 22.597h14.352a.857.857 0 0 0 .856-.856v-4.765c0-3.09-2.529-5.62-5.621-5.62H6.12c-3.092 0-5.621 2.53-5.621 5.62v4.765c0 .472.384.856.856.856Z"
      clipRule="evenodd"
    />
    <path
      fill="#056BB8"
      fillRule="evenodd"
      d="M4.824 22.599h.774v-5.234a.387.387 0 1 0-.774 0v5.234Zm6.645 0h.774v-5.234a.388.388 0 1 0-.774 0v5.234Z"
      clipRule="evenodd"
    />
    <path
      fill="#FFCE32"
      fillRule="evenodd"
      d="m14.53 12.714-.803 7.034c-.085.751.13 1.43.634 1.993a2.475 2.475 0 0 0 1.908.855h5.671c.756 0 1.406-.291 1.91-.855a2.48 2.48 0 0 0 .631-1.993l-.802-7.034a2.548 2.548 0 0 0-2.54-2.269H17.07a2.55 2.55 0 0 0-2.542 2.269Z"
      clipRule="evenodd"
    />
    <path
      fill="#FEA832"
      d="M16.492 13.043a.387.387 0 1 1 .774 0c0 .508.205.968.54 1.3a1.837 1.837 0 0 0 3.138-1.3.387.387 0 1 1 .774 0 2.613 2.613 0 1 1-5.226 0Z"
    />
    <path
      fill="#0584E3"
      fillRule="evenodd"
      d="M1.356 22.597h.967a.858.858 0 0 1-.855-.856v-4.765c0-3.09 2.528-5.62 5.62-5.62h-.967c-3.092 0-5.621 2.53-5.621 5.62v4.765c0 .472.384.856.856.856Z"
      clipRule="evenodd"
    />
    <path
      fill="#E6BF00"
      fillRule="evenodd"
      d="m14.53 12.714-.803 7.034c-.085.751.13 1.43.634 1.993a2.475 2.475 0 0 0 1.908.855h.557a2.474 2.474 0 0 1-1.908-.855 2.476 2.476 0 0 1-.634-1.993l.802-7.034a2.549 2.549 0 0 1 2.542-2.269h-.556a2.55 2.55 0 0 0-2.542 2.269Z"
      clipRule="evenodd"
    />
    <path
      fill="#FBBD80"
      fillRule="evenodd"
      d="M8.533 9.336A3.974 3.974 0 0 0 12.5 5.368a3.974 3.974 0 0 0-3.967-3.966 3.974 3.974 0 0 0-3.967 3.966 3.974 3.974 0 0 0 3.967 3.968Z"
      clipRule="evenodd"
    />
    <path
      fill="#E2AA73"
      fillRule="evenodd"
      d="M8.534 1.402a3.5 3.5 0 0 1 .29.011 3.966 3.966 0 0 0 0 7.913 3.967 3.967 0 1 1-.29-7.924Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconPackage = (props) => (
  <svg viewBox="0 0 25 24" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path fill="#3BB54A" d="M12.5 12.543a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
    <path
      fill="#8FCC92"
      d="M9.229 3.166a.44.44 0 0 1-.22-.108.263.263 0 0 1 0-.38c.492-.436 1.092-.82 1.743-1.036.164-.056.272 0 .329.164.056.164 0 .272-.165.328-.543.211-1.087.488-1.523.924-.056.108-.113.108-.164.108ZM7.592 6.823c-.164 0-.272-.108-.272-.272 0-.82.164-1.58.544-2.292.056-.108.22-.164.38-.108.108.056.164.22.108.38a4.626 4.626 0 0 0-.493 2.072c.005.107-.103.22-.267.22Z"
    />
    <path
      fill="#0E9347"
      d="M15.827 1.578a5.725 5.725 0 0 1 1.036 3.328c0 3.328-2.672 6-6 6-1.256 0-2.4-.38-3.328-1.036 1.092 1.58 2.892 2.672 4.964 2.672 3.328 0 6-2.672 6-6 0-2.072-1.036-3.923-2.672-4.964Z"
    />
    <path fill="#C97629" d="M14.135 23.456H3.227c-.328 0-.543-.22-.543-.543V9.82H14.14v13.636h-.005Z" />
    <path fill="#C97629" d="M14.135 23.456H3.227c-.328 0-.543-.22-.543-.543V9.82H14.14v13.636h-.005Z" />
    <path fill="#B06328" d="M14.137 23.456h7.636c.328 0 .543-.22.543-.543V9.82h-8.18v13.636Z" />
    <path
      fill="#B06328"
      d="M14.137 23.456h7.636c.328 0 .543-.22.543-.543V9.82h-8.18v13.636ZM3.228 22.909v-6.544c0-.6.492-1.092 1.092-1.092h8.293c.271 0 .492-.164.543-.436l.98-5.02H2.68v13.092c0 .328.22.543.543.543h10.908a1.904 1.904 0 0 0-1.308-.543H3.228Z"
    />
    <path
      fill="#A35425"
      d="M21.773 9.82h-7.636l.98 5.02a.532.532 0 0 0 .543.437h5.02c.6 0 1.093.492 1.093 1.092v6.544h-6.329c-.492 0-.98.22-1.307.543h7.636c.328 0 .543-.22.543-.543V9.82h-.543Z"
    />
    <path
      fill="#C97629"
      d="M17.465 14.18h6.492a.544.544 0 0 0 .544-.544c0-.108 0-.22-.108-.272L22.321 9.82h-8.184l2.4 3.872c.22.272.544.488.928.488Z"
    />
    <path
      fill="#DA8C36"
      d="M10.808 14.18H1.044a.544.544 0 0 1-.544-.544c0-.108 0-.22.108-.272L2.68 9.82h11.456l-2.4 3.872c-.216.272-.544.488-.928.488Z"
    />
    <path
      fill="#FFCB5B"
      d="M4.043 19.637h3.272c.164 0 .272.107.272.272 0 .164-.108.271-.272.271H4.043c-.164 0-.272-.107-.272-.271 0-.165.108-.272.272-.272ZM4.043 20.73h2.18c.164 0 .272.108.272.272 0 .164-.108.272-.272.272h-2.18c-.164 0-.272-.108-.272-.272 0-.164.108-.271.272-.271Z"
    />
    <path
      fill="#0E9347"
      d="M12.5 8.647a.48.48 0 0 1-.332-.136l-1.636-1.636a.467.467 0 1 1 .66-.66l1.304 1.303 2.939-2.94a.467.467 0 1 1 .66.661l-3.271 3.272a.425.425 0 0 1-.324.136Z"
    />
    <path
      fill="#fff"
      d="M11.956 8.105a.484.484 0 0 1-.333-.136L9.987 6.333a.467.467 0 1 1 .66-.66l1.304 1.302 2.944-2.943a.467.467 0 1 1 .66.66L12.285 7.97a.453.453 0 0 1-.329.136Z"
    />
  </svg>
);

export const IconTextFile = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M11.094 14.719h-6.25A2.345 2.345 0 0 1 2.5 12.375v-8.75a2.345 2.345 0 0 1 2.344-2.344h6.25a2.345 2.345 0 0 1 2.344 2.344v8.75a2.345 2.345 0 0 1-2.344 2.344Zm-6.25-12.5c-.775 0-1.407.631-1.407 1.406v8.75c0 .775.632 1.406 1.407 1.406h6.25c.775 0 1.406-.631 1.406-1.406v-8.75c0-.775-.631-1.406-1.406-1.406h-6.25Zm6.093 2.031a.472.472 0 0 0-.468-.469H8.594a.472.472 0 0 0-.469.469c0 .256.213.469.469.469h1.875a.472.472 0 0 0 .469-.469Zm-4.374 0a.472.472 0 0 0-.47-.469H5.47A.472.472 0 0 0 5 4.25c0 .256.213.469.469.469h.625a.472.472 0 0 0 .468-.469Zm0 5a.472.472 0 0 0-.47-.469H5.47A.472.472 0 0 0 5 9.25c0 .256.213.469.469.469h.625a.472.472 0 0 0 .468-.469Zm4.375-2.5a.472.472 0 0 0-.47-.469h-5A.472.472 0 0 0 5 6.75c0 .256.213.469.469.469h5a.472.472 0 0 0 .469-.469Zm0 5a.472.472 0 0 0-.47-.469h-5A.472.472 0 0 0 5 11.75c0 .256.213.469.469.469h5a.472.472 0 0 0 .469-.469Zm0-2.5a.472.472 0 0 0-.47-.469H8.595a.472.472 0 0 0-.469.469c0 .256.213.469.469.469h1.875a.472.472 0 0 0 .469-.469Z" />
  </svg>
);

export const IconImg = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 16 16"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M13.583.5H2.417A1.92 1.92 0 0 0 .5 2.417v11.166A1.92 1.92 0 0 0 2.417 15.5h11.166a1.92 1.92 0 0 0 1.917-1.917V2.417A1.92 1.92 0 0 0 13.583.5zm1.034 13.083c0 .57-.464 1.034-1.034 1.034H2.417c-.57 0-1.033-.464-1.033-1.034v-1.611L4.29 9.498a.286.286 0 0 1 .368-.003l1.822 1.513a.442.442 0 0 0 .595-.028l4.328-4.334a.283.283 0 0 1 .217-.084c.047.002.137.02.207.105l2.789 3.434v3.482zm0-4.884L12.514 6.11a1.171 1.171 0 0 0-1.736-.089l-4.043 4.05-1.511-1.255a1.167 1.167 0 0 0-1.505.009l-2.335 1.987V2.417c0-.57.463-1.033 1.033-1.033h11.166c.57 0 1.034.463 1.034 1.033v6.282z" />
    <path d="M4.222 2.344c-1.175 0-2.13.955-2.13 2.13 0 1.175.955 2.13 2.13 2.13 1.175 0 2.13-.955 2.13-2.13 0-1.175-.955-2.13-2.13-2.13zm0 3.377c-.687 0-1.247-.56-1.247-1.247s.56-1.247 1.247-1.247c.688 0 1.247.56 1.247 1.247s-.56 1.247-1.247 1.247z" />
  </svg>
);

export const IconReurnType = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 16 18"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.64 14.623H2.356a1.667 1.667 0 0 1-1.65-1.9l1.116-7.898a1.687 1.687 0 0 1 1.671-1.452h.57v-.558A2.249 2.249 0 0 1 6.31.566h.002a2.249 2.249 0 0 1 2.25 2.25v.557h.57c.84 0 1.552.619 1.67 1.452l.514 3.639a4.503 4.503 0 0 1 3.995 4.472c0 2.483-2.016 4.5-4.5 4.5a4.504 4.504 0 0 1-4.172-2.813Zm4.172-5.062a3.377 3.377 0 0 1 3.375 3.375 3.377 3.377 0 0 1-3.375 3.375 3.377 3.377 0 0 1-3.375-3.375 3.377 3.377 0 0 1 3.375-3.375Zm.503 2.841a.845.845 0 0 1-.221 1.659H9.687a.563.563 0 0 0 0 1.125h1.407a1.969 1.969 0 0 0 .2-3.928.564.564 0 0 0-.82-.741l-1.124.844a.562.562 0 0 0 0 .9l1.125.844a.562.562 0 0 0 .84-.703ZM10.183 8.48 9.69 4.982a.563.563 0 0 0-.557-.484h-.57v.568a.563.563 0 0 1-1.125 0v-.568h-2.25v.568a.563.563 0 0 1-1.125 0v-.568h-.569a.562.562 0 0 0-.557.484L1.82 12.881a.541.541 0 0 0 .536.617h3.991a4.503 4.503 0 0 1 3.836-5.019ZM7.437 3.373v-.558a1.124 1.124 0 0 0-1.124-1.124h-.002a1.126 1.126 0 0 0-1.124 1.124v.558h2.25Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconWarranty = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 16 16"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M9.25 8.5H8a.625.625 0 0 1-.625-.625v-1.25a.625.625 0 1 1 1.25 0v.625h.625a.625.625 0 1 1 0 1.25z" />
    <path d="M8 12.25a4.38 4.38 0 0 1-4.375-4.375A4.38 4.38 0 0 1 8 3.5a4.38 4.38 0 0 1 4.375 4.375A4.38 4.38 0 0 1 8 12.25zm0-7.5a3.129 3.129 0 0 0-3.125 3.125A3.129 3.129 0 0 0 8 11a3.129 3.129 0 0 0 3.125-3.125A3.129 3.129 0 0 0 8 4.75z" />
    <path d="M8 16a.624.624 0 0 1-.123-.012 8.421 8.421 0 0 1-4.848-2.911A8.422 8.422 0 0 1 1.125 7.75V3.125c0-.345.28-.625.625-.625 1.034 0 1.883-.557 2.782-1.147C5.545.688 6.592 0 8 0c1.407 0 2.455.688 3.468 1.353.9.59 1.748 1.147 2.782 1.147.345 0 .625.28.625.625v4.626a8.422 8.422 0 0 1-1.904 5.326 8.421 8.421 0 0 1-4.848 2.91A.624.624 0 0 1 8 16zM2.375 3.704V7.75A7.17 7.17 0 0 0 8 14.736a7.17 7.17 0 0 0 5.625-6.985V3.704c-1.104-.165-1.986-.744-2.843-1.307C9.882 1.808 9.034 1.25 8 1.25s-1.883.557-2.782 1.147c-.857.563-1.74 1.142-2.843 1.307z" />
  </svg>
);

export const IconSize = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      stroke={props.color || 'currentColor'}
      strokeWidth={0.2}
      d="M5.712 8.287a.3.3 0 0 0-.424 0L3.4 10.175V8.5a.3.3 0 0 0-.6 0v2.4a.3.3 0 0 0 .3.3h2.4a.3.3 0 0 0 0-.6H3.824l1.888-1.887a.3.3 0 0 0 0-.425ZM11.015 2.824A.315.315 0 0 0 10.9 2.8H8.5a.3.3 0 0 0 0 .6h1.676L8.288 5.288a.3.3 0 0 0 .425.425L10.6 3.825v1.676a.3.3 0 0 0 .6 0V3.1a.3.3 0 0 0-.185-.277Z"
    />
    <path
      stroke={props.color || 'currentColor'}
      strokeWidth={0.2}
      d="M11.5 1h-9C1.673 1 1 1.673 1 2.5v9c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5Zm.9 10.5c0 .496-.404.9-.9.9h-9a.901.901 0 0 1-.9-.9v-9c0-.496.404-.9.9-.9h9c.496 0 .9.404.9.9v9Z"
    />
  </svg>
);

export const IconQuantity = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11.023 16.779v-5.582a1.22 1.22 0 0 0-1.22-1.22H4.22A1.22 1.22 0 0 0 3 11.197v5.582c0 .674.546 1.22 1.22 1.22h5.582a1.22 1.22 0 0 0 1.221-1.22zm-1.046-5.582v5.582a.174.174 0 0 1-.175.174H4.221a.174.174 0 0 1-.175-.174v-5.582c0-.096.079-.174.175-.174h5.581c.096 0 .175.078.175.175z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M18 16.779v-5.582a1.22 1.22 0 0 0-1.221-1.22h-5.582a1.22 1.22 0 0 0-1.22 1.22v5.582c0 .674.546 1.22 1.22 1.22h5.582a1.22 1.22 0 0 0 1.22-1.22zm-1.047-5.582v5.582a.174.174 0 0 1-.174.174h-5.582a.175.175 0 0 1-.174-.174v-5.582c0-.096.078-.174.175-.174h5.58c.097 0 .175.078.175.175z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M14.511 9.802V4.221A1.22 1.22 0 0 0 13.291 3H7.708a1.22 1.22 0 0 0-1.22 1.22v5.582a1.22 1.22 0 0 0 1.22 1.221h5.581a1.22 1.22 0 0 0 1.221-1.22zm-1.046-5.581v5.581a.174.174 0 0 1-.175.175H7.71a.174.174 0 0 1-.175-.175V4.221c0-.096.078-.175.174-.175h5.581c.097 0 .175.079.175.175z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M8.581 5.617v.698c0 .288.234.523.523.523h2.79a.523.523 0 0 0 .524-.523v-.698a.523.523 0 0 0-1.046 0v.174H9.628v-.174a.523.523 0 0 0-1.047 0zm-3.488 6.977v.697c0 .289.235.524.524.524h2.79a.523.523 0 0 0 .523-.524v-.697a.523.523 0 0 0-1.046 0v.174H6.14v-.174a.523.523 0 0 0-1.047 0zm6.977 0v.697c0 .289.234.524.523.524h2.79a.523.523 0 0 0 .523-.524v-.697a.523.523 0 0 0-1.046 0v.174h-1.744v-.174a.523.523 0 0 0-1.047 0z"
      clipRule="evenodd"
    />
  </svg>
);
export const IconTimer = (props) => (
  <svg viewBox="0 0 12 12" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <g fill={props.color || 'currentColor'}>
      <path d="m9.635 3.572.719-.718-.707-.708-.77.769a4.968 4.968 0 0 0-2.377-.89V1h1V0h-3v1h1v1.025a4.968 4.968 0 0 0-2.378.89l-.768-.769-.708.708.719.718a5 5 0 1 0 7.27 0ZM6 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z" />
      <path d="M6 4v3H3a3 3 0 1 0 3-3Z" />
    </g>
  </svg>
);

export const IconAddUser = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 18 18"
    {...props}
  >
    <path d="M9 9.563a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM2.813 17.438h6.952a5.045 5.045 0 0 1-1.03-6.755 5.651 5.651 0 0 1-3.824-1.761 6.195 6.195 0 0 0-3.786 5.704v1.125a1.693 1.693 0 0 0 1.688 1.687Z" />
    <path d="M9 13.5a3.938 3.938 0 1 0 7.875 0A3.938 3.938 0 0 0 9 13.5Zm4.5-1.125v.563h.563a.562.562 0 1 1 0 1.124H13.5v.563a.562.562 0 1 1-1.125 0v-.563h-.563a.562.562 0 1 1 0-1.124h.563v-.563a.562.562 0 1 1 1.125 0Z" />
  </svg>
);

export const IconVerifiedUser = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 12 12"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M7.378.85 6 1.556 4.622.85l-.84 1.3-1.547.078-.078 1.546-1.3.84.706 1.378L.857 7.37l1.3.84.078 1.547 1.546.078.84 1.3L6 10.43l1.378.706.84-1.3 1.547-.078.077-1.546 1.3-.84-.705-1.379.706-1.378-1.3-.84-.078-1.546-1.547-.078-.84-1.3Z" />
    <path fill="#fff" d="M7.431 4.68 5.408 6.7l-.822-.827-.461.462.822.826.46.463.462-.462 2.006-2.003" />
  </svg>
);

export const IconPinDualTune = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 0a5.151 5.151 0 0 0-5.156 5.156c0 1.1.33 2.081.965 3l3.796 5.925a.469.469 0 0 0 .79 0l3.813-5.945c.62-.877.948-1.908.948-2.98A5.162 5.162 0 0 0 8 0Zm0 7.5a2.346 2.346 0 0 1-2.344-2.344A2.346 2.346 0 0 1 8 2.813a2.347 2.347 0 0 1 2.344 2.343A2.347 2.347 0 0 1 8 7.5Z" />
    <path
      fillOpacity={0.5}
      d="m11.665 10.766-2.36 3.69c-.612.952-2.002.95-2.61 0l-2.364-3.69C2.251 11.249.97 12.13.97 13.182c0 1.827 3.623 2.813 7.031 2.813 3.409 0 7.031-.986 7.031-2.813 0-1.053-1.284-1.935-3.367-2.415Z"
    />
  </svg>
);

export const IconUserSettings = (props) => (
  <svg viewBox="0 0 20 20" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M15.366 16.842a.816.816 0 0 1-.8-.8v-1.347a1.875 1.875 0 0 0-1.878-1.878H7.316a1.874 1.874 0 0 0-1.878 1.878v1.342a.805.805 0 0 1-1.61 0v-1.342a3.507 3.507 0 0 1 3.488-3.488h5.366a3.507 3.507 0 0 1 3.488 3.488v1.342a.775.775 0 0 1-.804.805ZM10 10.132a3.488 3.488 0 1 1 3.488-3.488A3.507 3.507 0 0 1 10 10.132Zm0-5.366a1.875 1.875 0 0 0-1.735 2.597A1.878 1.878 0 1 0 10 4.766Z"
    />
  </svg>
);

export const IconUser = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M13.2693 16.7025C13.0527 16.7023 12.845 16.6161 12.6919 16.4629C12.5387 16.3098 12.4525 16.1021 12.4523 15.8855V14.5775C12.4523 14.3412 12.4057 14.1071 12.3153 13.8887C12.2248 13.6703 12.0922 13.4719 11.9251 13.3047C11.7579 13.1376 11.5595 13.005 11.3411 12.9145C11.1227 12.8241 10.8887 12.7775 10.6523 12.7775H5.42328C4.94589 12.7775 4.48805 12.9672 4.15049 13.3047C3.81292 13.6423 3.62328 14.1001 3.62328 14.5775V15.8845C3.62328 16.1013 3.53715 16.3093 3.38384 16.4626C3.23053 16.6159 3.0226 16.702 2.80578 16.702C2.58897 16.702 2.38103 16.6159 2.22772 16.4626C2.07441 16.3093 1.98828 16.1013 1.98828 15.8845V14.5775C1.98934 13.667 2.35165 12.7941 2.99566 12.1505C3.63968 11.5069 4.51277 11.1451 5.42328 11.1445H10.6543C11.5644 11.1456 12.437 11.5076 13.0806 12.1512C13.7242 12.7948 14.0862 13.6674 14.0873 14.5775V15.8845C14.0873 16.1015 14.0011 16.3095 13.8477 16.4629C13.6943 16.6163 13.4862 16.7025 13.2693 16.7025Z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M8.03847 10.1629C7.35949 10.1629 6.69575 9.96153 6.1312 9.58431C5.56664 9.20709 5.12663 8.67093 4.86679 8.04363C4.60696 7.41633 4.53897 6.72607 4.67143 6.06013C4.8039 5.3942 5.13086 4.78249 5.61097 4.30238C6.09109 3.82227 6.70279 3.4953 7.36873 3.36284C8.03466 3.23038 8.72492 3.29836 9.35222 3.5582C9.97952 3.81803 10.5157 4.25805 10.8929 4.8226C11.2701 5.38716 11.4715 6.05089 11.4715 6.72988C11.4704 7.64004 11.1084 8.51262 10.4648 9.1562C9.82122 9.79979 8.94863 10.1618 8.03847 10.1629ZM8.03847 4.93188C7.68246 4.93188 7.33445 5.03744 7.03844 5.23523C6.74243 5.43302 6.51172 5.71414 6.37549 6.04305C6.23925 6.37195 6.2036 6.73387 6.27306 7.08304C6.34251 7.4322 6.51394 7.75293 6.76568 8.00467C7.01741 8.2564 7.33814 8.42784 7.68731 8.49729C8.03647 8.56674 8.39839 8.5311 8.7273 8.39486C9.05621 8.25862 9.33733 8.02791 9.53512 7.7319C9.7329 7.43589 9.83847 7.08788 9.83847 6.73188C9.83847 6.25449 9.64883 5.79665 9.31126 5.45908C8.9737 5.12152 8.51586 4.93188 8.03847 4.93188Z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M17.1916 16.7025C16.975 16.7022 16.7673 16.616 16.6142 16.4629C16.461 16.3097 16.3748 16.1021 16.3746 15.8855V14.5775C16.3738 14.1793 16.2411 13.7927 15.9972 13.478C15.7533 13.1634 15.4119 12.9384 15.0266 12.8385C14.9227 12.8116 14.8251 12.7646 14.7394 12.7C14.6537 12.6354 14.5816 12.5546 14.5271 12.4622C14.4727 12.3698 14.437 12.2675 14.422 12.1612C14.4071 12.055 14.4132 11.9469 14.4401 11.843C14.4669 11.7391 14.514 11.6415 14.5785 11.5558C14.6431 11.4701 14.7239 11.398 14.8164 11.3436C14.9088 11.2891 15.0111 11.2534 15.1173 11.2384C15.2235 11.2235 15.3317 11.2296 15.4356 11.2565C16.1719 11.4466 16.8243 11.8759 17.2902 12.477C17.7561 13.0781 18.0091 13.817 18.0096 14.5775V15.8855C18.0093 16.1023 17.923 16.3101 17.7696 16.4632C17.6163 16.6164 17.4083 16.7025 17.1916 16.7025Z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M12.6145 10.0851C12.4154 10.0849 12.2232 10.0121 12.074 9.88019C11.9248 9.7483 11.8289 9.56647 11.8043 9.36885C11.7798 9.17124 11.8282 8.97146 11.9406 8.80706C12.053 8.64266 12.2215 8.52496 12.4145 8.47608C12.8002 8.37574 13.1416 8.15027 13.3853 7.83502C13.6291 7.51977 13.7613 7.13255 13.7613 6.73408C13.7613 6.3356 13.6291 5.94838 13.3853 5.63313C13.1416 5.31788 12.8002 5.09241 12.4145 4.99208C12.3103 4.96561 12.2122 4.91887 12.126 4.85453C12.0398 4.79018 11.9671 4.70948 11.9121 4.61704C11.8571 4.5246 11.8208 4.42222 11.8054 4.31576C11.7899 4.20931 11.7956 4.10085 11.822 3.99658C11.8485 3.89231 11.8952 3.79427 11.9596 3.70806C12.0239 3.62186 12.1046 3.54917 12.1971 3.49415C12.2895 3.43913 12.3919 3.40286 12.4984 3.3874C12.6048 3.37195 12.7133 3.37761 12.8175 3.40408C13.5558 3.5933 14.2101 4.02281 14.6773 4.6249C15.1446 5.227 15.3982 5.96745 15.3982 6.72958C15.3982 7.4917 15.1446 8.23215 14.6773 8.83425C14.2101 9.43635 13.5558 9.86585 12.8175 10.0551C12.7514 10.0737 12.6832 10.0838 12.6145 10.0851Z"
    />
  </svg>
);

export const IconRoles = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={props.color || 'currentColor'}
    {...props}
  >
    <g clipPath="url(#clip0_24492_2166)">
      <mask
        id="mask0_24492_2166"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="17"
        height="17"
      >
        <path d="M1.9978 2.00488H17.9978V18.0049H1.9978V2.00488Z" fill="white" />
      </mask>
      <g mask="url(#mask0_24492_2166)">
        <path
          d="M12.2161 9.97461C12.2161 11.1827 11.2368 12.1621 10.0286 12.1621C8.8205 12.1621 7.84113 11.1827 7.84113 9.97461C7.84113 8.76648 8.8205 7.78711 10.0286 7.78711C11.2368 7.78711 12.2161 8.76648 12.2161 9.97461Z"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7215 14.0939C15.3237 14.4332 16.088 14.222 16.4286 13.6222C16.7692 13.0223 16.5572 12.2609 15.955 11.9216L15.9163 11.8997C15.5053 11.6663 15.2735 11.2068 15.3377 10.7384C15.3709 10.4963 15.388 10.2492 15.388 9.99807C15.388 9.73344 15.3689 9.47328 15.3321 9.21888C15.2641 8.74935 15.4977 8.28725 15.9103 8.05297L15.955 8.02757C16.5572 7.68828 16.7692 6.92694 16.4286 6.32707C16.088 5.72722 15.3237 5.516 14.7215 5.85528L14.6667 5.88641C14.2494 6.12341 13.7324 6.0756 13.3577 5.77563C12.9451 5.44528 12.483 5.17419 11.9842 4.97519C11.5405 4.79813 11.2474 4.37119 11.2474 3.89341V3.88088C11.2474 3.1905 10.6877 2.63088 9.99737 2.63088C9.30703 2.63088 8.74737 3.1905 8.74737 3.88088C8.74737 4.36085 8.45159 4.78925 8.0049 4.96485C7.50053 5.1631 7.03322 5.43503 6.61609 5.76732C6.24156 6.06572 5.72553 6.11216 5.30912 5.87566L5.27328 5.85528C4.67109 5.516 3.90681 5.72722 3.56619 6.32707C3.22556 6.92694 3.43762 7.68828 4.03981 8.02757L4.04984 8.03328C4.46634 8.26985 4.702 8.73666 4.63265 9.2106C4.59503 9.46763 4.5755 9.73057 4.5755 9.99807C4.5755 10.2543 4.59337 10.5063 4.6279 10.7531C4.69353 11.2219 4.46109 11.6824 4.04944 11.9162L4.03981 11.9216C3.43762 12.2609 3.22556 13.0223 3.56619 13.6222C3.90681 14.222 4.67106 14.4332 5.27325 14.0939"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.59113 17.3809C6.59113 15.6295 8.01253 14.1934 9.76591 14.1934H10.3538C12.1072 14.1934 13.5286 15.6295 13.5286 17.3809"
          stroke={props.color || 'currentColor'}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_24492_2166">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconChat = (props) => (
  <svg viewBox="0 0 20 20" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <g stroke={props.color || 'currentColor'} strokeWidth={1.3}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M10 3.5c-3.598 0-6.534 2.96-6.5 6.564V16.5l.108-.108a2.998 2.998 0 0 1 3.457-.574 6.458 6.458 0 0 0 2.906.682c3.578.002 6.494-2.858 6.529-6.436A6.48 6.48 0 0 0 10 3.5Z"
      />
      <path
        fill={props.color || 'currentColor'}
        d="M7.45 10.053a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2ZM10.03 10.053a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2ZM12.607 10.053a.1.1 0 1 0 0-.2.1.1 0 0 0 0 .2Z"
      />
    </g>
  </svg>
);

export const IconMarketing = (props) => (
  <svg viewBox="0 0 20 20" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <g fill={props.color || 'currentColor'}>
      <path d="M12.96 19a.958.958 0 0 1-.89-.613L8.938 10.17a.955.955 0 0 1 1.265-1.217l8.182 3.116a.952.952 0 0 1-.045 1.798l-3.37 1.104-1.105 3.373a.953.953 0 0 1-.907.657Zm-2.834-8.873 2.822 7.406 1.043-3.182a.562.562 0 0 1 .359-.36l3.182-1.042-7.406-2.822ZM9.77 9.99a.029.029 0 0 0 .01.004l-.01-.004Zm.21-.249.01.028-.01-.028Z" />
      <path d="M9.25 17.5C4.701 17.5 1 13.799 1 9.25 1 4.701 4.701 1 9.25 1 13.8 1 17.5 4.701 17.5 9.25c0 .159-.008.326-.016.485a.563.563 0 0 1-1.123-.055c.007-.14.014-.289.014-.43 0-3.929-3.197-7.125-7.125-7.125-3.929 0-7.125 3.196-7.125 7.125 0 3.928 3.196 7.125 7.125 7.125.141 0 .289-.007.43-.014.287-.009.574.222.59.532a.563.563 0 0 1-.534.591 9.592 9.592 0 0 1-.486.016Z" />
      <path d="M8.237 13.63a.561.561 0 0 1-.144-.02 4.514 4.514 0 0 1-3.35-4.36A4.513 4.513 0 0 1 9.25 4.742a4.5 4.5 0 0 1 4.36 3.353.563.563 0 0 1-1.087.284A3.375 3.375 0 0 0 9.25 5.867 3.387 3.387 0 0 0 5.867 9.25a3.389 3.389 0 0 0 2.515 3.273.562.562 0 0 1-.145 1.107Z" />
    </g>
  </svg>
);

export const IconFinance = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || 'currentColor'}
      d="M16.669 9.785a.587.587 0 0 0 .586-.586V6.85a1.76 1.76 0 0 0-1.76-1.76V3.76a1.759 1.759 0 0 0-2.288-1.678l-9.582 3.01A1.76 1.76 0 0 0 2 6.851v9.389A1.76 1.76 0 0 0 3.76 18h11.735a1.76 1.76 0 0 0 1.76-1.76v-2.347a.587.587 0 0 0-1.173 0v2.347a.587.587 0 0 1-.587.587H3.76a.587.587 0 0 1-.586-.587V6.85a.587.587 0 0 1 .586-.586h11.735a.587.587 0 0 1 .587.586V9.2a.587.587 0 0 0 .587.586Zm-3.11-6.583a.587.587 0 0 1 .7.29.588.588 0 0 1 .063.267v1.332H7.568l5.99-1.89Z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M16.67 14.48h-2.934a2.934 2.934 0 0 1 0-5.868h2.934a1.76 1.76 0 0 1 1.76 1.76v2.347a1.76 1.76 0 0 1-1.76 1.76Zm-2.934-4.695a1.76 1.76 0 1 0 0 3.52h2.934a.587.587 0 0 0 .587-.586v-2.347a.587.587 0 0 0-.587-.587h-2.934Z"
    />
    <path fill={props.color || 'currentColor'} d="M13.737 12.131a.587.587 0 1 0 0-1.174.587.587 0 0 0 0 1.174Z" />
  </svg>
);

export const IconOrdersList = (props) => (
  <svg viewBox="0 0 20 20" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M10.625 13.688c0 .345-.28.624-.625.624H6.312a.625.625 0 1 1 0-1.25H10c.345 0 .625.28.625.626ZM18 5.755v7.318a3.57 3.57 0 0 1-1.052 2.54l-1.335 1.335A3.57 3.57 0 0 1 13.073 18H5.755A3.753 3.753 0 0 1 2 14.245v-8.49A3.753 3.753 0 0 1 5.755 2h8.49A3.753 3.753 0 0 1 18 5.755Zm-1.334 7.943h-1.718c-.69 0-1.25.56-1.25 1.25v1.718a2.33 2.33 0 0 0 1.031-.602l1.335-1.335a2.33 2.33 0 0 0 .602-1.031Zm.084-7.943a2.503 2.503 0 0 0-2.505-2.505h-8.49A2.503 2.503 0 0 0 3.25 5.755v8.49a2.503 2.503 0 0 0 2.505 2.505h6.693v-1.802c0-1.379 1.121-2.5 2.5-2.5h1.802V5.755Zm-3.063 3.62H6.314a.625.625 0 1 0 0 1.25h7.375a.625.625 0 1 0 0-1.25Zm0-3.688H6.314a.625.625 0 1 0 0 1.25h7.375a.625.625 0 1 0 0-1.25Z"
    />
  </svg>
);

export const IconProductsList = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M4.4 17.02c-.64 0-1.25-.25-1.7-.7-.45-.45-.7-1.06-.7-1.7v-7.5c0-.1.03-.19.06-.27l1.27-2.53A2.375 2.375 0 0 1 5.45 3h8.29c.44 0 .88.12 1.25.36.38.23.68.57.87.96 1.28 2.56 1.28 2.57 1.29 2.58.02.06.04.13.04.19v7.53c0 .64-.25 1.25-.7 1.7-.45.45-1.06.7-1.7.7H4.4Zm-1.13-2.4c0 .3.12.59.33.8.21.21.5.33.8.33h10.39c.3 0 .59-.12.8-.33.21-.21.33-.5.33-.8V7.76h-3.95v3.72c0 .17-.07.33-.19.45s-.28.19-.45.19H7.85c-.17 0-.33-.07-.45-.19a.636.636 0 0 1-.19-.45V7.76H3.27v6.86Zm7.44-3.79V7.18l-.73-2.91h-.75L8.5 7.21v3.63h2.21v-.01Zm4.82-4.35-.8-1.6c-.09-.19-.23-.34-.41-.45-.18-.11-.38-.17-.58-.17h-2.46l.55 2.21h3.7v.01Zm-8.16 0 .55-2.21H5.46c-.21 0-.41.06-.58.17-.18.11-.32.26-.41.45l-.8 1.6h3.7v-.01Z" />
    <path d="M17.1 7.1c0-.06-.01-.11-.03-.16 0-.01-1.28-2.57-1.28-2.57-.19-.38-.48-.7-.84-.92a2.29 2.29 0 0 0-1.2-.34H5.46c-.42 0-.84.12-1.2.34-.36.22-.65.54-.84.92L2.16 6.88c-.03.08-.05.15-.06.23v7.5c0 .61.24 1.2.67 1.63.43.43 1.02.67 1.63.67h10.39c.61 0 1.2-.24 1.63-.67.43-.43.67-1.02.67-1.63V7.09l.01.01Zm-2.28-2.26.87 1.74h-3.94l-.6-2.41h2.59c.22 0 .44.06.64.18.19.12.34.29.44.49Zm-4.77-.67.75 3.01v3.75H8.39V7.18l.75-3.01h.91Zm-5.67.67a1.19 1.19 0 0 1 1.08-.67h2.59l-.6 2.41H3.5l.87-1.74h.01Zm11.65 9.78a1.225 1.225 0 0 1-1.23 1.23H4.4a1.225 1.225 0 0 1-1.23-1.23V7.66h4.15v3.82a.546.546 0 0 0 .54.54h3.48a.546.546 0 0 0 .54-.54V7.66h4.15v6.96Z" />
  </svg>
);

export const IconDashboard = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M4.65 17.27A2.667 2.667 0 0 1 2 14.62V4.65c0-.71.28-1.37.78-1.87S3.94 2 4.65 2h9.98c.71 0 1.37.28 1.87.78s.78 1.16.78 1.87v9.98c0 .71-.28 1.37-.78 1.87s-1.16.78-1.87.78H4.65v-.01Zm9.97-1.3c.36 0 .7-.14.95-.39s.39-.59.39-.95V7.3H8.28v8.68h6.34v-.01ZM3.3 14.62c0 .36.14.7.4.95.25.25.59.39.95.39H7V7.29H3.3v7.33Zm12.67-8.63V4.64c0-.36-.14-.7-.39-.95s-.59-.39-.95-.4H4.65c-.36 0-.7.14-.95.4s-.39.59-.4.95v1.35h12.67Z" />
    <path d="M14.62 2.148H4.64c-.66 0-1.3.26-1.76.73-.47.47-.73 1.1-.73 1.76v9.98c0 .66.26 1.3.73 1.76.47.47 1.1.73 1.76.73h9.98c.66 0 1.3-.26 1.76-.73.47-.47.73-1.1.73-1.76v-9.98c0-.66-.26-1.3-.73-1.76-.47-.47-1.1-.73-1.76-.73Zm-9.98 1h9.98a1.499 1.499 0 0 1 1.5 1.5v1.5H3.15v-1.5a1.499 1.499 0 0 1 1.5-1.5h-.01Zm-1.49 11.47v-7.49h3.99v8.98H4.65a1.499 1.499 0 0 1-1.5-1.5v.01Zm11.47 1.5H8.13v-8.98h7.98v7.49a1.499 1.499 0 0 1-1.5 1.5l.01-.01Z" />
  </svg>
);

export const IconShoppingBag = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <g fill={props.color || 'currentColor'}>
      <path d="M20.903 19.267 19.86 6.14a1.64 1.64 0 0 0-1.628-1.508h-2.058V7.68a.683.683 0 1 1-1.367 0V4.63H8.522v3.05a.683.683 0 1 1-1.366 0V4.63H5.098a1.64 1.64 0 0 0-1.629 1.507L2.427 19.27a3.81 3.81 0 0 0 1 2.872 3.81 3.81 0 0 0 2.788 1.217h10.9a3.81 3.81 0 0 0 2.788-1.217 3.81 3.81 0 0 0 1-2.874Zm-6.16-6.685-3.533 3.534a.682.682 0 0 1-.967 0l-1.656-1.657a.683.683 0 1 1 .966-.966l1.173 1.173 3.051-3.05a.684.684 0 0 1 .966.966Z" />
      <path d="M11.666.028a4.515 4.515 0 0 0-4.51 4.51v.093h1.367v-.093a3.147 3.147 0 0 1 3.143-3.143 3.147 3.147 0 0 1 3.143 3.143v.093h1.366v-.093a4.515 4.515 0 0 0-4.51-4.51Z" />
    </g>
  </svg>
);

export const IconRating = (props) => (
  <svg viewBox="0 0 16 16" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M12.77.5H2.948c-.323 0-.642.065-.94.19-.298.126-.569.31-.797.542A2.523 2.523 0 0 0 .492 3v7.5c0 .663.259 1.299.72 1.768A2.418 2.418 0 0 0 2.947 13h2.71l1.818 2.31a.495.495 0 0 0 .383.185.486.486 0 0 0 .383-.185L10.059 13h2.71c.652 0 1.276-.263 1.737-.732.46-.47.719-1.105.719-1.768V3a2.54 2.54 0 0 0-.72-1.768A2.453 2.453 0 0 0 13.71.69a2.417 2.417 0 0 0-.94-.19Zm-1.135 5.855L10.108 7.83l.358 2.085a.514.514 0 0 1-.196.483.49.49 0 0 1-.51.047l-1.901-.99-1.901.99a.488.488 0 0 1-.51-.047.504.504 0 0 1-.197-.483l.358-2.085-1.527-1.475a.51.51 0 0 1-.123-.514.508.508 0 0 1 .393-.346l2.122-.305.947-1.9a.515.515 0 0 1 .438-.251.503.503 0 0 1 .437.251l.947 1.9 2.122.305a.496.496 0 0 1 .392.346.518.518 0 0 1-.122.514Z"
    />
  </svg>
);

export const IconReviews = (props) => (
  <svg viewBox="0 0 16 16" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M.812 10.49h5.447a.278.278 0 0 0 .25-.147l.836-1.615a.26.26 0 0 0-.011-.262.281.281 0 0 0-.238-.128H1.649a.28.28 0 0 0-.25.149L.563 10.1a.261.261 0 0 0 .012.262c.05.08.14.128.237.128Z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M1.863 15.873H7.72V9.208l-.79 1.524a.557.557 0 0 1-.499.296H1.584v4.576c0 .148.125.269.279.269ZM14.416 15.604v-4.576H9.567a.557.557 0 0 1-.499-.297L8.28 9.208v6.665h5.858c.154 0 .279-.12.279-.27Z"
    />
    <path
      fill={props.color || 'currentColor'}
      d="M14.347 8.338H8.9a.281.281 0 0 0-.237.128.261.261 0 0 0-.013.261l.837 1.615a.28.28 0 0 0 .25.149h5.447a.281.281 0 0 0 .237-.128.261.261 0 0 0 .012-.261l-.837-1.615a.28.28 0 0 0-.249-.15ZM5.747 6.407a.47.47 0 0 0 .182.48.511.511 0 0 0 .526.048l1.32-.696a.482.482 0 0 1 .451 0l1.32.696c.17.083.375.064.527-.05a.47.47 0 0 0 .181-.479l-.248-1.453a.504.504 0 0 1 .143-.445l1.048-1.025a.494.494 0 0 0 .13-.504.518.518 0 0 0-.4-.349l-1.46-.213a.49.49 0 0 1-.37-.27L8.44.809A.48.48 0 0 0 8 .533a.48.48 0 0 0-.438.275l-.66 1.34a.49.49 0 0 1-.368.269l-1.46.213a.518.518 0 0 0-.4.349.494.494 0 0 0 .13.504l1.048 1.025a.504.504 0 0 1 .143.445l-.249 1.454ZM1.625 5.751c.06.06.086.142.072.223l-.124.726c-.02.09.015.184.09.24a.256.256 0 0 0 .264.024l.661-.347a.242.242 0 0 1 .226 0l.66.348a.256.256 0 0 0 .263-.025.235.235 0 0 0 .09-.24l-.124-.726a.251.251 0 0 1 .072-.222l.524-.512a.247.247 0 0 0 .065-.252.259.259 0 0 0-.2-.174l-.73-.108a.245.245 0 0 1-.185-.134l-.329-.67a.24.24 0 0 0-.22-.137.24.24 0 0 0-.218.138l-.33.668a.245.245 0 0 1-.185.135l-.73.108a.259.259 0 0 0-.2.174.247.247 0 0 0 .065.252l.523.511ZM13.078 3.901l-.329.67a.245.245 0 0 1-.184.135l-.73.107a.259.259 0 0 0-.2.175.247.247 0 0 0 .064.252l.524.511c.06.059.086.142.072.222l-.124.727c-.02.09.015.183.09.24a.256.256 0 0 0 .264.024l.66-.348a.242.242 0 0 1 .226 0l.66.348a.256.256 0 0 0 .263-.024.235.235 0 0 0 .091-.24l-.124-.726a.251.251 0 0 1 .072-.223l.524-.51a.247.247 0 0 0 .064-.253.259.259 0 0 0-.2-.175l-.73-.107a.245.245 0 0 1-.184-.135l-.33-.669a.24.24 0 0 0-.219-.14.24.24 0 0 0-.22.14Z"
    />
  </svg>
);

export const IconCpReviews = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    stroke={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      strokeWidth={0.4}
      d="M16.276 2H3.724C2.774 2 2 2.773 2 3.724v10.544c0 .95.773 1.724 1.724 1.724h4.073l1.872 1.87a.469.469 0 0 0 .662 0l1.872-1.87h4.073c.95 0 1.724-.774 1.724-1.724V3.724C18 2.774 17.227 2 16.276 2Zm.787 12.268a.787.787 0 0 1-.787.786h-4.268a.468.468 0 0 0-.331.137L10 16.869l-1.677-1.676a.469.469 0 0 0-.331-.138H3.724a.787.787 0 0 1-.787-.786V3.724c0-.434.353-.787.787-.787h12.552c.434 0 .787.353.787.787v10.544Z"
    />
    <path
      strokeWidth={0.4}
      d="m14.027 7.392-2.492-.362-1.115-2.258a.469.469 0 0 0-.84 0L8.465 7.03l-2.492.362a.469.469 0 0 0-.26.8L7.517 9.95l-.426 2.482a.469.469 0 0 0 .68.494L10 11.754l2.229 1.172a.469.469 0 0 0 .218.053h.002a.469.469 0 0 0 .456-.573l-.422-2.456 1.803-1.758a.469.469 0 0 0-.26-.8ZM11.652 9.45a.469.469 0 0 0-.134.415l.306 1.789-1.606-.845a.469.469 0 0 0-.436 0l-1.607.845.307-1.789a.469.469 0 0 0-.135-.415l-1.3-1.266 1.797-.262a.469.469 0 0 0 .353-.256L10 6.04l.803 1.627c.069.138.2.234.353.256l1.796.262-1.3 1.266Z"
    />
  </svg>
);

export const IconProducts = (props) => (
  <svg viewBox="0 0 17 17" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M7.008 7.882c.222.093.452.164.687.214V16.6a2.362 2.362 0 0 1-.42-.152l-5.359-2.385a2.68 2.68 0 0 1-1.59-2.448V5.666c0-.238.034-.475.098-.705l6.584 2.92Zm3.876-1.992-7.28-3.421-1.688.75c-.304.134-.58.325-.813.563l6.44 2.867a2.026 2.026 0 0 0 1.644 0l1.697-.76Zm4.743-2.108a2.599 2.599 0 0 0-.813-.563L9.455.834a2.65 2.65 0 0 0-2.18 0l-2.045.911 7.28 3.421 3.117-1.384Zm.679 1.179-3.135 1.393v2.189a.67.67 0 0 1-1.34 0v-1.6l-2.108.939c-.224.089-.453.16-.688.214V16.6c.145-.038.285-.088.42-.152l5.36-2.385a2.68 2.68 0 0 0 1.59-2.448V5.666c-.001-.238-.035-.475-.099-.705Z"
    />
  </svg>
);

export const IconPayments = (props) => (
  <svg viewBox="0 0 16 16" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M5.525 3.712h4.952l1.216-2.438a.536.536 0 0 0-.852-.627c-.35.274-.788.41-1.232.386A1.843 1.843 0 0 1 8.38.653a.536.536 0 0 0-.755 0c-.352.271-.79.406-1.233.38a1.843 1.843 0 0 1-1.227-.38.536.536 0 0 0-.857.621l1.216 2.438ZM10.808 4.786H5.192c-1.147 1.388-3.087 4.142-3.087 6.966 0 2.45 1.865 3.751 3.216 3.751h5.358c1.35 0 3.215-1.302 3.215-3.75 0-2.825-1.94-5.579-3.086-6.967Zm-2.272 7.502v.536a.536.536 0 0 1-1.072 0v-.536a1.608 1.608 0 0 1-1.388-.804.536.536 0 1 1 .922-.536.535.535 0 0 0 .466.268h1.072a.536.536 0 0 0 0-1.071H7.464a1.608 1.608 0 1 1 0-3.215v-.536a.536.536 0 0 1 1.072 0v.536a1.608 1.608 0 0 1 1.388.803.535.535 0 1 1-.922.536.536.536 0 0 0-.466-.268H7.464a.536.536 0 0 0 0 1.072h1.072a1.608 1.608 0 1 1 0 3.215Z"
    />
  </svg>
);

export const IconAddProduct = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    viewBox="0 0 19 19"
    {...props}
  >
    <path d="M15.15 8.232V2.496a1.33 1.33 0 0 0-1.33-1.328H1.81A1.33 1.33 0 0 0 .483 2.496v12.01a1.33 1.33 0 0 0 1.329 1.329h7.734a4.945 4.945 0 0 0 3.989 2.023 4.954 4.954 0 0 0 4.948-4.949 4.957 4.957 0 0 0-3.333-4.677ZM6.502 2.249h2.625a.55.55 0 0 0-.008.09v2.926l-1.122-.401a.54.54 0 0 0-.364 0l-1.123.401V2.34c0-.03-.003-.06-.008-.09ZM1.811 14.753a.247.247 0 0 1-.247-.247V2.496c0-.136.11-.247.247-.247h3.627a.536.536 0 0 0-.008.09v3.694a.54.54 0 0 0 .723.51l1.663-.596 1.663.595a.541.541 0 0 0 .723-.51V2.34c0-.03-.003-.06-.008-.09h3.627c.136 0 .247.111.247.247V7.99a4.954 4.954 0 0 0-5.483 4.92c0 .65.127 1.273.357 1.843H1.81Zm11.723 2.023a3.872 3.872 0 0 1-3.867-3.867 3.872 3.872 0 0 1 3.867-3.867A3.872 3.872 0 0 1 17.4 12.91a3.872 3.872 0 0 1-3.867 3.867Z" />
    <path d="M15.166 12.367h-1.093v-1.092a.54.54 0 0 0-1.08 0v1.092H11.9a.54.54 0 0 0 0 1.081h1.092v1.093a.54.54 0 1 0 1.081 0v-1.093h1.093a.54.54 0 1 0 0-1.08Z" />
  </svg>
);

export const IconScanQr = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="80" height="80" x="336" y="336" rx="8" ry="8"></rect>
    <rect width="64" height="64" x="272" y="272" rx="8" ry="8"></rect>
    <rect width="64" height="64" x="416" y="416" rx="8" ry="8"></rect>
    <rect width="48" height="48" x="432" y="272" rx="8" ry="8"></rect>
    <rect width="48" height="48" x="272" y="432" rx="8" ry="8"></rect>
    <rect width="80" height="80" x="336" y="96" rx="8" ry="8"></rect>
    <rect
      width="176"
      height="176"
      x="288"
      y="48"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      rx="16"
      ry="16"
    ></rect>
    <rect width="80" height="80" x="96" y="96" rx="8" ry="8"></rect>
    <rect
      width="176"
      height="176"
      x="48"
      y="48"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      rx="16"
      ry="16"
    ></rect>
    <rect width="80" height="80" x="96" y="336" rx="8" ry="8"></rect>
    <rect
      width="176"
      height="176"
      x="48"
      y="288"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      rx="16"
      ry="16"
    ></rect>
  </svg>
);

export const IconTrackOrder = (props) => (
  <svg width={props.size || '1em'} height={props.size || '1em'} fill={props.color || 'currentColor'} {...props}>
    <path d="M6.287 3.746c-1.033 0-1.874.84-1.874 1.874 0 1.032.84 1.873 1.874 1.873 1.032 0 1.873-.84 1.873-1.873s-.84-1.874-1.873-1.874Zm0 0c-1.033 0-1.874.84-1.874 1.874 0 1.032.84 1.873 1.874 1.873 1.032 0 1.873-.84 1.873-1.873s-.84-1.874-1.873-1.874Zm0-3.746a5.626 5.626 0 0 0-5.62 5.62c0 3.871 5.045 9.955 5.26 10.212a.469.469 0 0 0 .719 0c.215-.257 5.26-6.34 5.26-10.212A5.626 5.626 0 0 0 6.286 0Zm3.278 6.088h-.508A2.816 2.816 0 0 1 6.755 8.39v.508a.468.468 0 0 1-.937 0V8.39a2.816 2.816 0 0 1-2.302-2.302h-.508a.468.468 0 0 1 0-.937h.508A2.816 2.816 0 0 1 5.818 2.85v-.508a.468.468 0 0 1 .937 0v.508a2.816 2.816 0 0 1 2.302 2.302h.508a.468.468 0 0 1 0 .937ZM6.287 3.746c-1.033 0-1.874.84-1.874 1.874 0 1.032.84 1.873 1.874 1.873 1.032 0 1.873-.84 1.873-1.873s-.84-1.874-1.873-1.874Zm0 0c-1.033 0-1.874.84-1.874 1.874 0 1.032.84 1.873 1.874 1.873 1.032 0 1.873-.84 1.873-1.873s-.84-1.874-1.873-1.874Zm0 0c-1.033 0-1.874.84-1.874 1.874 0 1.032.84 1.873 1.874 1.873 1.032 0 1.873-.84 1.873-1.873s-.84-1.874-1.873-1.874Z" />
  </svg>
);

export const IconDisposition = (props) => (
  <svg
    viewBox="0 0 17 16"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    {...props}
  >
    <path d="M9.119 4.488V1H6.983v3.488l1.068-.712 1.068.712Z" />
    <path d="M9.83 1v4.818L8.05 4.63 6.272 5.818V1H2v14h8.547a3.915 3.915 0 0 1 3.555-6.896V1H9.83Z" />
    <path d="M12.796 8.593a3.203 3.203 0 1 0 0 6.406 3.203 3.203 0 0 0 0-6.406Zm1.899 3.56H12.44V9.897h.712v1.542h1.543v.712Z" />
  </svg>
);

export const IconSandClock = (props) => (
  <svg
    viewBox="0 0 19 18"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill={props.color || 'currentColor'}
    {...props}
  >
    <path d="M13.917 4.816V3.588c.347-.203.583-.575.583-1.005v-.291A.292.292 0 0 0 14.208 2H4.292A.292.292 0 0 0 4 2.292v.291c0 .43.236.802.583 1.005v1.228a4.09 4.09 0 0 0 1.352 3.035L7.211 9l-1.276 1.149a4.089 4.089 0 0 0-1.352 3.035v1.228A1.163 1.163 0 0 0 4 15.417v.291c0 .162.13.292.292.292h9.916c.162 0 .292-.13.292-.292v-.291c0-.43-.236-.802-.583-1.005v-1.228a4.09 4.09 0 0 0-1.352-3.035L11.289 9l1.276-1.149a4.09 4.09 0 0 0 1.352-3.035Zm-2.133 2.168-1.758 1.582a.582.582 0 0 0 0 .868l1.758 1.582c.614.552.966 1.342.966 2.168v1.066h-.73l-2.537-3.383a.302.302 0 0 0-.466 0L6.479 14.25H5.75v-1.066c0-.826.352-1.616.966-2.168l1.758-1.583a.582.582 0 0 0 0-.867L6.716 6.984a2.922 2.922 0 0 1-.966-2.168V3.75h7v1.066c0 .826-.352 1.616-.966 2.168Z" />
    <path d="M11.26 6.083H7.239a.292.292 0 0 0-.216.488l2.03 1.873a.29.29 0 0 0 .392 0l2.03-1.873a.291.291 0 0 0-.215-.488Z" />
  </svg>
);

export const IconGoogleLogo = (props) => (
  <svg viewBox="0 0 19 20" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <mask
      id="yellow"
      width={19}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M18.569 8.272H9.712v3.67h5.1c-.475 2.333-2.462 3.672-5.1 3.672a5.615 5.615 0 1 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.751 0 9.071-3.456 9.071-9.5a7.884 7.884 0 0 0-.214-1.73Z"
      />
    </mask>
    <g mask="url(#yellow)">
      <path fill="#FBBC05" d="M-.652 15.614V4.384l7.343 5.615-7.343 5.615Z" />
    </g>
    <mask
      id="orange"
      width={19}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M18.569 8.272H9.712v3.67h5.1c-.475 2.333-2.462 3.672-5.1 3.672a5.615 5.615 0 1 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.751 0 9.071-3.456 9.071-9.5a7.884 7.884 0 0 0-.214-1.73Z"
      />
    </mask>
    <g mask="url(#orange)">
      <path fill="#EA4335" d="M-.652 4.384 6.691 10l3.024-2.635L20.081 5.68V-.367H-.652v4.751Z" />
    </g>
    <mask
      id="green"
      width={19}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M18.569 8.272H9.712v3.67h5.1c-.475 2.333-2.462 3.672-5.1 3.672a5.615 5.615 0 1 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.751 0 9.071-3.456 9.071-9.5a7.884 7.884 0 0 0-.214-1.73Z"
      />
    </mask>
    <g mask="url(#green)">
      <path fill="#34A853" d="M-.652 15.615 12.306 5.68l3.412.432 4.363-6.479v20.733H-.652v-4.75Z" />
    </g>
    <mask
      id="blue"
      width={19}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M18.569 8.272H9.712v3.67h5.1c-.475 2.333-2.462 3.672-5.1 3.672a5.615 5.615 0 1 1 0-11.23 5.494 5.494 0 0 1 3.5 1.253l2.764-2.764a9.5 9.5 0 1 0-6.264 16.629c4.751 0 9.071-3.456 9.071-9.5a7.884 7.884 0 0 0-.214-1.73Z"
      />
    </mask>
    <g mask="url(#blue)">
      <path fill="#4285F4" d="M20.081 20.366 6.691 9.999 4.963 8.703l15.118-4.319v15.982Z" />
    </g>
  </svg>
);

export const IconBuyerOutline = (props) => (
  <svg
    width={props?.size || '40'}
    height={props?.size || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.5187 37.5H33.03C34.28 37.5 35.3787 36.6712 35.7225 35.47L37.0712 30.7537C37.5825 28.965 36.24 27.1837 34.3787 27.1837H21.1712C19.3112 27.1837 17.9675 28.965 18.4787 30.7537L19.8275 35.47C20.1712 36.6712 21.27 37.5 22.52 37.5H22.5187Z"
      fill="#E53B3B"
      fill-opacity="0.39"
    />
    <path
      d="M24.3726 32.3412C25.0629 32.3412 25.6226 31.7816 25.6226 31.0912C25.6226 30.4009 25.0629 29.8412 24.3726 29.8412C23.6822 29.8412 23.1226 30.4009 23.1226 31.0912C23.1226 31.7816 23.6822 32.3412 24.3726 32.3412Z"
      fill="#E00000"
    />
    <path
      d="M31.2 32.3412C31.8903 32.3412 32.45 31.7816 32.45 31.0912C32.45 30.4009 31.8903 29.8412 31.2 29.8412C30.5096 29.8412 29.95 30.4009 29.95 31.0912C29.95 31.7816 30.5096 32.3412 31.2 32.3412Z"
      fill="#E00000"
    />
    <path
      d="M33.03 38.75H22.5188C20.72 38.75 19.1188 37.5425 18.625 35.8125L17.2763 31.0975C16.925 29.8637 17.165 28.57 17.9363 27.545C18.7088 26.5212 19.8888 25.9337 21.1713 25.9337H34.3788C35.6613 25.9337 36.84 26.5212 37.6125 27.545C38.3838 28.5675 38.625 29.8625 38.2725 31.0962L36.9238 35.8137C36.4288 37.5425 34.8275 38.75 33.03 38.75ZM21.1713 28.4337C20.68 28.4337 20.2288 28.6587 19.9338 29.05C19.6388 29.4412 19.545 29.9375 19.6813 30.41L21.03 35.125C21.2175 35.7875 21.8313 36.2487 22.5188 36.2487H33.03C33.7188 36.2487 34.3313 35.7875 34.5188 35.1262L35.8675 30.4087C36.0025 29.9375 35.9113 29.4425 35.6163 29.05C35.3213 28.6575 34.8688 28.4337 34.3788 28.4337H21.1713Z"
      fill="#E00000"
    />
    <path
      d="M32.7087 28.4338H22.8387V23.4988C22.8387 20.7775 25.0525 18.565 27.7737 18.565C30.495 18.565 32.7075 20.7788 32.7075 23.4988L32.7087 28.4338ZM25.3387 25.9338H30.2087V23.4988C30.2087 22.1575 29.1162 21.065 27.775 21.065C26.4337 21.065 25.34 22.1575 25.34 23.4988L25.3387 25.9338Z"
      fill="#E00000"
    />
    <path
      d="M15 16.25C10.8637 16.25 7.5 12.8862 7.5 8.75C7.5 4.61375 10.8637 1.25 15 1.25C19.1362 1.25 22.5 4.61375 22.5 8.75C22.5 12.8862 19.1362 16.25 15 16.25ZM15 3.75C12.2425 3.75 10 5.9925 10 8.75C10 11.5075 12.2425 13.75 15 13.75C17.7575 13.75 20 11.5075 20 8.75C20 5.9925 17.7575 3.75 15 3.75Z"
      fill="#E00000"
    />
    <path
      d="M4.9725 38.6488C2.77 38.1975 1.25 36.1513 1.25 33.9025V27.9125C1.25 21.0475 6.11125 14.9338 12.8988 13.91C16.6363 13.3463 20.3337 14.3075 23.2562 16.505C23.8512 16.9525 23.935 17.8188 23.4287 18.3663C22.9975 18.8325 22.2825 18.9025 21.775 18.5188C19.6262 16.895 16.96 16.09 14.2175 16.2775C8.2525 16.6863 3.75 21.9063 3.75 27.885V33.9138C3.75 35.0163 4.50125 36.04 5.58875 36.22C6.9725 36.4475 8.1725 35.3813 8.1725 34.0388V28.435C8.1725 27.745 8.7325 27.185 9.4225 27.185C10.1125 27.185 10.6725 27.745 10.6725 28.435V34.0388C10.6725 36.96 8.00125 39.2688 4.9725 38.6488Z"
      fill="#E00000"
    />
    <path
      d="M15.6274 38.75H6.1062V36.25H15.6274C16.3174 36.25 16.8774 36.81 16.8774 37.5C16.8774 38.19 16.3174 38.75 15.6274 38.75Z"
      fill="#E00000"
    />
  </svg>
);

export const IconShopOutline = (props) => (
  <svg
    width={props?.size || '40'}
    height={props?.size || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.57122 18.4888C11.1725 18.4888 13.3787 16.5788 13.7512 14.005L15.4025 2.60001H9.96372C7.73747 2.60001 5.77997 4.07126 5.16122 6.21001L3.54247 11.8C2.57372 15.1475 5.08497 18.49 8.56997 18.49L8.57122 18.4888Z"
      fill="#E53B3B"
      fill-opacity="0.39"
    />
    <path
      d="M13.9238 37.6625C13.8338 37.24 13.7863 36.8013 13.7863 36.3525C13.7863 32.9013 16.585 30.1025 20.0363 30.1025C23.4875 30.1025 26.2863 32.9013 26.2863 36.3525C26.2863 36.745 26.25 37.1288 26.1813 37.5013L13.9238 37.6638V37.6625Z"
      fill="#E53B3B"
      fill-opacity="0.39"
    />
    <path
      d="M20 30.1012C21.8239 30.1012 23.3025 28.6227 23.3025 26.7987C23.3025 24.9748 21.8239 23.4962 20 23.4962C18.1761 23.4962 16.6975 24.9748 16.6975 26.7987C16.6975 28.6227 18.1761 30.1012 20 30.1012Z"
      fill="#E53B3B"
      fill-opacity="0.39"
    />
    <path
      d="M8.56997 19.7388C6.51247 19.7388 4.62247 18.795 3.38622 17.15C2.15122 15.505 1.76997 13.4275 2.34122 11.4513L3.95997 5.86126C4.73122 3.20501 7.19997 1.35001 9.96497 1.35001H16.8475L14.9887 14.185C14.5312 17.3513 11.7725 19.74 8.57122 19.74L8.56997 19.7388ZM9.96497 3.84876C8.30622 3.84876 6.82372 4.96251 6.36122 6.55626L4.74372 12.1463C4.39247 13.36 4.62497 14.6363 5.38622 15.6475C6.14497 16.6588 7.30622 17.2375 8.57122 17.2375C10.5375 17.2375 12.2337 15.77 12.515 13.825L13.9587 3.84876H9.96497Z"
      fill="#E00000"
    />
    <path
      d="M19.9999 19.7388C17.9024 19.7388 15.9124 18.8288 14.5399 17.2438C13.1674 15.6575 12.5524 13.5588 12.8537 11.4825L14.3212 1.34875H25.6787L27.1462 11.4825C27.4474 13.5588 26.8324 15.6575 25.4599 17.2438C24.0862 18.8288 22.0974 19.7388 19.9999 19.7388ZM16.4849 3.84876L15.3274 11.84C15.1312 13.1975 15.5337 14.5713 16.4312 15.6075C17.3287 16.6438 18.6299 17.2388 19.9999 17.2388C21.3699 17.2388 22.6724 16.6438 23.5687 15.6075C24.4649 14.5713 24.8687 13.1975 24.6724 11.84L23.5149 3.84876H16.4849Z"
      fill="#E00000"
    />
    <path
      d="M31.4299 19.7388C28.2287 19.7388 25.4699 17.35 25.0124 14.1838L23.1537 1.35001H30.0362C32.8012 1.35001 35.2699 3.20501 36.0399 5.86126L37.6599 11.4513C38.2312 13.4275 37.8499 15.505 36.6149 17.15C35.3787 18.795 33.4887 19.7388 31.4312 19.7388H31.4299ZM26.0412 3.84876L27.4849 13.8238C27.7674 15.77 29.4624 17.2375 31.4287 17.2375C32.6937 17.2375 33.8537 16.6575 34.6137 15.6475C35.3737 14.6363 35.6074 13.36 35.2562 12.1463L33.6374 6.55626C33.1762 4.96251 31.6937 3.84876 30.0349 3.84876H26.0412Z"
      fill="#E00000"
    />
    <path
      d="M26.2537 38.7638H13.7462C10.8937 38.7638 8.16873 37.5413 6.27248 35.4088C4.37623 33.2763 3.48123 30.43 3.81373 27.5963L4.96623 17.7863L7.44873 18.0775L6.29623 27.8875C6.04623 30.0125 6.71873 32.1488 8.14123 33.7475C9.56248 35.3463 11.605 36.2638 13.745 36.2638H26.2525C28.3925 36.2638 30.4362 35.3475 31.8562 33.7475C33.2787 32.1488 33.9512 30.0138 33.7012 27.8875L32.5487 18.0775L35.0312 17.7863L36.1837 27.5963C36.5175 30.43 35.6212 33.2763 33.725 35.4088C31.8287 37.5413 29.105 38.7638 26.2512 38.7638H26.2537Z"
      fill="#E00000"
    />
    <path
      d="M12.7025 37.9238C12.5925 37.4088 12.5363 36.8813 12.5363 36.3513C12.5363 32.215 15.9 28.8513 20.0363 28.8513C24.1725 28.8513 27.5363 32.215 27.5363 36.3513C27.5363 36.81 27.4938 37.2725 27.41 37.7263L24.9513 37.275C25.0075 36.97 25.035 36.6588 25.035 36.3525C25.035 33.595 22.7925 31.3525 20.035 31.3525C17.2775 31.3525 15.035 33.595 15.035 36.3525C15.035 36.7063 15.0713 37.0588 15.145 37.4025L12.7013 37.925L12.7025 37.9238Z"
      fill="#E00000"
    />
    <path
      d="M19.9999 31.3525C17.4887 31.3525 15.4462 29.31 15.4462 26.8C15.4462 24.29 17.4887 22.2475 19.9999 22.2475C22.5112 22.2475 24.5537 24.29 24.5537 26.8C24.5537 29.31 22.5112 31.3525 19.9999 31.3525ZM19.9999 24.7475C18.8687 24.7475 17.9462 25.6687 17.9462 26.8C17.9462 27.9312 18.8674 28.8525 19.9999 28.8525C21.1324 28.8525 22.0537 27.9312 22.0537 26.8C22.0537 25.6687 21.1324 24.7475 19.9999 24.7475Z"
      fill="#E00000"
    />
  </svg>
);

export const IconRefresh = (props) => {
  return (
    <svg
      width={props?.size || '14'}
      height={props?.size || '14'}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8471 12.11C12.3096 10.9662 13.2502 9.18497 13.2502 7.18497C13.2502 3.7334 10.4612 0.941217 7.00962 0.936529C3.55337 0.931842 0.750244 3.73028 0.750244 7.18497C0.750244 9.14122 1.64868 10.8865 3.05649 12.0318C3.11118 12.0756 3.19087 12.0662 3.23462 12.0115L3.85024 11.2225C3.89243 11.1693 3.88306 11.0928 3.83149 11.049C3.70493 10.9459 3.58306 10.835 3.46587 10.7178C3.00903 10.2625 2.64499 9.72283 2.39399 9.12872C2.13149 8.51466 2.00024 7.85997 2.00024 7.18497C2.00024 6.50997 2.13149 5.85528 2.39243 5.23965C2.64399 4.64434 3.00493 4.10997 3.46431 3.65059C3.92368 3.19122 4.45806 2.83028 5.05337 2.57872C5.67056 2.31778 6.32524 2.18653 7.00025 2.18653C7.67524 2.18653 8.32993 2.31778 8.94556 2.57872C9.54087 2.83028 10.0752 3.19122 10.5346 3.65059C10.994 4.10997 11.3549 4.64434 11.6065 5.23965C11.8674 5.85528 11.9987 6.50997 11.9987 7.18497C11.9987 7.85997 11.8674 8.51466 11.6065 9.13028C11.3555 9.72439 10.9915 10.2641 10.5346 10.7193C10.3893 10.8647 10.2362 11.0006 10.0768 11.1256L9.44087 10.3115C9.42647 10.2929 9.40711 10.2787 9.38502 10.2707C9.36293 10.2626 9.339 10.2609 9.31599 10.2658C9.29297 10.2706 9.27181 10.2819 9.25493 10.2983C9.23804 10.3147 9.22613 10.3355 9.22056 10.3584L8.60181 12.8928C8.58306 12.9709 8.64243 13.0475 8.72212 13.0475L11.3315 13.06C11.4362 13.06 11.4956 12.9397 11.4299 12.8584L10.8471 12.11Z"
        fill="#E00000"
      />
    </svg>
  );
};

export const IconShipment = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 18 18"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.832 4.106c1.56.362 2.158 1.275 2.906 2.53h-2.906v-2.53Zm-9.12 2.636c.305 0 .527.148.527.492 0 .291-.235.527-.526.528H.527a.527.527 0 0 0 0 1.054h4.746a.527.527 0 1 1 .003 1.055H.527a.527.527 0 1 0 0 1.055h1.16v1.582c0 .291.237.527.528.527h1.06a2.022 2.022 0 0 0 3.962 0h5.354a2.022 2.022 0 0 0 3.962 0h.92a.527.527 0 0 0 .527-.527V9.344c0-1.548-1.632-1.65-1.634-1.653h-4.061a.527.527 0 0 1-.528-.527V4H2.215a.527.527 0 0 0-.527.527v1.16h-.633a.527.527 0 1 0 0 1.055h2.657Zm11.544 5.205a.967.967 0 1 1-1.368 1.368.967.967 0 0 1 1.368-1.368Zm-9.317 0a.967.967 0 1 1-1.367 1.368.967.967 0 0 1 1.367-1.368Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconPDF = (props) => (
  <svg fill="none" viewBox="0 0 24 24" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <path
      fill="#E2E5E7"
      d="M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6H6Z"
    />
    <path fill="#B0B7BD" d="M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5Z" />
    <path fill="#CAD1D8" d="M22.5 10.5 18 6h4.5v4.5Z" />
    <path
      fill="#F15642"
      d="M19.5 19.5c0 .413-.337.75-.75.75H2.25a.752.752 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.413 0 .75.338.75.75v7.5Z"
    />
    <path
      fill="#fff"
      d="M4.77 14.21c0-.198.156-.414.407-.414h1.385c.78 0 1.482.522 1.482 1.522 0 .948-.702 1.476-1.482 1.476H5.561v.792c0 .264-.168.414-.384.414a.404.404 0 0 1-.407-.414V14.21Zm.79.341v1.494h1.002c.402 0 .72-.355.72-.727 0-.419-.318-.767-.72-.767H5.561ZM9.219 18c-.198 0-.414-.108-.414-.371v-3.407c0-.215.216-.372.414-.372h1.373c2.74 0 2.68 4.15.054 4.15H9.219Zm.378-3.418v2.687h.995c1.62 0 1.691-2.687 0-2.687h-.995ZM14.243 14.63v.953h1.53c.216 0 .432.216.432.425 0 .198-.216.36-.432.36h-1.53v1.26c0 .21-.149.37-.359.37-.264 0-.425-.16-.425-.37V14.22c0-.215.162-.372.425-.372h2.105c.264 0 .42.157.42.372a.414.414 0 0 1-.42.408h-1.746Z"
    />
    <path fill="#CAD1D8" d="M18.75 20.25H4.5V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75Z" />
  </svg>
);

export const IconWordDoc = (props) => (
  <svg fill="none" viewBox="0 0 24 24" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <path
      fill="#E2E5E7"
      d="M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6H6Z"
    />
    <path fill="#B0B7BD" d="M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5Z" />
    <path fill="#CAD1D8" d="M22.5 10.5 18 6h4.5v4.5Z" />
    <path
      fill="#3A77FF"
      d="M19.5 19.5c0 .413-.337.75-.75.75H2.25a.752.752 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.413 0 .75.338.75.75v7.5Z"
    />
    <path
      fill="#fff"
      d="M4.34 18c-.198 0-.414-.109-.414-.372v-3.406c0-.216.216-.372.414-.372h1.373c2.74 0 2.68 4.15.053 4.15H4.34Zm.378-3.419v2.687h.995c1.62 0 1.69-2.687 0-2.687h-.995ZM10.687 18.06c-1.11.048-2.261-.69-2.261-2.16 0-1.475 1.151-2.2 2.261-2.2 1.05.053 2.147.78 2.147 2.2 0 1.423-1.098 2.16-2.147 2.16Zm-.066-3.58c-.672 0-1.403.474-1.403 1.421 0 .942.732 1.422 1.403 1.422.69 0 1.427-.48 1.427-1.422 0-.948-.737-1.42-1.427-1.42ZM13.54 15.895c0-1.158.725-2.153 2.104-2.153.522 0 .936.156 1.374.534.162.15.18.413.018.581a.407.407 0 0 1-.552-.018c-.246-.258-.498-.329-.84-.329-.923 0-1.366.654-1.366 1.385 0 .744.437 1.428 1.366 1.428.342 0 .66-.14.936-.384a.403.403 0 0 1 .552.072c.096.132.143.354-.066.563-.42.39-.924.469-1.422.469-1.45 0-2.105-.991-2.105-2.148Z"
    />
    <path fill="#CAD1D8" d="M18.75 20.25H4.5V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75Z" />
  </svg>
);

export const ImageAccessDenied = (props) => (
  <svg fill="none" viewBox="0 0 270 270" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <mask
      id="a"
      width={203}
      height={122}
      x={19}
      y={95}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" fillRule="evenodd" d="M19.861 95.794h201.76v120.9H19.861v-120.9Z" clipRule="evenodd" />
    </mask>
    <g mask="url(#a)">
      <path fill="#EDEEEE" fillRule="evenodd" d="M10.73 86.662h220.023v139.163H10.731V86.662Z" clipRule="evenodd" />
    </g>
    <mask
      id="b"
      width={82}
      height={9}
      x={80}
      y={229}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" fillRule="evenodd" d="M80.389 229.245h80.704v8.163H80.389v-8.163Z" clipRule="evenodd" />
    </mask>
    <g mask="url(#b)">
      <path fill="#919395" fillRule="evenodd" d="M71.258 220.113h98.967v26.426H71.258v-26.426Z" clipRule="evenodd" />
    </g>
    <mask
      id="c"
      width={9}
      height={18}
      x={116}
      y={216}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" fillRule="evenodd" d="M116.654 216.691h8.173v16.633h-8.173v-16.633Z" clipRule="evenodd" />
    </mask>
    <g mask="url(#c)">
      <path fill="#919395" fillRule="evenodd" d="M107.523 207.56h26.436v34.895h-26.436V207.56Z" clipRule="evenodd" />
    </g>
    <mask
      id="d"
      width={211}
      height={130}
      x={15}
      y={91}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M23.947 212.612h193.588V99.874H23.947v112.738Zm195.283 8.162H22.251c-2.53-2.526-3.948-3.941-6.476-6.469V98.18l6.476-6.468H219.23l6.474 6.468v116.125c-2.528 2.528-3.945 3.943-6.474 6.469Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#d)">
      <path fill="#EDEEEE" fillRule="evenodd" d="M6.645 82.58h228.191v147.326H6.645V82.58Z" clipRule="evenodd" />
    </g>
    <mask
      id="e"
      width={132}
      height={130}
      x={94}
      y={91}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m225.715 98.192-.157 116.027-6.538 6.53-124.897.036 125.102-129.08 6.49 6.487Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#e)">
      <path fill="#BDBEBF" fillRule="evenodd" d="M84.992 82.572h149.855v147.345H84.992V82.572Z" clipRule="evenodd" />
    </g>
    <mask
      id="f"
      width={211}
      height={14}
      x={15}
      y={207}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M225.715 207.067v7.237c-2.546 2.525-3.95 3.946-6.48 6.473H22.255l-6.478-6.473v-7.237h209.938Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#f)">
      <path fill="#919395" fillRule="evenodd" d="M6.646 197.936h228.201v31.972H6.647v-31.972Z" clipRule="evenodd" />
    </g>
    <mask
      id="g"
      width={130}
      height={131}
      x={102}
      y={32}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M167.144 32.861c35.774 0 64.774 28.962 64.774 64.69 0 35.725-29 64.69-64.774 64.69-35.775 0-64.773-28.965-64.773-64.69 0-35.728 28.998-64.69 64.773-64.69Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#g)">
      <path
        fill="var(--ant-color-secondary-10)"
        fillRule="evenodd"
        d="M93.24 23.73h147.81v147.642H93.24V23.73Z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="h"
      width={154}
      height={154}
      x={102}
      y={32}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M245.394 164.639v-.001l9.707 9.691v10.786H244.3l-9.703-9.691v-.002l-27.192-27.156c-11.056 8.718-24.976 13.969-40.124 13.969-35.793 0-64.91-29.081-64.91-64.826 0-35.746 29.117-64.826 64.91-64.826 35.792 0 64.909 29.08 64.909 64.826 0 15.129-5.258 29.031-13.988 40.073l27.192 27.157Zm-78.112-17.657c27.367 0 49.635-22.238 49.635-49.573s-22.268-49.574-49.635-49.574c-27.369 0-49.637 22.24-49.637 49.574 0 27.335 22.268 49.573 49.637 49.573Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#h)">
      <path
        fill="var(--ant-color-secondary)"
        fillRule="evenodd"
        d="M93.24 23.451h170.993v170.795H93.24V23.451Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#23262A"
      fillRule="evenodd"
      d="M180.497 122.344h13.565v-11.712l-15.343-15.405 15.343-15.359V67.5l-12.911.001-15.048 15.061-14.999-15.058h-11.885l.065 13.462 14.186 14.242-14.05 14.063.064 13.073h12.143l14.457-14.471 14.413 14.471Z"
      clipRule="evenodd"
    />
    <mask
      id="i"
      width={87}
      height={26}
      x={15}
      y={143}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m15.773 168.847-.027-13.198 11.805-11.788h6.62l14.33 14.31 13.155-13.136h6.619l13.154 13.136 13.624-13.605 6.621 6.61-16.934 16.913h-6.62l-13.155-13.137-13.154 13.137h-6.62l-14.33-14.311-15.088 15.069Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#i)">
      <path fill="#919395" fillRule="evenodd" d="M6.615 134.729h104.191v43.25H6.616v-43.25Z" clipRule="evenodd" />
    </g>
  </svg>
);

export const DownloadAppStore = (props) => (
  <svg width={120} height={40} fill="none" {...props}>
    <rect width={119} height={39} x={0.5} y={0.5} fill="#fff" rx={3.5} />
    <rect width={119} height={39} x={0.5} y={0.5} stroke="#000" rx={3.5} />
    <path
      fill="#000"
      d="M24.704 20.763c.013-.92.263-1.822.728-2.622a5.515 5.515 0 0 1 1.933-1.954 5.677 5.677 0 0 0-1.965-1.709 5.826 5.826 0 0 0-2.54-.669c-1.896-.194-3.734 1.107-4.7 1.107-.985 0-2.472-1.088-4.074-1.056a6.107 6.107 0 0 0-2.93.854 5.923 5.923 0 0 0-2.12 2.153c-2.182 3.69-.554 9.114 1.537 12.097 1.047 1.46 2.27 3.093 3.87 3.035 1.566-.064 2.15-.975 4.04-.975 1.873 0 2.422.975 4.054.938 1.68-.027 2.74-1.467 3.749-2.942A11.967 11.967 0 0 0 28 25.612a5.37 5.37 0 0 1-2.395-1.94 5.18 5.18 0 0 1-.9-2.909ZM21.621 11.847A5.286 5.286 0 0 0 22.879 8a5.642 5.642 0 0 0-3.62 1.83 5.084 5.084 0 0 0-1.024 1.726 4.998 4.998 0 0 0-.268 1.978c.7.007 1.393-.141 2.026-.434a4.61 4.61 0 0 0 1.628-1.253ZM36.791 8.501h2.07c1.788 0 2.659 1.064 2.659 2.993 0 1.93-.88 3.006-2.66 3.006h-2.069V8.501Zm.998.84v4.32h.962c1.187 0 1.745-.717 1.745-2.154 0-1.445-.563-2.166-1.745-2.166h-.962Zm6.886.435c1.213 0 2.06.787 2.06 2.092v.602c0 1.349-.847 2.11-2.06 2.11-1.23 0-2.07-.752-2.07-2.106v-.602c0-1.27.853-2.096 2.07-2.096Zm.004.787c-.694 0-1.09.58-1.09 1.357v.519c0 .778.37 1.354 1.09 1.354.712 0 1.077-.572 1.077-1.354v-.519c0-.777-.383-1.357-1.077-1.357Zm9.22-.708L52.677 14.5h-.993l-.971-3.428h-.026l-.954 3.428h-.998l-1.274-4.645h1.05l.747 3.542h.044l.936-3.542h.919l.962 3.542h.044l.76-3.542h.976Zm.967 4.645V9.855h.958v.835h.048c.119-.365.457-.905 1.398-.905.936 0 1.564.518 1.564 1.577V14.5h-.976v-2.852c0-.708-.369-1.033-.918-1.033-.72 0-1.099.554-1.099 1.305v2.58h-.975Zm5.444 0V8.185h.976V14.5h-.976Zm4.325-4.724c1.213 0 2.06.787 2.06 2.092v.602c0 1.349-.847 2.11-2.06 2.11-1.23 0-2.07-.752-2.07-2.106v-.602c0-1.27.852-2.096 2.07-2.096Zm.004.787c-.694 0-1.09.58-1.09 1.357v.519c0 .778.37 1.354 1.09 1.354.712 0 1.077-.572 1.077-1.354v-.519c0-.777-.382-1.357-1.077-1.357Zm4.584 4.007c-.901 0-1.52-.553-1.52-1.42 0-.82.57-1.375 1.643-1.375h1.173v-.435c0-.531-.338-.782-.875-.782-.527 0-.764.22-.839.527h-.927c.057-.777.641-1.3 1.797-1.3.993 0 1.815.413 1.815 1.569V14.5h-.927v-.602h-.044c-.207.356-.61.672-1.296.672Zm.303-.755c.554 0 .993-.378.993-.884v-.5h-1.02c-.566 0-.817.285-.817.671 0 .484.404.713.844.713Zm4.97-4.022c.655 0 1.156.29 1.336.76h.048V8.186h.976V14.5h-.95v-.743h-.048c-.14.47-.698.805-1.375.805-1.068 0-1.762-.76-1.762-1.987v-.795c0-1.226.707-1.987 1.775-1.987Zm.273.8c-.65 0-1.055.484-1.055 1.327v.51c0 .848.409 1.332 1.076 1.332.66 0 1.09-.48 1.09-1.27v-.703c0-.717-.47-1.196-1.111-1.196Zm7.444-.817c1.213 0 2.06.787 2.06 2.092v.602c0 1.349-.847 2.11-2.06 2.11-1.23 0-2.07-.752-2.07-2.106v-.602c0-1.27.853-2.096 2.07-2.096Zm.004.787c-.694 0-1.09.58-1.09 1.357v.519c0 .778.37 1.354 1.09 1.354.712 0 1.077-.572 1.077-1.354v-.519c0-.777-.382-1.357-1.077-1.357Zm3.314 3.937V9.855h.958v.835h.048c.119-.365.457-.905 1.398-.905.936 0 1.564.518 1.564 1.577V14.5h-.976v-2.852c0-.708-.369-1.033-.918-1.033-.72 0-1.099.554-1.099 1.305v2.58h-.975Zm7.743-4.614v-1.16h.954v1.16h1.041v.764h-1.041v2.466c0 .505.189.646.712.646.131 0 .307-.01.382-.018v.747c-.08.013-.404.04-.624.04-1.13 0-1.437-.405-1.437-1.336V10.65h-.708v-.764h.72Zm3.225 4.614V8.185h.972v2.505h.048c.101-.33.479-.905 1.41-.905.906 0 1.552.523 1.552 1.582V14.5h-.971v-2.848c0-.707-.391-1.037-.945-1.037-.699 0-1.094.55-1.094 1.305v2.58h-.972Zm7.256.08c-1.266 0-2.052-.779-2.052-2.088v-.629c0-1.318.861-2.087 1.995-2.087 1.164 0 1.986.809 1.986 2.087v.545h-3.015v.229c0 .668.396 1.16 1.081 1.16.51 0 .862-.242.928-.532h.953c-.057.536-.624 1.314-1.876 1.314Zm-1.086-2.809h2.061v-.062c0-.698-.408-1.164-1.028-1.164-.619 0-1.033.466-1.033 1.165v.061ZM38.206 30.5h-2.03l4.13-11.997h2.233L46.661 30.5h-2.11l-1.063-3.322h-4.21L38.206 30.5Zm3.226-9.923h-.08l-1.625 5.071h3.313l-1.608-5.07Zm10.832 10.055c-1.204 0-2.118-.572-2.61-1.424h-.07v4.377h-1.952V21.21h1.899v1.362h.07c.51-.887 1.46-1.485 2.707-1.485 2.083 0 3.569 1.573 3.569 4.35v.827c0 2.76-1.468 4.368-3.613 4.368Zm-.448-1.609c1.24 0 2.083-.993 2.083-2.865v-.65c0-1.802-.79-2.83-2.118-2.83-1.362 0-2.215 1.107-2.215 2.821v.66c0 1.757.861 2.864 2.25 2.864Zm10.367 1.609c-1.204 0-2.118-.572-2.61-1.424h-.07v4.377H57.55V21.21h1.899v1.362h.07c.51-.887 1.459-1.485 2.707-1.485 2.083 0 3.568 1.573 3.568 4.35v.827c0 2.76-1.467 4.368-3.612 4.368Zm-.448-1.609c1.24 0 2.083-.993 2.083-2.865v-.65c0-1.802-.791-2.83-2.118-2.83-1.363 0-2.215 1.107-2.215 2.821v.66c0 1.757.861 2.864 2.25 2.864Zm8.104-1.854h1.95c.089 1.037 1.003 1.925 2.7 1.925 1.555 0 2.478-.73 2.478-1.864 0-.914-.616-1.406-1.899-1.713l-1.968-.493c-1.547-.36-2.936-1.283-2.936-3.234 0-2.294 2.004-3.55 4.333-3.55 2.33 0 4.271 1.256 4.315 3.497h-1.916c-.088-1.02-.87-1.863-2.425-1.863-1.371 0-2.303.65-2.303 1.767 0 .782.545 1.344 1.661 1.6l1.96.483c1.802.44 3.173 1.292 3.173 3.33 0 2.356-1.907 3.683-4.623 3.683-3.34 0-4.456-1.95-4.5-3.568Zm11.5-5.959v-2.259h1.916v2.259h1.811v1.564h-1.81v4.957c0 1.011.377 1.292 1.423 1.292.167 0 .325 0 .44-.017V30.5a6.534 6.534 0 0 1-.923.061c-2.259 0-2.883-.808-2.883-2.671v-5.116H80.03V21.21h1.31Zm8.996-.158c2.672 0 4.122 1.88 4.122 4.412v.747c0 2.62-1.441 4.447-4.122 4.447-2.68 0-4.14-1.828-4.14-4.447v-.747c0-2.523 1.468-4.412 4.14-4.412Zm0 1.564c-1.45 0-2.17 1.187-2.17 2.874v.712c0 1.661.711 2.883 2.17 2.883 1.46 0 2.162-1.213 2.162-2.883v-.712c0-1.696-.712-2.874-2.162-2.874Zm5.77 7.884v-9.29h1.952v1.222h.07c.237-.58.932-1.354 2.224-1.354.255 0 .474.018.659.053v1.723c-.167-.044-.51-.07-.835-.07-1.565 0-2.092.966-2.092 2.214V30.5h-1.977Zm9.638.158c-2.487 0-4.069-1.643-4.069-4.394v-.94c0-2.594 1.546-4.272 3.99-4.272 2.478 0 3.972 1.74 3.972 4.36v.887h-6.038v.22c0 1.564.844 2.601 2.171 2.601.993 0 1.67-.492 1.908-1.292h1.854c-.281 1.503-1.494 2.83-3.788 2.83Zm-2.145-5.722h4.131v-.017c0-1.318-.817-2.355-2.056-2.355-1.257 0-2.075 1.037-2.075 2.355v.017Z"
    />
  </svg>
);

export const DownloadAppPlayStore = (props) => (
  <svg width={120} height={40} fill="none" {...props}>
    <rect width={119} height={39} x={0.5} y={0.5} fill="#fff" rx={3.5} />
    <rect width={119} height={39} x={0.5} y={0.5} stroke="#000" rx={3.5} />
    <path
      fill="#EA4335"
      d="M17.805 19.462 8.09 30.006c0 .002 0 .005.002.006C8.39 31.157 9.412 32 10.626 32c.485 0 .94-.134 1.331-.37l.031-.018 10.935-6.453-5.118-5.697Z"
    />
    <path
      fill="#FBBC04"
      d="m27.633 17.666-.009-.006-4.721-2.799-5.319 4.84 5.338 5.457 4.696-2.77A2.696 2.696 0 0 0 29 20.022a2.69 2.69 0 0 0-1.367-2.356Z"
    />
    <path fill="#4285F4" d="M8.09 9.993a2.69 2.69 0 0 0-.09.69v18.633c0 .24.031.47.09.69L18.14 19.73 8.089 9.993Z" />
    <path
      fill="#34A853"
      d="m17.876 20 5.028-5.14-10.922-6.476A2.582 2.582 0 0 0 10.626 8c-1.214 0-2.238.845-2.536 1.99l-.001.003L17.876 20Z"
    />
    <path
      fill="#000"
      d="M43.61 11.71c0 1-.297 1.797-.89 2.39-.667.707-1.543 1.06-2.63 1.06-1.04 0-1.92-.36-2.64-1.08-.72-.72-1.08-1.607-1.08-2.66 0-1.053.36-1.94 1.08-2.66.72-.72 1.6-1.08 2.64-1.08.527 0 1.023.093 1.49.28.467.187.85.45 1.15.79l-.66.66a2.169 2.169 0 0 0-.86-.62 2.738 2.738 0 0 0-1.12-.23c-.78 0-1.44.27-1.98.81-.533.547-.8 1.23-.8 2.05 0 .82.267 1.503.8 2.05.54.54 1.2.81 1.98.81.713 0 1.307-.2 1.78-.6.473-.4.747-.95.82-1.65h-2.6v-.86h3.47c.033.187.05.367.05.54Zm5.298-3.87v.88h-3.26v2.27h2.94v.86h-2.94v2.27h3.26V15h-4.18V7.84h4.18Zm3.68.88V15h-.92V8.72h-2v-.88h4.92v.88h-2ZM58.665 15h-.92V7.84h.92V15Zm3.884-6.28V15h-.92V8.72h-2v-.88h4.92v.88h-2Zm11.972 2.7c0 1.06-.353 1.947-1.06 2.66-.713.72-1.587 1.08-2.62 1.08-1.04 0-1.913-.36-2.62-1.08-.707-.713-1.06-1.6-1.06-2.66s.353-1.947 1.06-2.66c.707-.72 1.58-1.08 2.62-1.08s1.913.363 2.62 1.09c.707.713 1.06 1.597 1.06 2.65Zm-6.42 0c0 .827.26 1.51.78 2.05.527.54 1.18.81 1.96.81s1.43-.27 1.95-.81c.527-.533.79-1.217.79-2.05 0-.833-.263-1.517-.79-2.05-.52-.54-1.17-.81-1.95-.81s-1.433.27-1.96.81c-.52.54-.78 1.223-.78 2.05ZM76.527 15h-.92V7.84h1.12l3.48 5.57h.04l-.04-1.38V7.84h.92V15h-.96l-3.64-5.84h-.04l.04 1.38V15ZM93.518 31.41h1.629V20.398h-1.629V31.41Zm14.671-7.045-1.867 4.774h-.056l-1.938-4.774h-1.755l2.906 6.672-1.656 3.712h1.698L110 24.365h-1.811Zm-9.237 5.794c-.534 0-1.278-.269-1.278-.936 0-.849.926-1.175 1.726-1.175.716 0 1.054.156 1.489.369-.127 1.02-.997 1.742-1.937 1.742Zm.196-6.035c-1.179 0-2.401.524-2.906 1.686l1.446.609c.309-.609.884-.808 1.488-.808.843 0 1.699.51 1.713 1.417v.113c-.295-.17-.926-.424-1.699-.424-1.558 0-3.145.864-3.145 2.478 0 1.474 1.278 2.423 2.71 2.423 1.095 0 1.699-.495 2.078-1.077h.056v.85h1.572V27.17c0-1.954-1.446-3.045-3.313-3.045Zm-10.066 1.581h-2.316v-3.774h2.316c1.218 0 1.91 1.017 1.91 1.887 0 .853-.692 1.887-1.91 1.887Zm-.042-5.307h-3.903V31.41h1.629v-4.172h2.274c1.805 0 3.58-1.32 3.58-3.42 0-2.101-1.775-3.42-3.58-3.42Zm-21.282 9.763c-1.125 0-2.067-.95-2.067-2.256 0-1.32.942-2.285 2.067-2.285 1.112 0 1.983.965 1.983 2.285 0 1.305-.871 2.256-1.983 2.256Zm1.87-5.18h-.056c-.366-.44-1.068-.837-1.954-.837-1.857 0-3.558 1.646-3.558 3.76 0 2.1 1.701 3.733 3.558 3.733.886 0 1.588-.397 1.954-.852h.057v.54c0 1.433-.76 2.2-1.983 2.2-.999 0-1.618-.724-1.87-1.335l-1.421.596c.408.994 1.49 2.214 3.29 2.214 1.913 0 3.53-1.135 3.53-3.902V24.37H69.63v.61Zm2.673 6.429h1.631V20.397h-1.631V31.41Zm4.035-3.633c-.042-1.447 1.111-2.185 1.94-2.185.648 0 1.197.326 1.379.794l-3.319 1.391Zm5.063-1.249c-.31-.837-1.252-2.384-3.178-2.384-1.913 0-3.501 1.518-3.501 3.747 0 2.1 1.574 3.746 3.683 3.746 1.702 0 2.687-1.05 3.095-1.66l-1.266-.852c-.422.624-.999 1.036-1.829 1.036s-1.42-.384-1.8-1.135l4.964-2.073-.168-.425ZM41.85 25.294v1.589h3.768c-.112.894-.407 1.547-.857 2-.549.554-1.407 1.165-2.91 1.165-2.322 0-4.136-1.888-4.136-4.23 0-2.341 1.814-4.228 4.135-4.228 1.252 0 2.166.497 2.84 1.135l1.112-1.121C44.859 20.696 43.608 20 41.85 20 38.672 20 36 22.612 36 25.819s2.672 5.818 5.85 5.818c1.715 0 3.009-.568 4.021-1.632 1.042-1.05 1.365-2.526 1.365-3.718 0-.37-.028-.71-.085-.993h-5.3Zm9.67 4.867c-1.124 0-2.095-.937-2.095-2.27 0-1.349.97-2.271 2.096-2.271 1.124 0 2.095.922 2.095 2.27 0 1.334-.97 2.27-2.095 2.27Zm0-6.017c-2.053 0-3.726 1.575-3.726 3.747 0 2.157 1.673 3.746 3.727 3.746 2.053 0 3.726-1.59 3.726-3.746 0-2.172-1.673-3.747-3.726-3.747Zm8.13 6.017c-1.125 0-2.096-.937-2.096-2.27 0-1.349.97-2.271 2.096-2.271 1.125 0 2.095.922 2.095 2.27 0 1.334-.97 2.27-2.095 2.27Zm0-6.017c-2.053 0-3.726 1.575-3.726 3.747 0 2.157 1.673 3.746 3.726 3.746s3.726-1.59 3.726-3.746c0-2.172-1.673-3.747-3.726-3.747Z"
    />
  </svg>
);

export const IconAccountUpdate = (props) => (
  <svg fill="none" viewBox="0 0 40 40" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <rect width={40} height={40} fill="#D8DFE0" rx={20} />
    <circle cx={20} cy={20} r={9.957} fill="#F2F4F5" />
    <circle cx={20} cy={19} r={2.965} fill="#FAFBFB" />
    <path
      stroke="#002F34"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 10c-2.56 0-5.118.976-7.071 2.929A9.969 9.969 0 0 0 10 19.999c0 2.56.976 5.12 2.929 7.072H9M20 30a9.97 9.97 0 0 0 7.071-2.929A9.969 9.969 0 0 0 30 20c0-2.56-.976-5.118-2.929-7.071H31"
    />
    <path
      stroke="#002F34"
      strokeLinecap="round"
      strokeWidth={2}
      d="M20 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 0c2.21 0 3.5.571 4 2m-4-2c-2.21 0-3.5.571-4 2"
    />
  </svg>
);

export const IconOrder = (props) => (
  <svg fill="none" viewBox="0 0 40 40" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <rect width={40} height={40} fill="#CEDDFF" rx={20} />
    <path
      fill="#9CBBFF"
      d="m12.756 27.295 1.77-13.27 12.384-.441.884 1.769.885 9.73-.885 2.654-7.077-1.327-6.192 2.212-1.77-1.327Z"
    />
    <path fill="#6C99FF" d="m24.688 13.708 1.78-.124h.442l1.326 8.846v5.75l-2.7-.022-.849-14.45Z" />
    <path
      fill="#17284E"
      fillRule="evenodd"
      d="m28.225 13.532 1.319 12.266h-.003a3.612 3.612 0 0 1-.903 2.828 3.813 3.813 0 0 1-2.912 1.323H15.712c-1.137 0-2.2-.486-2.92-1.331a3.6 3.6 0 0 1-.897-2.822l.41-3.81h1.678l-.428 3.984v-.002a2.02 2.02 0 0 0 .175 1.061l2.226-2.558a.844.844 0 0 1 .59-.239h8.345a.84.84 0 0 1 .59.24l2.283 2.429c.108-.292.154-.607.119-.931l-1.24-11.535h-1.752v.816a.825.825 0 0 1-.834.817.825.825 0 0 1-.835-.817v-.816h-5.007v.816a.825.825 0 0 1-.834.817.825.825 0 0 1-.834-.817v-.816h-1.753l-.336 3.129H12.78l.433-4.032a.828.828 0 0 1 .83-.73h2.504c0-1.083.432-2.106 1.216-2.886a4.237 4.237 0 0 1 2.956-1.198c2.301 0 4.172 1.831 4.172 4.083h2.504c.427 0 .786.315.83.731Zm-7.506-3.18c-.663 0-1.293.255-1.775.72a2.428 2.428 0 0 0-.728 1.73h5.006c0-1.352-1.122-2.45-2.503-2.45Z"
      clipRule="evenodd"
    />
    <path
      fill="#17284E"
      d="M9.788 18.45h5.315a.57.57 0 0 1 0 1.139H9.788a.57.57 0 0 1 0-1.14ZM7.133 21.102h8.854a.57.57 0 0 1 0 1.14H7.133a.57.57 0 0 1 0-1.14Z"
    />
  </svg>
);

export const IconProduct = (props) => (
  <svg
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <rect width="36" height="36" rx="18" fill="#FACA73" />
    <path d="M17.9996 18.45L8.54961 13.95H8.09961V17.55L8.54961 23.85L17.9996 28.35V18.45Z" fill="#FFF5DA" />
    <path
      d="M8.5498 12.6001L13.0498 9.4501L15.7498 8.5501L19.3498 8.1001L26.5498 11.7001L27.4498 13.5001L22.0498 16.2001L17.5498 17.5501L10.3498 14.8501L8.5498 12.6001Z"
      fill="#FEFBF5"
    />
    <path
      d="M13.2868 21.9267C12.9072 21.7558 12.461 21.9252 12.2902 22.3047C12.1194 22.6843 12.2887 23.1305 12.6682 23.3013L14.6781 24.2056C15.0576 24.3764 15.5038 24.2071 15.6746 23.8276C15.8454 23.4479 15.6762 23.0018 15.2966 22.831L13.2868 21.9267Z"
      fill="#9F6E00"
    />
    <path d="M18 28.35V18L27.9 13.95L27.45 23.4L18 28.35Z" fill="#FFE8AD" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8037 7.59814C18.6619 7.06722 17.344 7.06722 16.2023 7.59813L9.67034 10.6353C8.16376 11.3359 7.2002 12.8465 7.2002 14.508V21.5571C7.2002 23.2313 8.17841 24.7511 9.7023 25.4445L16.2342 28.4165C17.3579 28.9278 18.648 28.9278 19.7717 28.4165L26.3036 25.4445C27.8276 24.7511 28.8057 23.2313 28.8057 21.5571V14.508C28.8057 12.8465 27.8421 11.3359 26.3356 10.6353L19.8037 7.59814ZM16.8378 8.96496C17.5766 8.62144 18.4293 8.62144 19.1682 8.96496L25.7001 12.0022C26.17 12.2207 26.5583 12.561 26.8344 12.9754L23.8404 14.3936L14.729 9.94552L16.8378 8.96496ZM12.9692 10.7638L10.3059 12.0022C9.83594 12.2207 9.44765 12.561 9.17149 12.9754L18.003 17.1587L22.0966 15.2197L12.9692 10.7638ZM8.70882 14.4242L17.2497 18.4699L17.2503 27.1882C17.1171 27.1504 16.9862 27.1026 16.8585 27.0445L10.3266 24.0725C9.34052 23.6238 8.70756 22.6404 8.70756 21.5571V14.508C8.70756 14.48 8.70798 14.452 8.70882 14.4242ZM18.7577 27.1876C18.8901 27.15 19.0204 27.1023 19.1475 27.0445L25.6794 24.0725C26.6654 23.6238 27.2984 22.6404 27.2984 21.5571V14.508C27.2984 14.48 27.298 14.452 27.2971 14.4242L18.757 18.4694L18.7577 27.1876Z"
      fill="#9F6E00"
    />
  </svg>
);

export const IconPromotion = (props) => (
  <svg viewBox="0 0 40 40" width={props.size || '1em'} height={props.size || '1em'} fill="none" {...props}>
    <rect width={40} height={40} fill="#FF8169" rx={20} />
    <path fill="#FFD6C9" d="m19 24-4-7 3.5-3L21 9.5l1.5-1 7.5 13-.5 1.5H23l-4 1Z" />
    <path fill="#FFEEEA" d="m27.5 12.5-2 .5 3 4.5 1-1v-3l-2-1Z" />
    <path fill="#FFD6C9" d="m19 24-4-7-3.5 2-2 3 1 3 4 1.5L19 24Z" />
    <path fill="#FFAA9A" d="m19.5 31-3-4.5V26l3-1.5 2.5 4-.5 2.5h-2Z" />
    <path fill="#FFAA9A" d="M13.5 26.5c3.5-6.001 11.5-6.498 16.5-5l-.5 1.502h-6L14 26.5h-.5Z" />
    <path
      fill="#991801"
      stroke="#991801"
      strokeWidth={0.4}
      d="M28.895 17.647a3.178 3.178 0 0 0 1.329-1.828 3.123 3.123 0 0 0-.323-2.426 3.23 3.23 0 0 0-1.98-1.487 3.293 3.293 0 0 0-2.278.215l-1.82-3.092A2.085 2.085 0 0 0 21.969 8a2.077 2.077 0 0 0-1.816 1.095c-.255.472-.494.962-.747 1.481-1.032 2.115-2.202 4.512-4.73 5.945l-3.25 1.84a4.74 4.74 0 0 0-2.256 2.892 4.65 4.65 0 0 0 .48 3.612c.897 1.525 2.532 2.38 4.21 2.38a4.9 4.9 0 0 0 1.82-.35l2.272 3.86A2.551 2.551 0 0 0 20.155 32c.43 0 .867-.107 1.266-.333a2.481 2.481 0 0 0 1.181-1.514 2.434 2.434 0 0 0-.251-1.89l-2.235-3.799c2.353-1.098 4.823-.911 7.023-.744.585.044 1.137.086 1.682.105a2.084 2.084 0 0 0 1.874-.995 2 2 0 0 0 .02-2.091l-1.82-3.092Zm-1.317-4.483c.5.132.917.444 1.173.88a1.875 1.875 0 0 1-.522 2.47l-1.92-3.26c.398-.17.84-.202 1.268-.09ZM13.857 25.942a3.541 3.541 0 0 1-3.058-1.729 3.376 3.376 0 0 1-.348-2.622 3.442 3.442 0 0 1 1.638-2.101l2.675-1.515 3.527 5.987-2.678 1.517a3.554 3.554 0 0 1-1.756.463Zm7.463 3.874a1.183 1.183 0 0 1-.563.722 1.226 1.226 0 0 1-1.656-.435l-2.249-3.821 2.1-1.19 2.249 3.822c.16.273.203.594.119.902Zm8.237-7.658a.743.743 0 0 1-.688.365c-.517-.018-1.057-.06-1.628-.102-2.4-.182-5.099-.386-7.788.91l-3.55-6.027c2.49-1.64 3.66-4.034 4.7-6.165.247-.507.48-.986.723-1.434a.744.744 0 0 1 .683-.402c.285 0 .521.134.665.378l6.89 11.71a.716.716 0 0 1-.007.767Z"
    />
  </svg>
);

export const IconReviewAdded = (props) => (
  <svg fill="none" viewBox="0 0 40 40" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <rect width={40} height={40} fill="#E7CEFF" rx={20} />
    <path
      fill="#B37FEB"
      d="m9.92 18.664 20.12-.176v4.31l-5.294-.057-1.773 3.46-3.921.087-4.246 3.685-.055-3.326-3.498-.052-1.333-.792v-7.139Z"
    />
    <path fill="#EFDBFF" d="m10.01 19.506.05-6.676.349-.158H29.98l-.05 6.834H10.01Z" />
    <path
      fill="#391085"
      stroke="#391085"
      strokeWidth={0.287}
      d="M12.832 17.537h-.29a.291.291 0 0 0 0 .583h.29c.962 0 1.745-.783 1.745-1.745V14.92a.29.29 0 0 0-.29-.291H12.54c-.16 0-.291.13-.291.291v.873a.29.29 0 1 0 .582 0v-.582h1.164v1.164c0 .641-.522 1.163-1.164 1.163ZM16.026 17.537h-.291a.291.291 0 0 0 0 .583h.29c.963 0 1.746-.783 1.746-1.745V14.92a.29.29 0 0 0-.291-.291h-1.745c-.16 0-.292.13-.292.291v.873a.29.29 0 1 0 .583 0v-.582h1.163v1.164c0 .641-.522 1.163-1.163 1.163Z"
    />
    <path
      fill="#391085"
      stroke="#391085"
      strokeWidth={0.67}
      d="M23.321 25.994h-4.684a.397.397 0 0 0-.28.116l-3.282 3.283V26.39a.396.396 0 0 0-.396-.396h-3.166a1.19 1.19 0 0 1-1.188-1.188V13.723c0-.655.532-1.188 1.188-1.188h2.77a.396.396 0 0 0 0-.793h-2.77c-1.091 0-1.98.889-1.98 1.98v11.083c0 1.091.889 1.98 1.98 1.98h2.77v3.562a.395.395 0 0 0 .675.28l3.842-3.842h4.52a.396.396 0 0 0 0-.793l.001.002Z"
    />
    <path
      fill="#391085"
      stroke="#391085"
      strokeWidth={0.67}
      d="M13.358 12.538H28.36c.654 0 1.187.532 1.187 1.188v8.868a.396.396 0 1 0 .793 0v-8.869c0-1.09-.888-1.979-1.98-1.979h-15a.396.396 0 0 0 0 .793l-.002-.001Z"
    />
    <path
      fill="#F9F0FF"
      d="m23.663 21.69 1.694-4.307 1.792 4.356 4.89.34-3.631 2.711 1.452 4.89-4.406-2.517-4.213 2.711 1.26-4.987-3.439-2.615 4.6-.581Z"
    />
    <path
      fill="#391085"
      stroke="#391085"
      strokeWidth={0.709}
      d="M32.771 21.908a.365.365 0 0 0-.322-.262l-4.852-.347-1.733-4.504a.364.364 0 0 0-.678 0L23.454 21.3l-4.852.347a.362.362 0 0 0-.187.655l3.788 2.755-1.382 4.838a.364.364 0 0 0 .55.403l4.155-2.77 4.154 2.77a.36.36 0 0 0 .416-.009.364.364 0 0 0 .134-.393l-1.382-4.838 3.788-2.755a.363.363 0 0 0 .136-.393Zm-4.557 2.71a.363.363 0 0 0-.135.394l1.18 4.133-3.535-2.357a.361.361 0 0 0-.402 0l-3.534 2.357 1.18-4.133a.363.363 0 0 0-.136-.393l-3.19-2.32 4.09-.292c.141-.01.263-.1.314-.232l1.476-3.837L27 21.776c.05.13.172.221.313.231l4.09.292-1.595 1.16-1.595 1.16h.002Z"
    />
  </svg>
);

export const IconUserAdded = (props) => (
  <svg fill="none" viewBox="0 0 40 40" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <path fill="#5AECE4" d="M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20Z" />
    <path
      fill="#91F2ED"
      d="m20.273 16.379 3.782 2.371-2.003.447-2.225 1.78-1.26 2.374v3.56l2.15 3.19-2.3.37-6.23-.37-1.039-1.187.149-5.786 1.854-3.857 3.19-2.448 3.931-.444Z"
    />
    <rect width={6.71} height={6.71} x={15.54} y={9.29} fill="#C8F8F6" stroke="#085C5D" strokeWidth={1.5} rx={3.355} />
    <path
      fill="#085C5D"
      d="M12.686 31.162c-1.364-.28-2.305-1.547-2.305-2.94v-3.71c0-4.251 3.01-8.038 7.215-8.672A8.508 8.508 0 0 1 24.672 18l-1.05 1.137a6.947 6.947 0 0 0-5.209-1.829c-3.694.252-6.483 3.486-6.483 7.19v3.733c0 .683.465 1.317 1.138 1.428a1.372 1.372 0 0 0 1.602-1.35v-3.471a.774.774 0 0 1 1.548 0v3.47c0 1.81-1.656 3.24-3.532 2.856v-.002Z"
    />
    <path fill="#085C5D" d="M13.22 29.67h8.515a.775.775 0 0 1 0 1.55H13.22v-1.55Z" />
    <path
      fill="#E9FCFB"
      stroke="#085C5D"
      strokeWidth={1.5}
      d="M24.653 31.251a6.27 6.27 0 1 0 0-12.54 6.27 6.27 0 0 0 0 12.54Z"
    />
    <path
      fill="#085C5D"
      stroke="#085C5D"
      d="M27.49 23.142a.286.286 0 0 0-.405 0l-3.429 3.43-1.318-1.319a.286.286 0 0 0-.405.405l1.52 1.52a.286.286 0 0 0 .406 0l3.63-3.63a.286.286 0 0 0 0-.406Z"
    />
  </svg>
);

export const IconSalesSummary = (props) => (
  <svg
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <rect width="36" height="36" rx="18" fill="#C7EBC5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M9.81348 18.5432H14.607V26.2325H9.81348V18.5432Z" fill="#E8F7E8" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.1064 16.2148H19.9V26.2348H15.1064V16.2148Z" fill="#C7EBC5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M20.3994 13.4163H25.193V26.132H20.3994V13.4163Z" fill="#E8F7E8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.7113 26.9993H10.4256C9.63636 26.9993 8.99707 26.36 8.99707 25.5707V19.1421C8.99707 18.3529 9.63636 17.7136 10.4256 17.7136H14.2349V16.9993C14.2349 16.21 14.8749 15.5707 15.6635 15.5707H19.4735V14.1421C19.4735 13.3529 20.1128 12.7136 20.9021 12.7136H24.7113C25.5006 12.7136 26.1399 13.3529 26.1399 14.1421V25.5707C26.1399 26.36 25.5006 26.9993 24.7113 26.9993ZM14.2349 19.1421H10.4256V25.5707H14.2349V19.1421ZM19.4735 16.9993H15.6635V25.5707H19.4735V16.9993ZM20.9021 25.5707H24.7113V14.1421H20.9021V16.285V25.5707ZM19.7013 9.58644C17.0135 13.5493 12.0314 14.8343 12.0314 14.8343C11.6492 14.9321 11.2599 14.7014 11.1621 14.3193C11.0642 13.9371 11.2949 13.5479 11.6771 13.45C11.6771 13.45 16.4213 12.2479 18.7406 8.44001L17.3356 8.42787C16.9413 8.4243 16.6242 8.10144 16.6278 7.70715C16.6313 7.31287 16.9542 6.99573 17.3485 6.9993L20.4056 7.02644C20.7956 7.0293 21.1106 7.3443 21.1135 7.7343L21.1399 10.7207C21.1435 11.115 20.8263 11.4379 20.4321 11.4414C20.0378 11.445 19.7149 11.1279 19.7113 10.7336L19.7013 9.58644Z"
      fill="#1B4B19"
    />
  </svg>
);

export const IconStoreRating = (props) => (
  <svg
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
      fill="#FBE0E0"
    />
    <g clipPath="url(#clip0_23999_26827)">
      <path d="M16.4231 14.4167H10.833V21.5464H15.9524H18.306V28.1667H27.2497V14.4167H21.601H16.4231Z" fill="#FBE0E0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4062 8.6875C10.0962 8.6875 9.82455 8.895 9.74297 9.19411L8.71172 12.9754C8.69565 13.0343 8.6875 13.0951 8.6875 13.1562C8.6875 14.0725 9.08582 14.8958 9.71875 15.4622V19.1719C9.71875 19.5516 10.0266 19.8594 10.4062 19.8594C10.7859 19.8594 11.0938 19.5516 11.0938 19.1719V16.1733C11.3149 16.2235 11.545 16.25 11.7812 16.25C12.7531 16.25 13.6203 15.8019 14.1875 15.1009C14.7547 15.8019 15.6219 16.25 16.5938 16.25C17.5656 16.25 18.4328 15.8019 19 15.1009C19.5672 15.8019 20.4344 16.25 21.4062 16.25C22.3781 16.25 23.2453 15.8019 23.8125 15.1009C24.3797 15.8019 25.2469 16.25 26.2188 16.25C26.455 16.25 26.6852 16.2235 26.9062 16.1733V25.875C26.9062 27.0141 25.9828 27.9375 24.8438 27.9375H20.375C19.9953 27.9375 19.6875 28.2453 19.6875 28.625C19.6875 29.0047 19.9953 29.3125 20.375 29.3125H24.8438C26.7422 29.3125 28.2812 27.7735 28.2812 25.875V15.4622C28.9142 14.8958 29.3125 14.0725 29.3125 13.1562C29.3125 13.0951 29.3044 13.0343 29.2883 12.9754L28.257 9.19411C28.1754 8.895 27.9038 8.6875 27.5938 8.6875H10.4062ZM16.5938 14.875C15.6445 14.875 14.875 14.1055 14.875 13.1562C14.875 12.7765 14.5672 12.4688 14.1875 12.4688C13.8078 12.4688 13.5 12.7765 13.5 13.1562C13.5 14.1055 12.7305 14.875 11.7812 14.875C10.8604 14.875 10.1086 14.1508 10.0645 13.2408L10.9314 10.0625H27.0686L27.9355 13.2408C27.8914 14.1508 27.1396 14.875 26.2188 14.875C25.2695 14.875 24.5 14.1055 24.5 13.1562C24.5 12.7765 24.1922 12.4688 23.8125 12.4688C23.4328 12.4688 23.125 12.7765 23.125 13.1562C23.125 14.1055 22.3555 14.875 21.4062 14.875C20.457 14.875 19.6875 14.1055 19.6875 13.1562C19.6875 12.7765 19.3797 12.4688 19 12.4688C18.6203 12.4688 18.3125 12.7765 18.3125 13.1562C18.3125 14.1055 17.543 14.875 16.5938 14.875Z"
        fill="#930100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0079 18.6174C13.1355 18.4269 13.3498 18.3125 13.5791 18.3125H14.0395C15.316 18.3125 16.2538 19.5191 15.9223 20.7568L15.9044 20.8234H16.808C18.564 20.8234 19.9153 22.3785 19.6556 24.1148L19.2756 27.2356C19.131 28.4235 18.1193 29.3125 16.9237 29.3125H12.7383C12.4282 29.3125 12.139 29.2201 11.8975 29.0611C11.6559 29.2201 11.3667 29.3125 11.0566 29.3125H10.2158C9.37475 29.3125 8.6875 28.633 8.6875 27.788V22.3478C8.6875 21.5029 9.37475 20.8234 10.2158 20.8234H11.0566C11.2067 20.8234 11.3518 20.845 11.489 20.8853L13.0079 18.6174ZM12.585 27.788C12.585 27.8676 12.6506 27.9375 12.7383 27.9375H16.9237C17.4291 27.9375 17.8507 27.5624 17.9107 27.0694L18.2919 23.9386C18.2928 23.9315 18.2938 23.9245 18.2949 23.9174C18.4331 23.0168 17.7327 22.1984 16.808 22.1984H15.0085C14.7948 22.1984 14.5932 22.099 14.4631 21.9294C14.333 21.7598 14.2891 21.5394 14.3444 21.333L14.5941 20.401C14.6895 20.0447 14.4204 19.6875 14.0395 19.6875H13.9461L12.6099 21.6826C12.5935 21.7071 12.585 21.7355 12.585 21.7643V27.788ZM11.21 22.3475C11.2098 22.2681 11.1442 22.1984 11.0566 22.1984H10.2158C10.1282 22.1984 10.0625 22.2683 10.0625 22.3478V27.788C10.0625 27.8676 10.1282 27.9375 10.2158 27.9375H11.0566C11.1443 27.9375 11.21 27.8676 11.21 27.788V22.3475Z"
        fill="#930100"
      />
      <path
        d="M12.585 27.788C12.585 27.8676 12.6506 27.9375 12.7383 27.9375H16.9237C17.4291 27.9375 17.8507 27.5624 17.9107 27.0694L18.2919 23.9386C18.2928 23.9315 18.2938 23.9245 18.2949 23.9174C18.4331 23.0168 17.7327 22.1984 16.808 22.1984H15.0085C14.7948 22.1984 14.5932 22.099 14.4631 21.9294C14.333 21.7598 14.2891 21.5394 14.3444 21.333L14.5941 20.401C14.6895 20.0447 14.4204 19.6875 14.0395 19.6875H13.9461L12.6099 21.6826C12.5935 21.7071 12.585 21.7355 12.585 21.7643V27.788Z"
        fill="#FEF5F5"
      />
      <path
        d="M11.21 22.3474C11.2098 22.268 11.1442 22.1982 11.0566 22.1982H10.2158C10.1282 22.1982 10.0625 22.2682 10.0625 22.3477V27.7879C10.0625 27.8675 10.1282 27.9374 10.2158 27.9374H11.0566C11.1443 27.9374 11.21 27.8675 11.21 27.7879V22.3474Z"
        fill="#FEF5F5"
      />
      <path
        d="M14.8749 13.1562C14.8749 14.1055 15.6444 14.875 16.5937 14.875C17.5429 14.875 18.3124 14.1055 18.3124 13.1562C18.3124 12.7765 18.6202 12.4688 18.9999 12.4688C19.3796 12.4688 19.6874 12.7765 19.6874 13.1562C19.6874 14.1055 20.4569 14.875 21.4062 14.875C22.3554 14.875 23.1249 14.1055 23.1249 13.1562C23.1249 12.7765 23.4327 12.4688 23.8124 12.4688C24.1921 12.4688 24.4999 12.7765 24.4999 13.1562C24.4999 14.1055 25.2694 14.875 26.2187 14.875C27.1395 14.875 27.8913 14.1508 27.9354 13.2408L27.0685 10.0625H10.9313L10.0645 13.2408C10.1085 14.1508 10.8603 14.875 11.7812 14.875C12.7304 14.875 13.4999 14.1055 13.4999 13.1562C13.4999 12.7765 13.8077 12.4688 14.1874 12.4688C14.5671 12.4688 14.8749 12.7765 14.8749 13.1562Z"
        fill="#F08080"
      />
    </g>
    <defs>
      <clipPath id="clip0_23999_26827">
        <rect width="22" height="22" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconBuyerName = (props) => (
  <svg fill="none" viewBox="0 0 40 40" width={props.size || '1em'} height={props.size || '1em'} {...props}>
    <path fill="#FFF6D9" d="M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20Z" />
    <path fill="#FFE48D" d="m18.5 30.5 4-12.5-2-1H15l-4 3-1.5 5.5 1 5h8Z" />
    <path fill="#FFCE32" d="M30.5 24h-10l-1 1.5 2 5h8l2-5-1-1.5Z" />
    <path
      fill="#6A4E15"
      d="M23.302 27.223a.773.773 0 1 0 0-1.546.773.773 0 0 0 0 1.546ZM27.526 27.223a.773.773 0 1 0 0-1.546.773.773 0 0 0 0 1.546Z"
    />
    <path
      fill="#6A4E15"
      d="M28.66 31.187h-6.503a2.515 2.515 0 0 1-2.409-1.817l-.834-2.917a2.49 2.49 0 0 1 .409-2.197 2.487 2.487 0 0 1 2-.997h8.17c.794 0 1.523.363 2 .997.478.632.627 1.433.41 2.196l-.835 2.918a2.517 2.517 0 0 1-2.409 1.817Zm-7.336-6.382a.951.951 0 0 0-.766.381.95.95 0 0 0-.156.842l.834 2.916a.96.96 0 0 0 .921.695h6.502a.96.96 0 0 0 .921-.694l.834-2.918a.951.951 0 0 0-.155-.84.95.95 0 0 0-.765-.382h-8.17Z"
    />
    <path
      fill="#6A4E15"
      d="M28.46 24.807h-6.105v-3.053a3.056 3.056 0 0 1 3.052-3.052 3.055 3.055 0 0 1 3.052 3.052v3.053ZM23.9 23.26h3.013v-1.506c0-.83-.675-1.505-1.505-1.505-.83 0-1.506.675-1.506 1.505L23.9 23.26Z"
    />
    <path fill="#FFEDB2" d="M15 15.5c-2.4-1.6-.666-5 .5-6.5 2.8-.8 4.5.666 5 1.5l.5 4c-1 1-3.6 2.6-6 1Z" />
    <path
      fill="#6A4E15"
      d="M17.506 17.27a4.644 4.644 0 0 1-4.64-4.64c0-2.558 2.081-4.639 4.64-4.639 2.558 0 4.639 2.081 4.639 4.64 0 2.558-2.08 4.639-4.64 4.639Zm0-7.732a3.096 3.096 0 0 0-3.093 3.093 3.096 3.096 0 0 0 3.093 3.092 3.096 3.096 0 0 0 3.093-3.092 3.096 3.096 0 0 0-3.093-3.093Z"
    />
    <path
      fill="#6A4E15"
      d="M11.303 31.125C9.94 30.846 9 29.581 9 28.19v-3.705c0-4.246 3.007-8.028 7.206-8.662a8.505 8.505 0 0 1 6.407 1.606.78.78 0 0 1 .106 1.151.765.765 0 0 1-1.023.094 6.946 6.946 0 0 0-4.675-1.386c-3.69.253-6.475 3.482-6.475 7.18v3.73c0 .681.465 1.315 1.138 1.426a1.37 1.37 0 0 0 1.598-1.35v-3.466a.773.773 0 0 1 1.547 0v3.467a2.919 2.919 0 0 1-3.526 2.851Z"
    />
    <path fill="#6A4E15" d="M17.894 31.187h-5.89v-1.546h5.89a.774.774 0 0 1 0 1.546Z" />
  </svg>
);

export const IconDTAmount = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 18 18"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M2.4 17.1V.9h12.76v16.2l-1.76-1.35-2.2 1.8-2.2-1.8-2.2 1.35-2.2-1.35-2.2 1.35Z" opacity={0.1} />
    <path
      fillRule="evenodd"
      d="M16.163 1.465v15.907a.63.63 0 0 1-.327.555.602.602 0 0 1-.633-.037l-2.043-1.425-1.93 1.417a.602.602 0 0 1-.763-.038L9 16.532l-1.467 1.312a.602.602 0 0 1-.762.038l-1.932-1.418-2.042 1.426a.602.602 0 0 1-.633.037.63.63 0 0 1-.328-.555V1.465C1.836.656 2.477 0 3.27 0h11.462c.791 0 1.432.656 1.432 1.465Zm-1.228 0a.207.207 0 0 0-.204-.21H3.269a.207.207 0 0 0-.205.21v14.718l1.438-1.004a.602.602 0 0 1 .704.009l1.885 1.384 1.504-1.347a.603.603 0 0 1 .81 0l1.504 1.347 1.885-1.384a.602.602 0 0 1 .704-.009l1.437 1.004V1.465Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M5.726 4.604a.621.621 0 0 1-.614-.627c0-.347.275-.628.614-.628h6.55c.338 0 .613.28.613.628a.621.621 0 0 1-.614.627h-6.55ZM5.726 7.954a.621.621 0 0 1-.614-.628c0-.346.275-.628.614-.628h6.55c.338 0 .613.282.613.628a.621.621 0 0 1-.614.628h-6.55ZM5.726 11.303a.621.621 0 0 1-.614-.628c0-.347.275-.628.614-.628H9c.338 0 .614.281.614.628a.621.621 0 0 1-.614.628H5.726Z"
      clipRule="evenodd"
    />
  </svg>
);

export const IconDTCreditCard = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path d="M2 5v2h13l1.5 1v5.5H18l1.5-1.5L18 2.5l-1.5-1L2.5 4 2 5Z" opacity={0.2} />
    <path d="M16 7H1v11.5h13.5l2-.5V8.5L16 7Z" opacity={0.1} />
    <path d="m19.967 11.333-1.518-8.61A2.157 2.157 0 0 0 15.953.975L2.932 3.271a2.157 2.157 0 0 0-1.748 2.496l.112.633A2.157 2.157 0 0 0 0 8.375v8.528c0 1.188.966 2.154 2.154 2.154H15.08a2.157 2.157 0 0 0 2.154-2.154v-2.9l.985-.175a2.14 2.14 0 0 0 1.39-.885 2.14 2.14 0 0 0 .358-1.61Zm-1.32.935a.973.973 0 0 1-.632.403l-.78.138V8.375a2.157 2.157 0 0 0-2.155-2.154H2.458l-.116-.658a.973.973 0 0 1 .162-.732.973.973 0 0 1 .632-.403l13.021-2.296a.98.98 0 0 1 1.134.795l1.518 8.61a.973.973 0 0 1-.162.731Zm-3.567 5.614H2.154a.98.98 0 0 1-.979-.98v-4.175H16.06v4.176c0 .54-.44.98-.979.98ZM2.154 7.396H15.08c.54 0 .98.44.98.98v.51H1.174v-.51c0-.54.44-.98.98-.98ZM16.06 10.06v1.49H1.175v-1.49H16.06Z" />
    <path d="M5.654 15.523H2.99a.587.587 0 1 0 0 1.175h2.665a.587.587 0 1 0 0-1.175Z" />
  </svg>
);

export const IconDTCalendar = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 18 18"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      d="M16.2 2.25H1.8L.45 3.6v12.15L1.8 17.1h6.75l2.138-2.138-.338-1.912.9-1.8 1.8-.9 1.913.338L17.1 8.55V3.6l-.9-1.35Z"
      opacity={0.1}
    />
    <path d="M13.57 8.086a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406Z" />
    <path
      stroke="#fff"
      strokeWidth={0.064}
      d="M13.57.032c.37 0 .671.3.671.671v.735h.947a2.783 2.783 0 0 1 2.78 2.78v4.009a.67.67 0 1 1-1.342 0V4.219a1.44 1.44 0 0 0-1.439-1.439h-.946v.736a.67.67 0 1 1-1.342 0V2.78H9.636v.736a.67.67 0 1 1-1.342 0V2.78H5.065v.736a.67.67 0 1 1-1.341 0V2.78h-.912A1.44 1.44 0 0 0 1.375 4.22v10.968a1.44 1.44 0 0 0 1.438 1.439h5.38a.67.67 0 1 1 0 1.342h-5.38a2.783 2.783 0 0 1-2.78-2.78V4.217a2.783 2.783 0 0 1 2.78-2.78h.912V.703a.67.67 0 1 1 1.341 0v.735h3.229V.703a.67.67 0 1 1 1.342 0v.735h3.263V.703c0-.37.3-.67.671-.67Z"
    />
    <path
      stroke="#fff"
      strokeWidth={0.064}
      d="M13.746 9.524a4.226 4.226 0 0 1 4.222 4.222 4.226 4.226 0 0 1-4.222 4.222 4.226 4.226 0 0 1-4.222-4.222 4.226 4.226 0 0 1 4.222-4.222Zm0 1.342a2.883 2.883 0 0 0-2.88 2.88 2.883 2.883 0 0 0 2.88 2.88 2.883 2.883 0 0 0 2.88-2.88 2.883 2.883 0 0 0-2.88-2.88Z"
    />
    <path
      stroke="#fff"
      strokeWidth={0.064}
      d="M13.746 11.634c.37 0 .671.3.671.67v.771h.349a.67.67 0 1 1 0 1.342h-1.02a.67.67 0 0 1-.67-.67v-1.442c0-.37.3-.671.67-.671Z"
    />
    <path d="M10.512 8.086a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM7.453 11.145a.703.703 0 1 0 0-1.407.703.703 0 0 0 0 1.407ZM4.395 8.086a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM4.395 11.145a.703.703 0 1 0 0-1.407.703.703 0 0 0 0 1.407ZM4.395 14.203a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM7.453 14.203a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406ZM7.453 8.086a.703.703 0 1 0 0-1.406.703.703 0 0 0 0 1.406Z" />
  </svg>
);

export const IconDTSandClock = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      d="M7 8.5V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3.5L11.5 10l1.5 2 2 5-.5 1.5h-9V17l.5-3.5 2.5-3-1.5-2Z"
      opacity={0.1}
    />
    <path d="M7.348 16.633a.663.663 0 0 0 .663.663h3.98a.663.663 0 1 0 0-1.326H8.01a.663.663 0 0 0-.663.663Z" />
    <path d="M15.306 4.031V2.373A1.659 1.659 0 0 0 13.648.715H6.353a1.658 1.658 0 0 0-1.659 1.658v1.658a7.01 7.01 0 0 0 2.07 4.994l1.014 1.015-1.445 1.738a7.077 7.077 0 0 0-1.639 4.517v1.326a1.658 1.658 0 0 0 1.659 1.665h7.295a1.656 1.656 0 0 0 1.658-1.658V16.3a7.076 7.076 0 0 0-1.638-4.516l-1.446-1.738 1.015-1.015a7.01 7.01 0 0 0 2.07-5Zm-4.45 5.499a.663.663 0 0 0-.04.895l1.837 2.228a5.736 5.736 0 0 1 1.327 3.668v1.327a.332.332 0 0 1-.332.331H6.353a.332.332 0 0 1-.332-.331V16.32c0-1.34.47-2.637 1.326-3.668l1.838-2.202a.663.663 0 0 0-.04-.895l-1.446-1.44A5.71 5.71 0 0 1 6.02 4.032V2.373a.332.332 0 0 1 .332-.332h7.295a.332.332 0 0 1 .332.332v1.658a5.71 5.71 0 0 1-1.678 4.06L10.856 9.53Z" />
  </svg>
);

export const IconDTCall = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 20 20"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      d="M10.45 6.4 9.1 1.9v-.45L5.95 2.8 4.6 5.05V8.2l1.8 5.85 3.15 3.6 3.15.45 3.15-.9-.9-2.25-2.7-2.25-2.7.45L7.75 10l.45-1.8 2.25-1.8Z"
      opacity={0.1}
    />
    <path d="m15.624 14.977-.375-.627c-.675-1.113-1.607-2.39-2.829-2.39-.226 0-.45.045-.673.138l-.656.28c-.06.026-.118.054-.18.084-.167.082-.358.174-.553.174-.483 0-1.043-.628-1.576-1.77-.523-1.12-.49-1.707-.37-2.003.133-.326.44-.465.772-.59a4.95 4.95 0 0 0 .128-.05l.664-.28c1.73-.724 1.087-3.253.876-4.082l-.18-.713C10.52 2.561 10.115 1 8.769 1c-.249 0-.515.058-.79.173-.18.071-2.661 1.084-3.56 2.863-1.075 2.118-.876 4.959.59 8.44 1.454 3.486 3.34 5.619 5.606 6.338.389.123.828.186 1.306.186 1.563 0 3.107-.665 3.232-.72.54-.229.888-.576 1.036-1.032.25-.774-.17-1.621-.564-2.27Zm-.595 1.895c-.034.106-.154.203-.355.288l-.01.004c-.015.006-1.412.618-2.744.618a3.11 3.11 0 0 1-.937-.129c-1.909-.606-3.541-2.505-4.852-5.647-1.321-3.139-1.532-5.634-.627-7.42.703-1.391 2.905-2.274 2.926-2.283l.013-.005a.888.888 0 0 1 .325-.08c.268 0 .513.416.725 1.232l.178.71c.385 1.51.326 2.454-.166 2.66l-.661.278-.091.036c-.365.138-1.125.425-1.469 1.27-.312.768-.183 1.741.394 2.978.777 1.663 1.654 2.472 2.68 2.472.476 0 .858-.186 1.086-.297.042-.02.08-.039.12-.056l.657-.281a.51.51 0 0 1 .199-.042c.316 0 .883.313 1.786 1.801l.375.627c.463.763.5 1.11.448 1.266Z" />
  </svg>
);

export const IconDTLocation = (props) => (
  <svg
    fill={props.color || 'currentColor'}
    viewBox="0 0 18 18"
    width={props.size || '1em'}
    height={props.size || '1em'}
    {...props}
  >
    <path
      d="M3.15 8.3C3.15 3.26 7.05 2 9 2c4.05.45 5.85 2.25 5.85 6.3 0 3.24-3.9 7.05-5.85 8.55-4.68-3.6-5.85-7.2-5.85-8.55Z"
      opacity={0.1}
    />
    <path fill="#fff" d="M9 11.4A2.7 2.7 0 1 0 9 6a2.7 2.7 0 0 0 0 5.4Z" />
    <path d="M8.999 17.087c-1.155 0-6.562-5.25-6.562-9.524a6.563 6.563 0 0 1 13.125 0c0 4.29-5.408 9.524-6.563 9.524Zm0-14.97a5.445 5.445 0 0 0-5.437 5.446c0 3.554 4.432 7.904 5.437 8.377 1.005-.473 5.438-4.822 5.438-8.377a5.445 5.445 0 0 0-5.438-5.446Z" />
    <path d="M8.999 11.375a3.187 3.187 0 1 1 3.188-3.188 3.195 3.195 0 0 1-3.188 3.188Zm0-5.25a2.063 2.063 0 1 0 0 4.125 2.063 2.063 0 0 0 0-4.125Z" />
  </svg>
);
export const IconCreditCards = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_23763_176546)">
      <path
        d="M15.9734 9.06646L14.7589 2.17846C14.5938 1.24261 13.698 0.61544 12.7623 0.780482L2.34555 2.61728C1.40967 2.78229 0.782529 3.6779 0.947539 4.61376L1.03678 5.11994C0.427284 5.38582 0 5.99394 0 6.70029V13.5225C0 14.4728 0.773129 15.2459 1.72343 15.2459H12.064C13.0143 15.2459 13.7874 14.4728 13.7874 13.5225V11.2019L14.5754 11.0629C15.0287 10.983 15.4238 10.7313 15.6878 10.3542C15.9519 9.97712 16.0533 9.51975 15.9734 9.06646ZM14.9178 9.81502C14.7978 9.98643 14.6182 10.1008 14.4121 10.1372L13.7874 10.2473V9.71155V7.57921V6.70026C13.7874 5.74996 13.0143 4.97683 12.064 4.97683H1.96615L1.87333 4.4505C1.83698 4.24444 1.88311 4.03656 2.00312 3.86513C2.12313 3.69373 2.30275 3.57932 2.50881 3.54298L12.9256 1.70621C12.9714 1.69813 13.017 1.69424 13.062 1.69424C13.4348 1.69424 13.7662 1.96209 13.8331 2.34165L15.0476 9.22965C15.0839 9.43574 15.0378 9.64362 14.9178 9.81502ZM12.064 14.3059H1.72343C1.29147 14.3059 0.94005 13.9544 0.94005 13.5225V10.1816H12.8474V13.5225C12.8474 13.9544 12.4959 14.3059 12.064 14.3059ZM1.72343 5.91692H12.064C12.4959 5.91692 12.8474 6.26834 12.8474 6.70029V7.10921H0.94005V6.70029C0.94005 6.26834 1.29147 5.91692 1.72343 5.91692ZM12.8474 8.04926V9.24156H0.94005V8.04926H12.8474Z"
        fill="#406367"
      />
      <path
        d="M4.52327 12.4182H2.39092C2.13134 12.4182 1.9209 12.6287 1.9209 12.8882C1.9209 13.1478 2.13134 13.3583 2.39092 13.3583H4.52327C4.78285 13.3583 4.9933 13.1478 4.9933 12.8882C4.9933 12.6287 4.78285 12.4182 4.52327 12.4182Z"
        fill="#406367"
      />
    </g>
    <defs>
      <clipPath id="clip0_23763_176546">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconVacation = (props) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.86328 13.8684C1.97381 13.8543 2.08685 13.8615 2.19434 13.8909C2.30162 13.9202 2.40228 13.9702 2.49023 14.0383C2.57821 14.1064 2.65178 14.1917 2.70703 14.2883L5.85645 19.8H18.0918C18.2613 19.8001 18.427 19.8515 18.5674 19.9465C18.7078 20.0416 18.8169 20.1767 18.8799 20.3342L20.3633 24.0432H24.8799C25.1048 24.0432 25.3204 24.1323 25.4795 24.2912C25.6386 24.4504 25.7285 24.6668 25.7285 24.8918C25.7284 25.1167 25.6385 25.3324 25.4795 25.4914C25.3204 25.6504 25.1048 25.7395 24.8799 25.7395H1.12207C0.897157 25.7395 0.681539 25.6504 0.522461 25.4914C0.363443 25.3324 0.273554 25.1167 0.273438 24.8918C0.273438 24.6668 0.363339 24.4504 0.522461 24.2912C0.681535 24.1323 0.897179 24.0432 1.12207 24.0432H3.09277L4.4248 20.7141L1.23438 15.1301C1.17916 15.0334 1.14295 14.9271 1.12891 14.8166C1.11486 14.7062 1.12306 14.594 1.15234 14.4866C1.18166 14.3791 1.23159 14.2778 1.2998 14.1897C1.368 14.1017 1.45315 14.0281 1.5498 13.9729C1.64639 13.9177 1.75295 13.8825 1.86328 13.8684ZM5.93945 21.4973L4.9209 24.0432H18.5352L17.5176 21.4973H5.93945ZM12.9775 12.1633C13.0888 12.1602 13.1997 12.1784 13.3037 12.218C13.4079 12.2578 13.5039 12.3181 13.585 12.3948C13.6659 12.4714 13.7309 12.5635 13.7764 12.6653C13.8218 12.7671 13.8466 12.877 13.8496 12.9885C13.8526 13.0999 13.8338 13.2107 13.7939 13.3147L11.8545 18.4055C11.7741 18.6154 11.6134 18.7854 11.4082 18.8772C11.2029 18.9689 10.9689 18.9759 10.7588 18.8957C10.5488 18.8156 10.3791 18.6545 10.2871 18.4494C10.1952 18.2444 10.1888 18.0111 10.2686 17.801L12.208 12.7102C12.2476 12.6059 12.3073 12.5101 12.3838 12.4289C12.4603 12.3478 12.5526 12.2832 12.6543 12.2375C12.7561 12.1919 12.8661 12.1665 12.9775 12.1633ZM17.1865 0.346911C17.3917 0.255352 17.6251 0.248373 17.835 0.328357C18.0448 0.408407 18.2145 0.568805 18.3066 0.773669C18.3987 0.97865 18.4057 1.21195 18.3262 1.42211L18.0518 2.14281C20.5832 3.25964 22.6755 5.18052 24.0039 7.60765C24.6988 8.8465 25.1164 10.2218 25.2275 11.6379C25.3386 13.0538 25.1405 14.4769 24.6475 15.8088C24.5953 15.9451 24.5088 16.0662 24.3965 16.1594C24.2843 16.2524 24.1501 16.3149 24.0068 16.3411C23.9569 16.3507 23.9054 16.355 23.8545 16.3547C23.7346 16.3546 23.6162 16.3296 23.5068 16.2805C23.3975 16.2313 23.2994 16.1592 23.2197 16.0696L22.7988 15.595C22.227 14.9524 21.4622 14.5124 20.6191 14.342C19.7761 14.1717 18.9004 14.2795 18.124 14.6496C18.01 14.7113 17.8835 14.7461 17.7539 14.7512C17.6242 14.7563 17.4946 14.7316 17.376 14.6789C17.2575 14.6263 17.1525 14.547 17.0693 14.4475C16.9862 14.348 16.9272 14.2307 16.8965 14.1047C16.6878 13.3524 16.2996 12.6616 15.7656 12.092C15.2317 11.5225 14.5673 11.0909 13.8301 10.8342C13.1094 10.5351 12.3269 10.4148 11.5498 10.4846C10.7725 10.5545 10.0231 10.8127 9.36719 11.2356C9.26043 11.309 9.13796 11.3573 9.00977 11.3762C8.88151 11.3951 8.7504 11.3845 8.62695 11.345C8.50342 11.3053 8.39029 11.2377 8.29688 11.1477C8.20355 11.0577 8.13202 10.9473 8.08789 10.8254C7.75316 10.0333 7.17129 9.3705 6.42871 8.93676C5.68616 8.50306 4.82312 8.32163 3.96875 8.41918L3.34082 8.4934C3.19583 8.51149 3.04795 8.49104 2.91309 8.4348C2.77842 8.37857 2.66038 8.28867 2.57129 8.17308C2.48144 8.05794 2.42314 7.92102 2.40137 7.7766C2.37964 7.63225 2.39539 7.48434 2.44727 7.34789C4.41091 2.19704 10.5769 -0.290496 16.4648 1.54027L16.7402 0.817614C16.8208 0.607925 16.9814 0.438535 17.1865 0.346911ZM20.1768 5.55492C20.553 7.4635 20.3672 9.44042 19.6416 11.2453C19.4606 11.7124 19.249 12.1671 19.0088 12.6067C19.262 12.5708 19.5177 12.5532 19.7734 12.553C21.1087 12.5565 22.4022 13.0183 23.4375 13.8616C23.7567 11.9902 23.4289 10.0659 22.5068 8.40648C21.9078 7.29405 21.1103 6.29998 20.1543 5.47386C20.1608 5.50141 20.1705 5.52717 20.1768 5.55492ZM16.667 3.39281C14.7066 2.64295 12.0189 4.69738 10.8066 7.87816C10.6743 8.22462 10.5614 8.57861 10.4688 8.93773C11.7925 8.6481 13.1729 8.75642 14.4355 9.24828C15.7055 9.72109 16.8074 10.5592 17.6025 11.6565C17.7724 11.3269 17.9237 10.9874 18.0557 10.6409C18.6629 9.14765 18.8244 7.51025 18.5215 5.92699C18.4478 5.38353 18.2399 4.86662 17.916 4.42406C17.5921 3.98163 17.1626 3.6273 16.667 3.39281ZM12.6387 2.635C11.0694 2.568 9.50931 2.90724 8.10938 3.61937C6.70954 4.33151 5.51731 5.39274 4.64746 6.70043C5.43824 6.73621 6.21322 6.93371 6.9248 7.28051C7.63659 7.62745 8.26969 8.11692 8.78516 8.71801C8.8987 8.22808 9.0444 7.74564 9.2207 7.27465C9.88093 5.42675 11.0695 3.81331 12.6387 2.635Z"
      fill="#085C5D"
    />
  </svg>
);

export const IconPending = (props) => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20.5" cy="20" r="20" fill="#FFF5DA" />
    <path
      d="M21 29.75C26.3848 29.75 30.75 25.3848 30.75 20C30.75 14.6152 26.3848 10.25 21 10.25C15.6152 10.25 11.25 14.6152 11.25 20C11.25 25.3848 15.6152 29.75 21 29.75Z"
      fill="#FACA73"
    />
    <path
      d="M21 10.25C19.0716 10.25 17.1866 10.8218 15.5832 11.8932C13.9798 12.9645 12.7301 14.4873 11.9922 16.2688C11.2542 18.0504 11.0611 20.0108 11.4373 21.9021C11.8136 23.7934 12.7422 25.5307 14.1057 26.8943C15.4693 28.2579 17.2066 29.1865 19.0979 29.5627C20.9892 29.9389 22.9496 29.7458 24.7312 29.0078C26.5127 28.2699 28.0355 27.0202 29.1068 25.4168C30.1782 23.8134 30.75 21.9284 30.75 20C30.7474 17.415 29.7193 14.9365 27.8914 13.1086C26.0635 11.2807 23.5851 10.2526 21 10.25ZM21 28.25C19.3683 28.25 17.7733 27.7661 16.4165 26.8596C15.0598 25.9531 14.0024 24.6646 13.378 23.1571C12.7536 21.6496 12.5902 19.9908 12.9085 18.3905C13.2269 16.7902 14.0126 15.3202 15.1664 14.1664C16.3202 13.0126 17.7902 12.2268 19.3905 11.9085C20.9909 11.5902 22.6497 11.7536 24.1571 12.378C25.6646 13.0024 26.9531 14.0598 27.8596 15.4165C28.7661 16.7733 29.25 18.3683 29.25 20C29.2474 22.1872 28.3773 24.2841 26.8307 25.8307C25.2841 27.3773 23.1872 28.2474 21 28.25ZM24.53 22.47C24.6705 22.6106 24.7493 22.8012 24.7493 23C24.7493 23.1988 24.6705 23.3894 24.53 23.53C24.3894 23.6705 24.1988 23.7493 24 23.7493C23.8013 23.7493 23.6106 23.6705 23.47 23.53L20.47 20.53C20.3293 20.3895 20.2502 20.1988 20.25 20V14C20.25 13.8011 20.329 13.6103 20.4697 13.4697C20.6103 13.329 20.8011 13.25 21 13.25C21.1989 13.25 21.3897 13.329 21.5303 13.4697C21.671 13.6103 21.75 13.8011 21.75 14V19.69L24.53 22.47Z"
      fill="#9F6E00"
    />
  </svg>
);

export const IconPaid = ({ style, ...rest }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={typeof style === 'object' ? style : undefined}
    {...rest}
  >
    <rect width="40" height="40" rx="20" fill="#85B5F5" />
    <g clipPath="url(#clip0_22420_293569)">
      <mask
        id="mask0_22420_293569"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="8"
        width="24"
        height="24"
      >
        <path d="M9 8H33V32H9V8Z" fill="white" />
      </mask>
      <g mask="url(#mask0_22420_293569)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.25 26.5C10.25 28.8472 12.1528 30.75 14.5 30.75H28.75C30.4069 30.75 31.75 29.4069 31.75 27.75V21.5C31.75 20.8096 31.1904 20.25 30.5 20.25H27.25V12.4977C27.25 10.7018 25.794 9.25 24 9.25H13.5C11.7051 9.25 10.25 10.7051 10.25 12.5V26.5ZM27.25 27.75V21.75H30.25V27.75C30.25 28.5784 29.5784 29.25 28.75 29.25C27.9216 29.25 27.25 28.5784 27.25 27.75Z"
          fill="#E7F1FD"
        />
        <path
          d="M17.25 13C17.25 12.5858 16.9142 12.25 16.5 12.25C16.0858 12.25 15.75 12.5858 15.75 13V13.2583C14.8868 13.4612 14.25 14.2214 14.25 15.127C14.25 16.094 14.9497 16.9626 15.8865 17.1447L16.8272 17.3277C17.0878 17.3783 17.25 17.5923 17.25 17.8125C17.25 17.9975 17.1133 18.2417 16.8882 18.2855C16.6443 18.3329 16.3925 18.327 16.1514 18.2684C15.9376 18.2165 15.7706 18.1084 15.667 17.907C15.4775 17.5386 15.0253 17.3936 14.657 17.583C14.2628 17.7858 14.1594 18.2553 14.3533 18.6325C14.6357 19.1816 15.1533 19.5695 15.75 19.7145V20C15.75 20.4142 16.0858 20.75 16.5 20.75C16.9142 20.75 17.25 20.4142 17.25 20V19.7417C18.1132 19.5388 18.75 18.7786 18.75 17.873C18.75 16.906 18.0503 16.0374 17.1135 15.8552L16.1728 15.6723C15.9122 15.6217 15.75 15.4077 15.75 15.1875C15.75 15.0025 15.8867 14.7583 16.1118 14.7145C16.3557 14.6671 16.6075 14.673 16.8486 14.7316C17.0623 14.7835 17.2294 14.8916 17.333 15.093C17.5225 15.4614 17.9746 15.6064 18.343 15.417C18.7114 15.2275 18.8564 14.7754 18.667 14.407C18.3781 13.8453 17.864 13.4347 17.25 13.2855V13Z"
          fill="#173660"
        />
        <path
          d="M14.25 23C14.25 22.5858 14.5858 22.25 15 22.25H22.5C22.9142 22.25 23.25 22.5858 23.25 23C23.25 23.4142 22.9142 23.75 22.5 23.75H15C14.5858 23.75 14.25 23.4142 14.25 23Z"
          fill="#173660"
        />
        <path
          d="M15 25.25C14.5858 25.25 14.25 25.5858 14.25 26C14.25 26.4142 14.5858 26.75 15 26.75H19C19.4142 26.75 19.75 26.4142 19.75 26C19.75 25.5858 19.4142 25.25 19 25.25H15Z"
          fill="#173660"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.25 26.5C10.25 28.8472 12.1528 30.75 14.5 30.75H28.75C30.4069 30.75 31.75 29.4069 31.75 27.75V21.5C31.75 20.8096 31.1904 20.25 30.5 20.25H27.25V12.4977C27.25 10.7018 25.794 9.25 24 9.25H13.5C11.7051 9.25 10.25 10.7051 10.25 12.5V26.5ZM13.5 10.75C12.5335 10.75 11.75 11.5335 11.75 12.5V26.5C11.75 28.0188 12.9812 29.25 14.5 29.25H26.1513C25.8961 28.8087 25.75 28.2964 25.75 27.75V12.4977C25.75 11.5321 24.9674 10.75 24 10.75H13.5Z"
          fill="#C4DBFA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.25 26.5C10.25 28.8472 12.1528 30.75 14.5 30.75H28.75C30.4069 30.75 31.75 29.4069 31.75 27.75V21.5C31.75 20.8096 31.1904 20.25 30.5 20.25H27.25V12.4977C27.25 10.7018 25.794 9.25 24 9.25H13.5C11.7051 9.25 10.25 10.7051 10.25 12.5V26.5ZM13.5 10.75C12.5335 10.75 11.75 11.5335 11.75 12.5V26.5C11.75 28.0188 12.9812 29.25 14.5 29.25H26.1513C25.8961 28.8087 25.75 28.2964 25.75 27.75V12.4977C25.75 11.5321 24.9674 10.75 24 10.75H13.5ZM27.25 27.75V21.75H30.25V27.75C30.25 28.5784 29.5784 29.25 28.75 29.25C27.9216 29.25 27.25 28.5784 27.25 27.75Z"
          fill="#173660"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_22420_293569">
        <rect width="24" height="24" fill="white" transform="translate(9 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const NoInternetIcon = () => (
  <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.527 15.2666C9.54655 15.2666 8.74902 16.0642 8.74902 17.0446C8.74902 18.0251 9.54655 18.8225 10.527 18.8225C11.5074 18.8225 12.3049 18.0251 12.3049 17.0446C12.3049 16.0642 11.5074 15.2666 10.527 15.2666Z"
      fill="#FFEEEA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.3276 13.1411C13.2982 12.1545 11.9385 11.6113 10.499 11.6113C8.9988 11.6113 7.54711 12.2249 6.51652 13.2946L6.41113 13.4039L7.76679 14.6592L7.87218 14.5499C8.56221 13.8339 9.49507 13.4396 10.499 13.4396C11.4483 13.4396 12.3451 13.798 13.0241 14.4485L13.1339 14.5538L14.4372 13.246L14.3276 13.1411Z"
      fill="#FF8169"
    />
    <path
      d="M10.5188 7.44444C11.025 7.44446 11.525 7.48515 12.0159 7.56152C12.0622 8.25653 12.2172 8.92137 12.4644 9.53987C11.8365 9.37825 11.1841 9.29384 10.5188 9.29381C8.42576 9.29381 6.4655 10.1141 5.00045 11.6035L4.89429 11.7117L3.56877 10.4169L3.67593 10.3088C5.49305 8.46185 7.92321 7.44444 10.5188 7.44444Z"
      fill="#FF8169"
    />
    <path
      d="M10.2767 3.58398C10.9872 3.58398 11.6891 3.63949 12.3781 3.7467C12.1728 4.32228 12.0461 4.93494 12.011 5.57225C11.4419 5.48762 10.8626 5.44526 10.2767 5.44526C7.16616 5.44528 4.24291 6.65802 2.04582 8.86024L1.93768 8.96938L0.621094 7.65478L0.729238 7.54664C3.27823 4.99166 6.66878 3.58401 10.2767 3.58398Z"
      fill="#FF8169"
    />
    <path
      d="M18.4465 3.52014L21.5738 0.435547H23.3765V2.33254L20.3108 5.36158L23.3765 8.39061V10.2906L21.551 10.2747L18.4455 7.204L15.3232 10.2906L13.5215 10.2757V8.37871L16.5803 5.36058L13.5215 2.33552V0.435547H15.3242L18.4465 3.52014Z"
      fill="white"
    />
  </svg>
);

export const IconError = (props) => (
  <svg
    width={props.size || '120em'}
    height={props.size || '120em'}
    {...props}
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M104.502 98.6512C97.4235 102.179 88.2025 100.773 82.5311 95.2961C78.7 91.5947 76.5569 86.4862 72.9637 82.5684C66.2319 75.2306 54.3484 73.2825 45.6252 78.0661C35.2961 83.7492 28.9879 98.6798 16.3169 99.1706C9.23873 99.4521 2.42029 93.6942 1.51115 86.6812C0.60201 79.6464 5.71045 72.3518 12.6372 70.815C22.8315 68.4937 25.4715 63.6869 15.6027 53.4119C10.5547 48.2093 7.1699 42.3963 12.5073 35.381C17.3823 29.0805 28.0942 26.7443 37.2484 32.3505C52.405 41.6721 39.5507 40.7695 51.7295 23.4759C63.2094 7.01692 76.0637 18.607 84.1115 19.5147C91.6441 20.4023 99.0686 15.6834 106.558 16.9172C118.156 18.8343 122.699 33.3175 114.22 41.5068C108.787 46.7667 100.108 47.0697 94.0682 51.5721C89.1625 55.2384 89.9116 59.8706 94.6527 61.5724C124.794 72.3937 115.92 92.9069 104.502 98.6512Z"
      fill="#F2F4F5"
    />
    <path
      d="M25.1295 6.31245C18.9938 6.41323 16.4866 13.2605 24.1374 18.9113C32.4989 25.0873 38.7061 20.49 38.633 16.1246C38.5671 12.2018 32.7117 6.18799 25.1295 6.31245Z"
      fill="#F2F4F5"
    />
    <path
      opacity="0.4"
      d="M57.648 30.8662C59.584 27.5947 64.3181 27.5947 66.254 30.8662L107.258 100.158C109.231 103.491 106.828 107.704 102.955 107.704H20.9465C17.0735 107.704 14.6711 103.491 16.6435 100.158L57.648 30.8662Z"
      fill="white"
    />
    <path d="M27.667 20.6631L35.2472 22.3199" stroke="#002F34" stroke-width="4" stroke-linecap="round" />
    <path d="M31.3252 6.55176L39.3971 15.3219" stroke="#002F34" stroke-width="4" stroke-linecap="round" />
    <path d="M44.7588 5.31934L46.2408 10.8944" stroke="#002F34" stroke-width="4" stroke-linecap="round" />
    <path
      d="M69.0446 99.645C69.1598 102.433 66.9934 104.786 64.2058 104.901C61.4182 105.016 59.065 102.85 58.9498 100.062C58.8346 97.2745 61.001 94.9214 63.7886 94.8062C66.5762 94.691 68.9294 96.8574 69.0446 99.645Z"
      fill="#3A77FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.8561 55.3056C64.624 55.1912 66.9603 57.3423 67.0746 60.11L67.903 80.1556C68.0173 82.9234 65.8664 85.2598 63.0986 85.3741C60.3308 85.4885 57.9945 83.3376 57.8801 80.5698L57.0518 60.5241C56.9374 57.7564 59.0883 55.42 61.8561 55.3056Z"
      fill="#3A77FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.8352 54.3065C64.603 54.1922 66.9393 56.3432 67.0537 59.1109L67.4747 70.8646L57.5979 74.4255L57.0308 59.525C56.9165 56.7573 59.0674 54.4209 61.8352 54.3065Z"
      fill="#6C99FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.8904 52.9431C65.0586 52.8122 67.7329 55.2743 67.8638 58.4424L68.812 81.3878C68.9429 84.556 66.4808 87.2303 63.3127 87.3612C60.1445 87.4921 57.4702 85.03 57.3393 81.8619L56.3911 58.9165C56.2602 55.7484 58.7223 53.074 61.8904 52.9431ZM69.5102 100.912C69.6412 104.08 67.1791 106.754 64.0109 106.885C60.8427 107.016 58.1685 104.554 58.0375 101.386C57.9066 98.2178 60.3687 95.5435 63.5369 95.4126C66.705 95.2817 69.3793 97.7437 69.5102 100.912Z"
      stroke="#002F34"
      stroke-width="4"
    />
    <path
      d="M65.1559 34.3568C63.2827 31.1075 58.5614 31.2026 56.8205 34.5248L21.9148 101.133C20.2351 104.338 22.1488 107.8 26.2246 108.097C26.2246 108.097 37.28 108.226 44.3411 108.732C45.8128 108.838 47.6249 108.997 49.2406 109.147C51.6163 109.367 53.4355 111.343 53.4835 113.728C53.5406 116.563 51.1038 118.808 48.2794 118.555C46.9918 118.439 45.662 118.327 44.5327 118.245C37.4716 117.739 26.4163 117.61 26.4163 117.61C15.1017 116.438 8.44796 106.332 13.4869 96.7162L48.3925 30.1082C53.6152 20.1418 67.7793 19.8564 73.399 29.6044L110.959 94.7524C116.382 104.157 109.736 115.932 98.8822 116.151L82.7657 116.516L80.4906 116.574C77.8534 116.643 75.6643 114.552 75.6111 111.914C75.5584 109.298 77.6286 107.13 80.2446 107.063L82.5741 107.002L98.6906 106.637C102.308 106.565 104.523 102.64 102.716 99.5047L65.1559 34.3568Z"
      fill="#002F34"
    />
    <path
      d="M92.618 11.4353C94.1977 8.61329 93.1907 5.04494 90.3686 3.46517C87.5466 1.88541 83.9783 2.89246 82.3985 5.71449C80.8187 8.53651 81.8258 12.1049 84.6478 13.6846C87.4698 15.2644 91.0382 14.2573 92.618 11.4353Z"
      fill="#F2F4F5"
    />
  </svg>
);

export const NetAmountIcon = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08333 12.8332C3.7625 12.8332 3.48784 12.7189 3.25937 12.4905C3.0309 12.262 2.91666 11.9873 2.91666 11.6665C2.91666 11.3457 3.0309 11.071 3.25937 10.8425C3.48784 10.6141 3.7625 10.4998 4.08333 10.4998C4.40416 10.4998 4.67881 10.6141 4.90729 10.8425C5.13576 11.071 5.24999 11.3457 5.24999 11.6665C5.24999 11.9873 5.13576 12.262 4.90729 12.4905C4.67881 12.7189 4.40416 12.8332 4.08333 12.8332ZM9.91666 12.8332C9.59583 12.8332 9.32118 12.7189 9.0927 12.4905C8.86423 12.262 8.75 11.9873 8.75 11.6665C8.75 11.3457 8.86423 11.071 9.0927 10.8425C9.32118 10.6141 9.59583 10.4998 9.91666 10.4998C10.2375 10.4998 10.5121 10.6141 10.7406 10.8425C10.9691 11.071 11.0833 11.3457 11.0833 11.6665C11.0833 11.9873 10.9691 12.262 10.7406 12.4905C10.5121 12.7189 10.2375 12.8332 9.91666 12.8332ZM3.03333 2.33317H11.6375C11.8611 2.33317 12.0312 2.43282 12.1479 2.63213C12.2646 2.83143 12.2694 3.03317 12.1625 3.23734L10.0917 6.97067C9.98472 7.16511 9.84131 7.31581 9.66145 7.42275C9.48159 7.5297 9.28472 7.58317 9.07083 7.58317H4.725L4.08333 8.74984H11.0833V9.9165H4.08333C3.64583 9.9165 3.31527 9.72449 3.09166 9.34046C2.86805 8.95643 2.85833 8.57484 3.06249 8.19567L3.84999 6.7665L1.74999 2.33317H0.583328V1.1665H2.47916L3.03333 2.33317Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);

export const ClockArrowIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_26761_457430)">
      <path
        d="M25.0692 20.8185C24.5845 20.458 23.8994 20.5587 23.5388 21.0433C23.3405 21.3098 23.1283 21.5713 22.9081 21.8204C22.508 22.2729 22.5505 22.9642 23.0031 23.3642C23.2112 23.5482 23.4696 23.6386 23.7271 23.6386C24.0296 23.6386 24.3308 23.5137 24.547 23.2692C24.8078 22.9742 25.0591 22.6646 25.2939 22.3489C25.6544 21.8643 25.5539 21.179 25.0692 20.8185Z"
        fill={props?.color ?? '#3A77FF'}
      />
      <path
        d="M26.8984 15.6891C26.3086 15.5606 25.7255 15.9349 25.5971 16.5251C25.5264 16.8498 25.4409 17.1751 25.343 17.4921C25.1647 18.0692 25.488 18.6816 26.0651 18.86C26.1727 18.8932 26.2814 18.909 26.3883 18.909C26.8554 18.909 27.2878 18.6074 27.433 18.1378C27.5492 17.7616 27.6506 17.3756 27.7345 16.9904C27.863 16.4002 27.4887 15.8176 26.8984 15.6891Z"
        fill={props?.color ?? '#3A77FF'}
      />
      <path
        d="M19.8041 24.3214C19.5137 24.4835 19.213 24.635 18.9105 24.7717C18.3599 25.0203 18.1152 25.6681 18.3638 26.2187C18.5465 26.6231 18.9445 26.8625 19.3612 26.8625C19.5117 26.8625 19.6647 26.8313 19.8108 26.7653C20.1697 26.6032 20.5261 26.4236 20.8705 26.2313C21.3979 25.9369 21.5868 25.2706 21.2922 24.7432C20.9978 24.2158 20.3315 24.027 19.8041 24.3214Z"
        fill={props?.color ?? '#3A77FF'}
      />
      <path
        d="M12.9063 5.25V13.547L8.89553 17.5576C8.46842 17.9848 8.46842 18.6773 8.89553 19.1044C9.10914 19.318 9.38897 19.4248 9.66897 19.4248C9.94886 19.4248 10.2288 19.318 10.4424 19.1044L14.7734 14.7734C14.9785 14.5683 15.0938 14.2901 15.0938 14V5.25C15.0938 4.64592 14.6041 4.15625 14 4.15625C13.3959 4.15625 12.9063 4.64592 12.9063 5.25Z"
        fill={props?.color ?? '#3A77FF'}
      />
      <path
        d="M26.9062 2.35156C26.3022 2.35156 25.8125 2.84123 25.8125 3.44531V6.48244C23.2667 2.48981 18.8208 0 14 0C10.2605 0 6.74477 1.45627 4.10047 4.10047C1.45627 6.74477 0 10.2605 0 14C0 17.7395 1.45627 21.2552 4.10047 23.8995C6.74477 26.5437 10.2605 28 14 28C14.0092 28 14.0182 27.9989 14.0273 27.9986C14.0365 27.9989 14.0454 28 14.0547 28C14.4489 28 14.8469 27.9834 15.238 27.9507C15.8399 27.9002 16.287 27.3714 16.2367 26.7695C16.1862 26.1675 15.6581 25.7202 15.0554 25.7708C14.7249 25.7984 14.3882 25.8125 14.0547 25.8125C14.0454 25.8125 14.0365 25.8136 14.0273 25.8139C14.0182 25.8136 14.0092 25.8125 14 25.8125C7.48656 25.8125 2.1875 20.5134 2.1875 14C2.1875 7.48656 7.48656 2.1875 14 2.1875C18.1977 2.1875 22.0586 4.42493 24.1684 7.98438H21.1609C20.5569 7.98438 20.0672 8.47405 20.0672 9.07812C20.0672 9.6822 20.5569 10.1719 21.1609 10.1719H24.5C25.1661 10.1719 25.7893 9.98468 26.3198 9.66038C26.354 9.64091 26.3868 9.61997 26.4181 9.59738C27.3699 8.97116 28 7.89398 28 6.67188V3.44531C28 2.84123 27.5103 2.35156 26.9062 2.35156Z"
        fill={props?.color ?? '#3A77FF'}
      />
    </g>
    <defs>
      <clipPath id="clip0_26761_457430">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationActiveIcon = (props) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.9397 12.5416C25.4567 12.5416 25.0647 12.1496 25.0647 11.6666C25.0647 8.31592 23.7605 5.16711 21.3921 2.79761C21.0503 2.45581 21.0503 1.90167 21.3921 1.55988C21.7339 1.21808 22.288 1.21808 22.63 1.55988C25.3285 4.25943 26.8147 7.84937 26.8147 11.6666C26.8147 12.1496 26.4227 12.5416 25.9397 12.5416Z"
      fill="#D02C0D"
    />
    <path
      d="M2.02344 12.5416C1.54044 12.5416 1.14844 12.1496 1.14844 11.6666C1.14844 7.84933 2.63483 4.2594 5.33438 1.56091C5.67618 1.21912 6.23053 1.21912 6.57233 1.56091C6.91412 1.90271 6.91412 2.45706 6.57233 2.79886C4.20282 5.16708 2.89844 8.31589 2.89844 11.6666C2.89844 12.1496 2.50644 12.5416 2.02344 12.5416Z"
      fill="#D02C0D"
    />
    <path
      d="M13.9814 28C11.5688 28 9.60645 26.0377 9.60645 23.625C9.60645 23.142 9.99844 22.75 10.4814 22.75C10.9644 22.75 11.3564 23.142 11.3564 23.625C11.3564 25.0729 12.5335 26.25 13.9814 26.25C15.4292 26.25 16.6064 25.0729 16.6064 23.625C16.6064 23.142 16.9984 22.75 17.4814 22.75C17.9644 22.75 18.3564 23.142 18.3564 23.625C18.3564 26.0377 16.3941 28 13.9814 28Z"
      fill="#D02C0D"
    />
    <path
      d="M23.6072 24.5H4.35724C3.23123 24.5 2.31543 23.5842 2.31543 22.4584C2.31543 21.8609 2.57562 21.2952 3.02957 20.9066C4.80392 19.4074 5.81543 17.2283 5.81543 14.9194V11.6666C5.81543 7.16342 9.47885 3.5 13.9822 3.5C18.4854 3.5 22.1488 7.16342 22.1488 11.6666V14.9194C22.1488 17.2283 23.1603 19.4074 24.9232 20.8985C25.3886 21.2952 25.6488 21.8609 25.6488 22.4584C25.6488 23.5842 24.733 24.5 23.6072 24.5ZM13.9822 5.25C10.4436 5.25 7.56543 8.12814 7.56543 11.6666V14.9194C7.56543 17.7437 6.3277 20.4108 4.17053 22.2343C4.12973 22.2693 4.06543 22.3418 4.06543 22.4584C4.06543 22.6169 4.19852 22.75 4.35724 22.75H23.6072C23.7657 22.75 23.8988 22.6169 23.8988 22.4584C23.8988 22.3418 23.8347 22.2693 23.7961 22.2367C21.6366 20.4108 20.3988 17.7437 20.3988 14.9194V11.6666C20.3988 8.12814 17.5207 5.25 13.9822 5.25Z"
      fill="#D02C0D"
    />
    <path
      d="M13.9814 5.25C13.4984 5.25 13.1064 4.858 13.1064 4.375V0.875C13.1064 0.391998 13.4984 0 13.9814 0C14.4644 0 14.8564 0.391998 14.8564 0.875V4.375C14.8564 4.858 14.4644 5.25 13.9814 5.25Z"
      fill="#D02C0D"
    />
  </svg>
);

export const FeePrecentIcon = (props) => (
  <svg
    width={props.size || '1em'}
    height={props.size || '1em'}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.54274 8.49556C9.54274 8.58431 9.51642 8.67107 9.46711 8.74486C9.41781 8.81865 9.34773 8.87616 9.26574 8.91012C9.18374 8.94409 9.09352 8.95297 9.00648 8.93566C8.91944 8.91834 8.83948 8.87561 8.77673 8.81285C8.71397 8.7501 8.67124 8.67015 8.65392 8.5831C8.63661 8.49606 8.6455 8.40584 8.67946 8.32385C8.71342 8.24185 8.77093 8.17177 8.84472 8.12247C8.91852 8.07316 9.00527 8.04684 9.09402 8.04684C9.21254 8.04839 9.32578 8.09617 9.4096 8.17998C9.49341 8.2638 9.54119 8.37704 9.54274 8.49556ZM5.3547 5.50411C5.3547 5.41536 5.32839 5.32861 5.27908 5.25482C5.22977 5.18102 5.15969 5.12351 5.0777 5.08955C4.99571 5.05559 4.90549 5.0467 4.81844 5.06401C4.7314 5.08133 4.65145 5.12406 4.58869 5.18682C4.52594 5.24957 4.4832 5.32953 4.46589 5.41657C4.44858 5.50361 4.45746 5.59383 4.49142 5.67583C4.52539 5.75782 4.5829 5.8279 4.65669 5.87721C4.73048 5.92651 4.81724 5.95283 4.90599 5.95283C5.02451 5.95128 5.13775 5.90351 5.22156 5.81969C5.30538 5.73587 5.35315 5.62264 5.3547 5.50411ZM12.8333 6.99984C12.8333 8.15356 12.4912 9.28138 11.8502 10.2407C11.2093 11.1999 10.2982 11.9476 9.23232 12.3891C8.16642 12.8306 6.99353 12.9462 5.86197 12.7211C4.73042 12.496 3.69102 11.9404 2.87521 11.1246C2.05941 10.3088 1.50384 9.26942 1.27876 8.13786C1.05368 7.00631 1.16919 5.83342 1.61071 4.76752C2.05222 3.70161 2.79989 2.79057 3.75918 2.1496C4.71846 1.50862 5.84628 1.1665 7 1.1665C8.54661 1.16809 10.0294 1.78318 11.123 2.8768C12.2167 3.97042 12.8318 5.45323 12.8333 6.99984ZM4.90599 6.85026C5.17223 6.85026 5.43249 6.77131 5.65387 6.6234C5.87524 6.47548 6.04778 6.26524 6.14967 6.01926C6.25156 5.77328 6.27821 5.50262 6.22627 5.24149C6.17433 4.98036 6.04612 4.7405 5.85786 4.55224C5.6696 4.36397 5.42974 4.23576 5.16861 4.18382C4.90748 4.13188 4.63681 4.15854 4.39083 4.26043C4.14486 4.36231 3.93462 4.53485 3.7867 4.75623C3.63878 4.9776 3.55983 5.23787 3.55983 5.50411C3.55983 5.86113 3.70166 6.20353 3.95411 6.45598C4.20656 6.70844 4.54896 6.85026 4.90599 6.85026ZM9.15385 4.8759C9.1892 4.82876 9.21493 4.77512 9.22955 4.71804C9.24418 4.66095 9.24742 4.60155 9.23908 4.54322C9.23075 4.48488 9.21101 4.42876 9.18098 4.37806C9.15096 4.32735 9.11125 4.28306 9.0641 4.2477C9.01696 4.21234 8.96332 4.18662 8.90624 4.172C8.84915 4.15737 8.78975 4.15413 8.73142 4.16247C8.67308 4.1708 8.61696 4.19054 8.56625 4.22056C8.51555 4.25059 8.47126 4.2903 8.4359 4.33744L4.84616 9.12377C4.77475 9.21897 4.74409 9.33865 4.76092 9.45646C4.77775 9.57427 4.84069 9.68057 4.9359 9.75197C5.02885 9.81433 5.14175 9.83969 5.25244 9.82309C5.36314 9.80649 5.46362 9.74911 5.53419 9.66223L9.15385 4.8759ZM10.4402 8.49556C10.4402 8.22932 10.3612 7.96905 10.2133 7.74768C10.0654 7.52631 9.85515 7.35377 9.60917 7.25188C9.36319 7.14999 9.09253 7.12333 8.8314 7.17527C8.57027 7.22722 8.33041 7.35543 8.14214 7.54369C7.95388 7.73195 7.82567 7.97181 7.77373 8.23294C7.72179 8.49407 7.74845 8.76474 7.85034 9.01071C7.95222 9.25669 8.12476 9.46693 8.34614 9.61485C8.56751 9.76277 8.82777 9.84172 9.09402 9.84172C9.45104 9.84172 9.79344 9.69989 10.0459 9.44744C10.2983 9.19498 10.4402 8.85258 10.4402 8.49556Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);

export const FeePercentOutlineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.size ?? '24'}
    height={props?.size ?? '24'}
    viewBox="0 0 24 24"
    fill="none"
    stroke={props?.color ?? 'currentColor'}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-badge-percent-icon lucide-badge-percent"
  >
    <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
    <path d="m15 9-6 6" />
    <path d="M9 9h.01" />
    <path d="M15 15h.01" />
  </svg>
);

export const NoChatIcon = (props) => (
  <svg width="101" height="103" viewBox="0 0 101 103" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M91.9536 21.7275C95.4585 21.7275 98.2997 18.8862 98.2997 15.3813C98.2997 11.8764 95.4585 9.03516 91.9536 9.03516C88.4487 9.03516 85.6074 11.8764 85.6074 15.3813C85.6074 18.8862 88.4487 21.7275 91.9536 21.7275Z"
      fill="#F6F6F6"
    />
    <path
      d="M89.6448 101.342C90.6007 101.342 91.3756 100.568 91.3756 99.6116C91.3756 98.6558 90.6007 97.8809 89.6448 97.8809C88.689 97.8809 87.9141 98.6558 87.9141 99.6116C87.9141 100.568 88.689 101.342 89.6448 101.342Z"
      fill="#BDBEBF"
    />
    <path
      d="M72.3382 11.3424C73.2941 11.3424 74.069 10.5675 74.069 9.61163C74.069 8.65575 73.2941 7.88086 72.3382 7.88086C71.3823 7.88086 70.6074 8.65575 70.6074 9.61163C70.6074 10.5675 71.3823 11.3424 72.3382 11.3424Z"
      fill="#BDBEBF"
    />
    <path
      d="M73.146 39.0352V66.8036C73.146 69.949 70.5983 72.4967 67.453 72.4967C64.0895 72.4967 40.2337 72.4967 35.9922 72.4967L19.8383 85.189V72.4967H11.6853C8.53988 72.4967 5.99219 69.949 5.99219 66.8036C5.99219 63.001 5.99219 33.5521 5.99219 29.7282C5.99219 26.5828 8.53988 24.0352 11.6853 24.0352H67.453C70.5983 24.0352 73.146 26.5828 73.146 29.7282V39.0352Z"
      fill="#EDEEEE"
    />
    <path
      d="M39.6852 3.26855C51.1568 3.26855 60.4545 12.5662 60.4545 24.0378C60.4545 35.5093 51.1568 44.807 39.6852 44.807C28.2137 44.807 18.916 35.5093 18.916 24.0378C18.916 12.5662 28.2137 3.26855 39.6852 3.26855Z"
      fill="#F6F6F6"
    />
    <path
      d="M44.8278 15.2059C45.6631 14.5018 46.9122 14.5015 47.8077 15.2059L47.9932 15.3676L48.163 15.5457C48.9057 16.4086 48.9594 17.6545 48.2904 18.5175L48.1358 18.6955L34.7901 32.6005C33.9489 33.4769 32.5547 33.5155 31.5963 32.7285L31.4106 32.561C30.4864 31.6359 30.4417 30.1753 31.3093 29.2715L44.655 15.3665L44.8278 15.2059Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="1.36364"
    />
    <path
      d="M28.4925 97.8785C29.4484 97.8785 30.2233 97.1036 30.2233 96.1478C30.2233 95.1919 29.4484 94.417 28.4925 94.417C27.5366 94.417 26.7617 95.1919 26.7617 96.1478C26.7617 97.1036 27.5366 97.8785 28.4925 97.8785Z"
      fill="#BDBEBF"
    />
    <path
      d="M7.14663 88.6523C9.69663 88.6523 11.762 90.7177 11.762 93.2677C11.762 95.8177 9.69663 97.8831 7.14663 97.8831C4.59663 97.8831 2.53125 95.8177 2.53125 93.2677C2.53125 90.7177 4.59663 88.6523 7.14663 88.6523Z"
      fill="#F6F6F6"
    />
    <path
      d="M5.99249 14.6754C6.94837 14.6754 7.72326 13.9005 7.72326 12.9446C7.72326 11.9888 6.94837 11.2139 5.99249 11.2139C5.03661 11.2139 4.26172 11.9888 4.26172 12.9446C4.26172 13.9005 5.03661 14.6754 5.99249 14.6754Z"
      fill="#BDBEBF"
    />
    <path
      d="M76.8392 101.346C76.5851 101.346 76.3333 101.263 76.1261 101.1L60.2859 88.654H39.6851C39.0479 88.654 38.5312 88.1375 38.5312 87.5001C38.5312 86.8628 39.0479 86.3463 39.6851 86.3463H60.6851C60.9436 86.3463 61.1946 86.4331 61.3979 86.5928L75.6851 97.8185V87.5001C75.6851 86.8628 76.2016 86.3463 76.8389 86.3463H84.992C87.4949 86.3463 89.5312 84.31 89.5312 81.8071V44.7317C89.5312 42.2288 87.4949 40.1925 84.992 40.1925H73.1466C72.5092 40.1925 71.9928 39.6758 71.9928 39.0386C71.9928 38.4015 72.5092 37.8848 73.1466 37.8848H84.992C88.7674 37.8848 91.8389 40.9563 91.8389 44.7317V81.8071C91.8389 85.5825 88.7674 88.654 84.992 88.654H77.9928V100.192C77.9928 100.634 77.7406 101.037 77.3432 101.23C77.183 101.308 77.0106 101.346 76.8392 101.346Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="2.72727"
    />
    <path
      d="M19.8396 86.3404C19.6679 86.3404 19.4955 86.3021 19.3354 86.2244C18.938 86.0312 18.686 85.6283 18.686 85.1866V73.6481H11.6868C7.91138 73.6481 4.83984 70.5766 4.83984 66.8012V29.7258C4.83984 25.9504 7.91138 22.8789 11.6868 22.8789H18.9168C19.5539 22.8789 20.0706 23.3956 20.0706 24.0328C20.0706 24.6699 19.5539 25.1866 18.9168 25.1866H11.6868C9.18384 25.1866 7.14754 27.2229 7.14754 29.7258V66.8012C7.14754 69.3041 9.18384 71.3404 11.6868 71.3404H19.8398C20.477 71.3404 20.9937 71.8569 20.9937 72.4943V82.8127L35.2808 71.5869C35.4842 71.4272 35.7352 71.3404 35.9937 71.3404H67.4545C69.9574 71.3404 71.9937 69.3041 71.9937 66.8012V29.7258C71.9937 27.2229 69.9574 25.1866 67.4545 25.1866H60.4552C59.8178 25.1866 59.3014 24.6699 59.3014 24.0328C59.3014 23.3956 59.8178 22.8789 60.4552 22.8789H67.4545C71.2298 22.8789 74.3014 25.9504 74.3014 29.7258V66.8012C74.3014 70.5766 71.2298 73.6481 67.4545 73.6481H36.3927L20.5525 86.094C20.3455 86.2569 20.0937 86.3404 19.8396 86.3404Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="2.72727"
    />
    <path
      d="M39.6848 45.9594C27.5964 45.9594 17.7617 36.1247 17.7617 24.0364C17.7617 11.948 27.5964 2.11328 39.6848 2.11328C51.7732 2.11328 61.6079 11.948 61.6079 24.0364C61.6079 36.1247 51.7732 45.9594 39.6848 45.9594ZM39.6848 4.42097C28.8689 4.42097 20.0694 13.2204 20.0694 24.0364C20.0694 34.8523 28.8689 43.6517 39.6848 43.6517C50.5007 43.6517 59.3002 34.8523 59.3002 24.0364C59.3002 13.2204 50.5007 4.42097 39.6848 4.42097Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="2.72727"
    />
    <path
      d="M91.9551 22.8789C87.8195 22.8789 84.4551 19.5143 84.4551 15.3789C84.4551 11.2435 87.8195 7.87891 91.9551 7.87891C96.0907 7.87891 99.4551 11.2435 99.4551 15.3789C99.4551 19.5143 96.0907 22.8789 91.9551 22.8789ZM91.9551 10.1866C89.0922 10.1866 86.7628 12.5158 86.7628 15.3789C86.7628 18.2421 89.0922 20.5712 91.9551 20.5712C94.818 20.5712 97.1474 18.2421 97.1474 15.3789C97.1474 12.5158 94.818 10.1866 91.9551 10.1866Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="1.62272"
    />
    <path
      d="M7.14618 99.0346C3.96503 99.0346 1.37695 96.4465 1.37695 93.2653C1.37695 90.0842 3.96503 87.4961 7.14618 87.4961C10.3273 87.4961 12.9154 90.0842 12.9154 93.2653C12.9154 96.4465 10.3273 99.0346 7.14618 99.0346ZM7.14618 89.8038C5.23749 89.8038 3.68465 91.3564 3.68465 93.2653C3.68465 95.1742 5.23749 96.7269 7.14618 96.7269C9.05488 96.7269 10.6077 95.1742 10.6077 93.2653C10.6077 91.3564 9.05488 89.8038 7.14618 89.8038Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="1.62272"
    />
    <path
      d="M42.9141 55.2569H14.0679C13.4308 55.2569 12.9141 54.7404 12.9141 54.1031C12.9141 53.4657 13.4308 52.9492 14.0679 52.9492H42.9141C43.5512 52.9492 44.0679 53.4657 44.0679 54.1031C44.0679 54.7404 43.5512 55.2569 42.9141 55.2569Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="1.62272"
    />
    <path
      d="M56.7602 63.3311H14.0679C13.4308 63.3311 12.9141 62.8147 12.9141 62.1773C12.9141 61.5399 13.4308 61.0234 14.0679 61.0234H56.7602C57.3976 61.0234 57.9141 61.5399 57.9141 62.1773C57.9141 62.8147 57.3976 63.3311 56.7602 63.3311Z"
      fill="#BDBEBF"
      stroke="#BDBEBF"
      stroke-width="1.62272"
    />
  </svg>
);
